// HU
const locale = {
    MENU: {
        DASHBOARD: "Irányítópult",
        CREATE_REQUEST_BUTTON: "Kérelem létrehozása",
        SEARCH_BUTTON: "Részletes keresés",
        RESPONSE_TEMPLATES: "Válaszsablonok",
        TRANSLATIONS: "Fordítások",
        TRANSLATIONS_GLOSSARY: "Fordítási szószedet",
        TRANSLATIONS_DASHBOARD: "Fordítási irányítópult",
        TAX_CATEGORY: "Díjkategóriák",
        COMPLAIN_TYPE: "Bejelentéstípusok",
        ORGANIZATION: "Szervezetek kezelése",
        MY_ORGANIZATION: "Szervezet kezelése",
        ACCOUNTS: "Másodlagos fiókok",
        BENEFICIARIES: "Kedvezményezettek",
        MY_APPLICATIONS: "Kérelmeim",
        DRAFT: "Piszkozat",
        SUBMITTED: "Benyújtott",
        SIGN_PENDING: "Aláírandó",
        TO_CLARIFY: "Tisztázandó",
        FINALIZED: "Lezárt",
        STAFF_APPLICATIONS: "Kérelemnyilvántartás",
        NOTIFICATIONS: "Üzenetek és értesítések",
        RESPONSIBILITIES: "Felelősségi körök jegyzéke",
        MY_COMPLAINS: "Bejelentéseim",
        STAFF_COMPLAINS: "Bejelentések nyilvántartása",
        PAYMENTS: "Fizetési nyilvántartás",
        DOCUMENTS: "Kiállított iratok",
        EXTERNAL_APPS: "Alkalmazások",
        ATLAS: "Területi Atlasz",
        EFACTURA: "e-Factura",
        ARCHIVE: "Archívum",
        HELP: "Súgó",
        MANUAL: "Felhasználói kézikönyv",
        FAQ: "Gyakori kérdések",
        ADMINISTRATOR: {
            HEADER: "Adminisztrátor",
            MANAGE: "Kezelés",
            FUNCTIONARY: "Ügyintéző",
        },
        DOCUMENT_TEMPLATE: "Dokumentumsablonok",
        FORMS: "Űrlapfelületek",
        APPLICATION_TYPE: "Kérelemtípusok",
        PROCESS_MANAGEMENT: "Folyamatkezelés",
        PERMISSIONS: "Jogosultságok",
        METADATA_MAPPING: "Metaadat-leképezés",
        GU: "Ghișeul Unic",
        STAFF_OWN_APPLICATIONS: "Aláírandó (iratok)",
        STAFF_OWN_CLARIFICATIONS: "Aláírandó (tisztázások)",
        STAFF_REVIEW_APPLICATIONS: "Felülvizsgálandó",
        DECISION_TARGET: "Határozatok helyszínei",
        DECISION_PURPOSE: "Határozatok céljai",
        DOCUMENT_SERIES_TYPE: "Sorozattípusok",
        REGISTERS_TYPE: "Regiszter típusok",
        REGISTERS: "Regiszterek",
        SPECIAL_REGISTERS: "Speciális regiszterek",
        PAYMENT_REGISTRY: "Fizetési nyilvántartás",
        REAL_ESTATE_REGISTER: "Telekkönyvi adatok",
        ISSUED_DOCUMENT: "Kiállított iratok",
        ISSUED_DOCUMENT_STAFF: "Kiállított iratok nyilvántartása",
        CONTROLS: "Ellenőrzési nyilvántartás",
        ORGANISATION_CONFIG: "Szervezeti konfiguráció",
        SYSTEM_CONFIG: "Rendszerkonfiguráció",
        TRANSLATIONS_SECTION: "Fordítások",
        INTERNAL_DOCUMENTS: "Dokumentumnyilvántartás",
        DOCUMENT_SERIES_ALLOCATION: "Foglalások nyilvántartása",
        USEFUL_LINKS: "Hasznos linkek",
        APPLICATIONS_DETAILS: "Alkalmazások részletei",
        CONTROL_TYPE: "Ellenőrzéstípusok",
        STAFF_SIGN_INTERNAL_DOCUMENTS: "Aláírandó",
        STAFF_TO_REVIEW_DOCUMENTS: "Felülvizsgálandó",
        DASHBOARD_REPORTS: "Jelentések",
        PURPOSE_LIST: "Határozatok céljai",
        TARGET_LIST: "Határozatok helyszínei",
        SYSTEM_SETTINGS: "Rendszerbeállítások",
        INBOX: "Beérkezett",
        IN_WORK: "Folyamatban",
        NEW: "Új",
        COMPLETED: "Lezárt",
        WITH_ERRORS: "Hibák",
        REGISTRY: "Iktató",
        GENERAL_REGISTRY: "Általános iktató",
        REGISTRY_ADD: "Hozzáadás",
    },
    GENERAL: {
        YES: "Igen",
        NO: "Nem",
        CLOSE: "Bezárás",
        NEXT: "Tovább",
        PREV: "Vissza",
        STATUS: "Állapot",
        ACTIVE: "Aktív",
        INACTIVE: "Inaktív",
        CHECK: "Ellenőrzés",
        LOADING: "Betöltés...",
        EXTEND: "Kibontás",
        NOT_AVAILABLE: "Nem elérhető",
        PREVIEW: "Előnézet",
        GIS_INTERSECTIONS: "GIS-metszetek",
        GIS_INTERSECTIONS_METADATAS: "GIS-metszetek metaadatai",
        GIS_INTERSECTIONS_RESULTS: "GIS-metszetek eredményei",
        CONTINUE_NAVIGATION_BUTTON: "Folytatás mentés nélkül",
        LINE_SPACING: {
            SINGLE: "Szimpla",
            DOUBLE: "Dupla",
        },
        BUTTON: {
            ADD: "Hozzáadás",
            CANCEL: "Mégse",
            SAVE: "Mentés",
            UPDATE: "Szerkesztés",
            CONFIRM: "Megerősítés",
            ERASE: "Törlés",
            MORE_FILTERS: "További szűrők",
            OK: "OK",
            SEND_CODE: "Kód küldése",
            SEND: "Küldés",
            SENDING: "Küldés folyamatban...",
            CONTINUE: "Folytatás",
            PUBLISH: "Közzététel",
            UPLOAD_FILE: "Fájl kiválasztása",
            COMPLETE: "Kitöltés",
            UPLOAD_MAX_FILE_SIZE: "Dokumentumok feltöltése (max. {0} MB/dokumentum)",
            DOWNLOAD: "Letöltés",
            EXTRACT: "Kijelölés kinyerése",
            SEARCH: "Keresés",
            DIGITALIZE: "Kérelem digitalizálása",
            VIEW: "Megtekintés",
            VIEW_DOC: "Dokumentum megtekintése",
            DELETE_FILES: "Dokumentumok törlése ",
            GO_TO_APPLICATION: "Ugrás a kérelemhez",
            REFRESH: "Frissítés",
        },
        ACTIONS: {
            EDIT: "Szerkesztés",
            DELETE: "Törlés",
            DELETE_MESSAGE: "Biztos folytatja a törlést?",
            VIEW: "Megtekintés",
            DOWNLOAD: "Letöltés",
            DOWNLOAD_ALL: "Összes letöltése",
            SIGN: "Aláírás",
            VIEW_ORIGINAL: "Dokumentum megtekintése",
            VIEW_STATUS: "Aláírási állapot megtekintése",
            DO_UPDATE: "Frissítés",
            GO_TO_LINK: "Ugrás az intézmény oldalára",
            COPY: "Másolás",
            SELECT_ALL: "Összes kijelölése",
            UN_SELECT_ALL: "Kijelölés megszüntetése",
            REMOVE_SELECTION: "Kijelölés eltávolítása",
            SEND_EMAIL: "E-mail küldése",
            VIEW_QR: "Iktatási bizonylat nyomtatása",
            CLONE: "Klónozás",
            FILTER_PROJECT_IDS: "Szűrés Project ID szerint",
            LOGS: "Előzmények",
        },
        DATEPICKER: {
            FROM_DATE: "Dátumtól",
            TO_DATE: "Dátumig",
            SELECT_DATE: "Válasszon",
            INVALID_DATE: "A megadott dátum érvénytelen",
            HELP: "A naptár dátumai között a kurzorbillentyűkkel navigálhat",
        },
        PAGINATION: "Megjelenített találatok: {start}–{end}",
        CREATED_SUCCESS: "Sikeres mentés.",
        UPDATED_SUCCESS: "Sikeres mentés.",
        PUBLISHED_SUCCESS: "Sikeres közzététel.",
        PUBLISHED_FAILED: "Hiba történt a réteg közzététele során, kérjük, próbálja újra",
        REMOVE_SUCCESS: "Sikeres törlés.",
        SELECT_PLACEHOLDER: "Válasszon",
        EXPIRED_SESSION: "A munkamenet lejárt",
        TABLE: {
            ACTIONS: "Műveletek",
            COLUMN_SELECTOR_TITLE: "Válassza ki a látható oszlopokat",
            SELECT_ALL_COLUMNS: "Összes kijelölése",
            FILTER_SELECTOR_TITLE: "Válassza ki a látható szűrőket",
            SELECT_ALL_FILTERS: "Összes kijelölése",
            APPLY: "Alkalmazás",
            RESET_WIDTHS: "Szélességek visszaállítása",
            CANCEL: "Mégse",
            RECOMMENDED_SELECTION_TITLE: "Nagy kijelölés",
            RECOMMENDED_SELECTION_TEXT: "{selected} elemet választott ki. Több mint {recommended} elem kijelölése csökkentheti a teljesítményt. Legfeljebb {max} elem választható ki.",
            MAX_SELECTION_TITLE: "Elérte a maximális kijelölést",
            MAX_SELECTION_TEXT: "Legfeljebb {max} elem választható ki. Az első {max} konfigurált elem lett kijelölve.",
        },
        TABLE_ACTIONS_COLUMN: "Műveletek",
        TABLE_EMPTY_TEXT: "Nincs megjeleníthető bejegyzés",
        DAYS: "nap | nap | nap",
        AUTOCOMPLETE_NO_OPTIONS: "Nincs megfelelő találat",
        AUTOCOMPLETE_LOAD_MORE: "További lehetőségek betöltése...",
        DUAL_LIST_BOX: {
            SEARCH_PLACEHOLDER: "Keresés",
            SEARCH_RESULTS: "Nincs találat.",
            CLEAR_SEARCH: "Keresés törlése",
        },
        CLICK_HERE: "kattintson ide",
        CITIZEN: "Állampolgár",
        STAFF: "Ügyintéző",
        SIGN: "Aláírás",
        SYSTEM: "Rendszer",
        ORGANISATION: "Szervezet",
        CITIZEN_CLARIFICATION: "Állampolgár tisztázásai",
        STAFF_CLARIFICATION: "Ügyintéző tisztázásai",
        ERROR_PAGE: {
            TITLE: "Hoppá...",
            TEXT: "Probléma merült fel...",
            SUB_TEXT: "váratlan hiba",
            NOT_FOUND_TITLE: "Az oldal nem található",
            NOT_FOUND_TEXT: "A keresett erőforrás nem létezik, vagy már nem érhető el.",
            BACK_HOME: "Vissza a főoldalra",
        },
        SELECT_LOADING: "Betöltés...",
        CURRENCY_LABEL: "RON",
        RECOMANDED_SCREEN: "Ez az alkalmazás nincs mobiltelefonra vagy táblagépre optimalizálva. A legjobb böngészési és működési élmény érdekében az alkalmazás webes verziójának használatát javasoljuk.",
        OR: "vagy",
        MAINTENANCE: "A rendszer jelenleg karbantartás alatt áll, ezért egyes funkciók esetleg nem működnek megfelelően.",
        SEARCH_OPTIONS: "{0} keresése",
        NO_RESULTS: "Nincs találat erre: ",
        COPY_PREFIX: "Melléklet",
        MISSING_ADDRESS: "A cím nem elérhető",
        ADD_ASSIGNMENT: "Kiosztás hozzáadása",
        REMOVE_ASSIGNMENT: "Kiosztás törlése",
        NO_OPTIONS_AVAILABLE: "Nincs elérhető lehetőség",
        CITIZEN_MAINTENANCE_TITLE: "A rendszer karbantartás alatt áll",
        MAINTENANCE_MESSAGE: "A platform karbantartási munkálatok miatt átmenetileg nem érhető el. Kérjük, látogasson vissza később.",
        LOGO_ALT: "Logó",
        MAP: {
            EXPORT_MAP: "Térkép exportálása",
            DOWNLOAD_PDF: "Letöltés PDF-ként",
            DOWNLOAD_PNG: "Letöltés PNG-ként",
            MEASURE_DISTANCE: "Távolság mérése két vagy több pont között",
            MEASURE_AREA: "Terület mérése",
            CLEAR_MEASUREMENTS: "Mérések törlése",
            EXPORT_PDF_ERROR: "A térképet nem sikerült PDF-ként exportálni",
            EXPORT_PNG_ERROR: "A térképet nem sikerült PNG-ként exportálni",
        },
        DOCUMENT_EDITOR: {
            TOTAL_PAGES: "Összes oldal",
            TOTAL_PAGES_TOOLTIP: "Beszúrja az oldalak teljes számát.",
            DEFAULT_AUTHOR: "Felhasználó",
            PASTE: "Beillesztés",
            TABLE_HEADER_GROUP: "Táblázatfejléc",
            REPEAT_HEADER_ROWS: "Fejlécsorok ismétlése",
            REPEAT_HEADER_ROWS_TOOLTIP: "Megismétli a táblázat fejlécsorát minden oldal tetején.",
        },
        UNKNOWN_USER: "Ismeretlen felhasználó",
    },
    ALERT_MODAL: {
        ERROR: "Hiba",
        WARNING: "Figyelem",
        SUCCESS: "Sikeres",
        INFO: "Információ",
    },
    AUTH: {
        GENERAL: {
            OR: "vagy",
            CANCEL_BUTTON: "Mégse",
            BACK_BUTTON: "Vissza",
            PRIVACY: "Adatvédelmi szabályzat",
            LEGAL: "Felhasználási feltételek",
        },
        LOGIN: {
            TITLE: "Üdvözöljük!",
            DESC: "Adja meg e-mail címét és jelszavát a platform eléréséhez",
            NO_ACCOUNT: "Nincs fiókja? Regisztráljon most!",
            BUTTON: "Belépés",
            FORGOT_PASSWORD_LABEL: "Elfelejtette a jelszavát?",
            GOOGLE_BUTTON: "Belépés Google-fiókkal",
            FACEBOOK_BUTTON: "Belépés Facebook-fiókkal",
            ROEID_BUTTON: "Belépés ROeID-vel",
            HELP_TEXT: "* Az alkalmazásban kétféle fiók hozható létre: személyes fiók természetes és jogi személyek részére, valamint szakmai fiók tervezői/településtervezési irodák részére.",
            ROEID_INFO_TEXT_FIRST: "Javasoljuk, hogy használja a ",
            ROEID_INFO_TEXT_SECOND: " alkalmazást a Ghișeul Unic rendszerbe való belépéshez.",
            ROEID_INFO_DESCRIPTION: "A {roeid} egy mobiltelefonos alkalmazás, amelyet a {adr} bocsát rendelkezésre. Az alkalmazást Romániában hivatalos elektronikus azonosítási módszerként bejelentették az {ec}.",
            ROEID_INFO_ADR_LINK_TEXT: "Romániai Digitalizációs Hatóság",
            ROEID_INFO_EC_LINK_TEXT: "Európai Bizottságnál",
        },
        FORGOT: {
            TITLE: "Jelszó visszaállítása?",
            DESC: "Adja meg a fiókhoz tartozó e-mail címet.",
            BUTTON: "E-mail küldése",
            SUCCESS: "Fiókja sikeresen visszaállítva.",
        },
        RESET: {
            TITLE: "Jelszó visszaállítása?",
            DESC: "Adja meg az új jelszót",
            BUTTON: "Jelszó módosítása",
        },
        CHANGE_PASSWORD: {
            TITLE: "Jelszó módosítása",
            DESC: "Adja meg az új jelszót",
            BUTTON: "Jelszó módosítása",
        },
        SET: {
            TITLE: "Jelszó beállítása",
            DESC: "Adja meg a jelszót",
            BUTTON: "Jelszó beállítása",
        },
        REGISTER: {
            TITLE: "Üdvözöljük!",
            DESC: "Az alkalmazásban kétféle fiók hozható létre: személyes fiók természetes/jogi személyek és területi-közigazgatási egységek (UAT) részére, valamint szakmai fiók tervezői/településtervezési irodák részére.",
            HAS_ACCOUNT: "Már van fiókja? Lépjen be",
            GOOGLE_BUTTON: "Regisztráció Google-fiókkal",
            FACEBOOK_BUTTON: "Regisztráció Facebook-fiókkal",
            BUTTON: "Fiók létrehozása",
            ACCEPT_TERMS: "Elfogadom az {0} és a {1}.",
            PRIVACY: "adatvédelmi szabályzatot",
            TOS: "felhasználási feltételeket",
            PASSWORD_HELP: "Legalább 8 karakter, egy nagybetű, egy kisbetű, egy számjegy és egy speciális karakter",
            PROFESSIONAL_TITLE: "Új szakmai fiók létrehozása",
            PROFESSIONAL_DESC: "A szakmai fiók a tervezés területén (építészet, urbanisztika, mérnöki tervezés stb.) tevékenykedő jogi személyek – irodák / társaságok / egyéni vállalkozók (PFA) / egyéni építészirodák (BIA) – számára szól, és kérelmek kezelésére/benyújtására szolgál egy vagy több kedvezményezett részére – alfiókok létrehozását is lehetővé teszi",
            PERSONAL_TITLE: "Új személyes fiók létrehozása",
            PERSONAL_DESC: "A személyes fiók természetes / jogi személyek és közigazgatási szervek számára szól, és természetes / jogi személyek / polgármesteri hivatalok részére vagy nevében történő kérelembenyújtásra szolgál",
            BUTTON_PERSONAL: "Személyes fiók létrehozása",
            BUTTON_PROFESSIONAL: "Szakmai fiók létrehozása",
            ROEID_BUTTON: "Belépés ROeID-vel",
        },
        INPUT: {
            EMAIL: "E-mail",
            PASSWORD: "Jelszó",
            CONFIRM_PASSWORD: "Jelszó megerősítése",
            NEW_PASSWORD: "Új jelszó",
            OLD_PASSWORD: "Régi jelszó",
            PHONE: "Telefonszám",
            VALIDATION_CODE_PLACEHOLDER: "Ellenőrző kód",
        },
        VERIFY_EMAIL: {
            TITLE: "E-mail megerősítése",
            MESSAGE_SENT: "Aktiválási linket küldtünk a következő e-mail címre: {0}. Ellenőrizze e-mailjeit, majd a megerősítés után folytassa a fiók érvényesítését. Az aktiválási link néha a levélszemét mappába kerülhet, kérjük, ellenőrizze azt is.",
            RESEND_CONFIRMATION_MESSAGE: "Nem kapta meg a megerősítő e-mailt? {0}.",
            RESEND_LINK: "Link újraküldése",
            TOAST_MESSAGE: "A megerősítő e-mail sikeresen elküldve",
        },
        VERIFY_SMS: {
            TITLE: "Fiók érvényesítése",
            MESSAGE: "Biztonsági okokból a Ghișeul Unic SMS-ben ellenőrzi az Ön fiókját. Adja meg telefonszámát, és kövesse az érvényesítés lépéseit.",
            MESSAGE_SENT: "SMS-t küldtünk a következő telefonszámra: {0}. Adja meg a kapott kódot, és érvényesítse fiókját.",
            BUTTON_SUBMIT: "Kód küldése",
            BUTTON_VALIDATE: "Fiók érvényesítése",
            INPUT_PLACEHOLDER: "Ellenőrző kód",
            MESSAGE_NOT_RECEIVED: "Nem kapta meg a kódot? {0}",
            RESEND_LINK: "Üzenet újraküldése",
            CHANGED_VALIDATION_METHOD_LINK: "érvényesítési mód módosítása",
        },
        INVALID_LINK: {
            TITLE: "Érvénytelen aktiválási link",
            MESSAGE: "Az aktiválási link érvénytelen, lejárt vagy már felhasználták. Kérjük, ellenőrizze fiókját, vagy kezdje újra a regisztrációs folyamatot.",
            REGISTER_MESSAGE: "Ugrás a {0} oldalára.",
            REGISTER_LINK: "regisztráció",
        },
        VALIDATION: {
            INVALID: "A(z) {{name}} nem érvényes",
            REQUIRED: "Ez a mező kötelező",
            EMAIL: "Az e-mail cím nem érvényes",
            INVALID_EMAIL: "Az e-mail cím nem érvényes.",
            MIN_LENGTH: "A(z) {{name}} minimális hossza {{min}}",
            AGREEMENT_REQUIRED: "A felhasználási feltételek elfogadása kötelező",
            NOT_FOUND: "A kért {{name}} nem található",
            INVALID_LOGIN: "Hibás bejelentkezési adatok. Kérjük, próbálja újra.",
            REQUIRED_FIELD: "Ez a mező kötelező",
            CONFIRM_PASSWORD: "A jelszavak nem egyeznek",
            MIN_LENGTH_FIELD: "A mezőnek legalább {min} karakterből kell állnia",
            MAX_LENGTH_FIELD: "A mező legfeljebb {max} karakterből állhat",
            INVALID_FIELD: "A mező nem érvényes",
            STRONG_PASSWORD: "Érvénytelen jelszó",
            INVALID_PHONE: "A telefonszám nem érvényes",
            NUMERIC_FIELD: "Ez a mező csak számokat tartalmazhat",
            PHONE_FIELD: "Ez a mező csak számokat tartalmazhat",
            INVALID_URC: "Érvénytelen CUI",
            INVALID_PNC: "Érvénytelen CNP",
            POSTAL_CODE_MAX_LENGTH_FIELD: "Az irányítószámnak 6 számjegyből kell állnia",
            SMS_CODE_LENGTH: "Az ellenőrző kódnak 6 számjegyből kell állnia",
            IBAN: "Érvénytelen IBAN-kód.",
            INTEGER: "A mező értéke nem érvényes egész szám",
            INVALID_DATE: "Érvénytelen dátum",
            ALPHABETICAL: "A mező értéke csak betűket és szóközt tartalmazhat",
            LETTERS_ONLY: "A mező értéke csak betűket tartalmazhat",
            NO_UPPER: "Ez a mező csak kisbetűket tartalmazhat",
            ALPHABETICAL_SPECIAL_CHARS: "A mező értéke csak betűket, szóközt, aposztrófot és - jelet tartalmazhat",
            URL: "A megadott link nem érvényes",
            FULL_URL: "A megadott link nem érvényes. A \"https\" előtag kötelező.",
            ARCGIS_FEATURE_SERVICE_URL: "A megadott link nem érvényes ArcGIS Feature Service",
            INVALID_EMAIL_DOMAIN: "Kérjük, használjon másik domainhez tartozó e-mail címet",
            NO_SPACE: "Ez a mező nem tartalmazhat szóközt",
            "АT_LEAST_ONE_COLUMN": "Válasszon ki legalább egy oszlopot",
        },
    },
    LAYOUT: {
        HEADER: {
            SEARCH_PLACEHOLDER: "Kérelem, láttamozás vagy más dokumentum keresése",
        },
    },
    LOGOUT: {
        CONFIRMATION_MESSAGE: "Biztos be szeretné fejezni a munkamenetet?",
    },
    RESET_PASSWORD: {
        CONFIRMATION_MESSAGE: "Biztos vissza szeretné állítani a jelszavát?",
        SUCCESSFULLY_SENT_MESSAGE: "A jelszó-visszaállítási linket elküldtük a megadott e-mail címére.",
        SUCCESSFULLY_MESSAGE: "Jelszava sikeresen módosítva",
    },
    UNLINK_ROEID: {
        CONFIRMATION_MESSAGE: "Biztos deaktiválni szeretné a ROeID-kapcsolatot? Ez a művelet eltávolítja a ROeID-fiókból átvett adatokat, és letiltja a ROeID-fiókhoz kapcsolódó funkciókat.",
        SUCCESSFULLY_MESSAGE: "A ROeID-kapcsolat sikeresen deaktiválva. A jelszó visszaállításához e-mailben értesítést fog kapni.",
    },
    LINK_ROEID: {
        INFORMATION_MESSAGE: "A fiók ROeID-vel való összekapcsolásához ki kell jelentkeznie, majd a „Belépés ROeID-vel” opcióval kell bejelentkeznie. Az összekapcsolás után a ROeID-fiók adatai átvehetők és frissíthetők lesznek az Ön profiljában. Ha nincs ROeID-fiókja, javasoljuk, hogy töltse le a ROeID mobilalkalmazást, kövesse a ROeID-fiók létrehozásának lépéseit, majd térjen vissza a fiókok összekapcsolásához.",
    },
    HOME: {
        WELCOME_TEXT: "Üdvözöljük a Ghișeul Unic alkalmazásban.",
    },
    PROFILE: {
        HEADER: "Fiókom",
        HEADER_CITIZEN: "Személyes fiókom",
        HEADER_LEGAL: "Szakmai fiókom",
        LOGOUT_BUTTON_TEXT: "Kijelentkezés",
        UPDATE_BUTTON: "Adatok frissítése",
        ROEID_BUTTON: "Adatok átvétele a ROeID-fiókból",
        DEACTIVATE_ROEID_BUTTON: "ROeID-kapcsolat deaktiválása",
        VIDEO_ENROLL_BUTTON: "Videós aláírói regisztráció",
        SECTIONS: {
            ACCOUNT_DETAILS: {
                HEADER: "Fiók részletei",
            },
            PERSONAL_DETAILS: {
                HEADER: "Személyes adatok",
            },
            PERSONAL_DATAS: {
                HEADER: "Személyi adatok",
            },
            COMPANY_DATAS: {
                HEADER: "Cégadatok",
            },
            RESPONSIBILITIES: {
                HEADER: "Felelősségi körök",
            },
            IDENTITY_CARD: {
                HEADER: "Személyi igazolvány adatai",
            },
            LANGUAGE: {
                SAVE_FAILED: "A nyelvet nem sikerült menteni a profiljába. Kérjük, próbálja újra.",
                CHOICE: {
                    LOGIN_TITLE: "Melyik nyelvet szeretné használni?",
                    LOGIN_TEXT: "A fiókjában mentett nyelv eltér attól, amellyel bejelentkezett. A választott nyelv a következőkre vonatkozik:",
                    SWITCH_TITLE: "Módosítja a nyelvet?",
                    SWITCH_TEXT: "Az új nyelv a következőkre vonatkozik:",
                    APPLIES_TO: {
                        PLATFORM: "Platform",
                        EMAIL: "E-mail",
                        SMS: "SMS",
                    },
                    TAGS: {
                        ACCOUNT: "Az Ön fiókja",
                        LOGIN_SCREEN: "Bejelentkezési képernyő",
                        CURRENT: "Jelenlegi nyelv",
                        NEW: "Új nyelv",
                    },
                    CAPTION_ACCOUNT: "Tartsa meg a fiókjában mentett nyelvet",
                    CAPTION_LOGIN_SCREEN: "Váltson arra a nyelvre, amellyel bejelentkezett",
                    CAPTION_KEEP: "Maradok a magyarnál",
                    CAPTION_SWITCH: "Váltás magyar nyelvre",
                    DESCRIPTION_USE: "A platform és az értesítések magyarul",
                    DESCRIPTION_KEEP: "A platform és az értesítései magyarul maradnak.",
                    DESCRIPTION_SWITCH: "A teljes platform és minden értesítése magyarul lesz.",
                    FOOTNOTE: "Bármikor módosíthatja a felső sávban lévő zászlóval.",
                    NOTICE: "A platform és az értesítései mostantól magyar nyelvűek.",
                },
            },
        },
        OPTIONS: {
            MY_PROFILE: {
                NAME: "Profilom",
                DESCRIPTION: "Profil részleteinek megtekintése",
            },
            RESET_PASSWORD: {
                NAME: "Jelszó visszaállítása",
                DESCRIPTION: "Visszaállítási űrlap megnyitása",
            },
            NOTIFICATIONS_MANAGEMENT: {
                NAME: "Értesítések kezelése",
                DESCRIPTION: "Az értesítések típusának és gyakoriságának kezelése",
            },
            UNLINK_ROEID: {
                NAME: "ROeID deaktiválása",
                DESCRIPTION: "ROeID-kapcsolat deaktiválása",
            },
            LINK_ROEID: {
                NAME: "Összekapcsolás ROeID-vel",
                DESCRIPTION: "Kapcsolja össze fiókját a ROeID-vel, hogy átvehesse az adatokat a ROeID-fiókból.",
            },
            PCUEL: {
                NAME: "PCUEL",
                DESCRIPTION: "Utolsó szinkronizálás {0}",
                BUTTON: "Szinkronizálás",
            },
        },
        FIELDS: {
            PERSONAL_NUMERIC_CODE: "CNP",
            LAST_NAME: "Vezetéknév",
            FIRST_NAME: "Keresztnév",
            COUNTY: "Megye",
            LOCALITY: "Megyei jogú város/Város/Község",
            VILLAGE: "Település",
            SECTOR: "Kerület",
            STREET: "Utca",
            POSTAL_CODE: "Irányítószám",
            STREET_NUMBER: "Házszám",
            STAIRCASE: "Lépcsőház",
            BLOCK: "Tömbház",
            FLOOR: "Emelet",
            APARTMENT: "Lakás",
            EMAIL: "E-mail",
            PHONE: "Telefon",
            PASSPORT_NUMBER: "Útlevél/Személyi igazolvány",
            COUNTRY: "Ország",
            CITY: "Város",
            ADDRESS: "Cím",
            UNIQUE_REGISTRATION_CODE: "CIF vagy CUI",
            REGISTRATION_NUMBER: "Cégjegyzékszám",
            COMPANY_NAME: "Szervezet megnevezése",
            IBAN: "IBAN-számla",
            BANK: "Számlavezető bank",
            LICENSE: "Építész – TNA-szám",
            STATUS: "Állapot",
            IDENTIFICATION_NUMBER: "Szolgálati igazolvány száma",
            ORGANISATION: "Intézmény",
            FUNCTIONS: "Beosztás",
            DEPARTMENTS: "Osztály",
            USER_TYPE_NAME: "Felhasználótípus",
            ID_CARD_SERIAL: "Sz. ig. sorozat",
            ID_CARD_NUMBER: "Sz. ig. szám",
            ID_CARD_ISSUED_DATE: "Kiállítás dátuma",
            ID_CARD_EXPIRATION_DATE: "Lejárati dátum",
            ID_CARD_ISSUER: "Kiállította",
        },
        PLACEHOLDERS: {
            COUNTY: "Megye",
            LOCALITY: "Település",
            VILLAGE: "Falu",
            COUNTRY: "Ország",
            STATUS: "Állapot",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
        },
        MESSAGES: {
            ID_CARD_EXPIRED: "A személyi igazolvány lejárt!",
            STAFF_ENROLLMENT_PROCESSING_TITLE: "Videós aláírói regisztráció feldolgozás alatt...",
            STAFF_ENROLLMENT_SUCCESS_TITLE: "Az ügyintéző aláírói regisztrációja sikeresen megtörtént",
            STAFF_ENROLLMENT_REDIRECT_TEXT: "Néhány másodpercen belül átirányítjuk a profiljához. Ha az átirányítás nem történik meg automatikusan, kérjük, {0}",
            STAFF_ENROLLMENT_FAILED_TITLE: "Hiba történt az aláírói regisztráció során, kérjük, próbálja újra.",
            ROEID_UPDATED_SUCCESSFULLY: "A ROeID-adatok átvétele sikeresen megtörtént. Ahhoz, hogy fiókja minősített fiókká váljon, kérjük, kattintson az Adatok frissítése gombra. Ha szakmai fiókja van, a frissítés előtt töltse ki a többi kötelező mezőt",
        },
        ENROLLED_BADGE_LABEL: "Regisztrálva",
        ROEID_BADGE_LABEL: "Minősített",
        DEACTIVATE_PCUEL_BUTTON: "PCUEL deaktiválása",
    },
    SET_PROFILE_DATA: {
        UPDATE_PROFILE_MODAL: {
            HEADER: "Fontos adatfrissítés!",
            TEXT: "Az alkalmazásban bevezetett új funkciók miatt kérjük, hogy frissítse profiladatait. Köszönjük!",
            GO_TO_PROFILE: "Ugrás a profilomhoz",
        },
        UPDATE_PROFILE_MODAL_ROEID: {
            TEXT: "A ROeID-fiók adatai frissültek. Ahhoz, hogy a profiljában is frissüljenek, kérjük, vegye át és mentse el az adatokat.",
        },
        WELCOME_MODAL: {
            BRAND: {
                NAME: "Ghișeul Unic",
                ORGANISATION: "Kolozs Megyei Tanács",
            },
            HEADER: {
                TOP_P: "Üdvözöljük a Ghișeul Unic platformon!",
                BOTTOM_P: "Töltse ki profiladatait, hogy az élményt az igényeihez igazíthassuk.",
                BOTTOM_P_PERSON: "Személyes fiók beállítása",
                BOTTOM_P_LEGAL: "Szakmai fiók beállítása",
            },
            OPTIONS: {
                PERSON: "Személyes profil beállítása",
                LEGAL: "Szakmai profil beállítása",
            },
        },
        CITIZEN: {
            ROMANIAN: "Román állampolgár",
            FOREIGNER: "Külföldi állampolgár",
        },
        FORM_BUTTONS: {
            CHANGE_TYPE: "Profiltípus módosítása",
            SAVE: "Adatok mentése",
        },
        LEGAL_FORM: {
            COMPANY: "Cég adatai",
            LEGAL_REPRESENTATIVE: "Törvényes képviselő adatai",
        },
        PERSON: {
            PNC: "CNP",
            LAST_NAME: "Vezetéknév",
            FIRST_NAME: "Keresztnév",
            COUNTY: "Megye",
            LOCALITY: "Megyei jogú város/Város/Község",
            VILLAGE: "Település",
            SECTOR: "Kerület",
            STREET: "Utca",
            POSTAL_CODE: "Irányítószám",
            NUMBER: "Házszám",
            STAIRCASE: "Lépcsőház",
            BLOCK: "Tömbház",
            FLOOR: "Emelet",
            APARTMENT: "Lakás",
            EMAIL: "E-mail",
            PHONE: "Telefon",
        },
        FOREIGNER: {
            PNC: "Útlevél/Személyi igazolvány",
            LAST_NAME: "Vezetéknév",
            FIRST_NAME: "Keresztnév",
            COUNTRY: "Ország",
            CITY: "Város",
            ADDRESS: "Cím",
            EMAIL: "E-mail",
            PHONE: "Telefon",
        },
        LEGAL: {
            URC: "CUI",
            COMPANY_NAME: "Megnevezés",
            COUNTY: "Megye",
            LOCALITY: "Település",
            STREET: "Utca",
            POSTAL_CODE: "Irányítószám",
            NUMBER: "Házszám",
            STAIRCASE: "Lépcsőház",
            BLOCK: "Tömbház",
            FLOOR: "Emelet",
            APARTMENT: "Lakás",
            LAST_NAME: "Vezetéknév",
            FIRST_NAME: "Keresztnév",
            PNC: "CNP",
            LICENSE: "Építész – TNA-szám",
            EMAIL: "E-mail",
            PHONE: "Telefon",
        },
        ERRORS: {
            LOCALITIES: "Hiba történt a települések listájának betöltésekor!",
            VILLAGES: "Hiba történt a falvak listájának betöltésekor!",
            UPDATE: "Hiba történt a profiladatok módosításakor!",
            CREATE: "Hiba történt a felhasználói profil létrehozásakor!",
        },
        SUCCESS_MODAL: {
            TITLE: "Üdvözöljük, {0}!",
            TEXT: "Mostantól feltöltheti és elküldheti az engedélyezési folyamathoz szükséges dokumentumokat, és kezelheti a dokumentumait.",
            CONFIRM_BUTTON: "Kezdjük!",
        },
        UPDATED_MESSAGE: "A profil sikeresen frissítve!",
        GDPR: {
            AGREE_CONDITION: "Hozzájárulok a személyes adataim kezeléséhez",
            CONDITIONS: "A természetes személyeknek a személyes adatok kezelése tekintetében történő védelméről és az ilyen adatok szabad áramlásáról, valamint a 95/46/EK irányelv hatályon kívül helyezéséről szóló (EU) 2016/679 rendelet (általános adatvédelmi rendelet) és a 190/2018. sz. törvény alapján a Kolozs Megyei Tanács személyes adatokat kezel, biztosítva azok biztonságát és bizalmas jellegét.”",
        },
    },
    NOTIFICATIONS: {
        BUTTON_TEXT: "Módosítások alkalmazása",
        HEADER: {
            TOP: "Értesítések kezelése",
            COL_1: "Értesítés típusa",
            COL_2: "E-mail",
            COL_3: "SMS",
            COL_4: "Alkalmazásban",
        },
        SECTION_TITLE: {
            ACCOUNT: "Fiók",
            APPLICATIONS: "Kérelmek",
            DOCUMENTS: "Iratok",
            ALERTS: "Figyelmeztetések",
            OTHERS: "Egyéb",
            COMPLAINS: "Bejelentések",
            COMMENTS: "Üzenetek",
            INTERNAL_DOCUMENTS: "Belső dokumentumok",
            CONTROLS: "Ellenőrzések",
        },
        FREQUENCY: {
            DAILY: "Naponta",
            WEEKLY: "Hetente",
            MONTHLY: "Havonta",
        },
        ITEMS: {
            ACCOUNT_DATA_CHANGED: "Fiókadatok módosítása",
            ACCOUNT_TYPE_CHANGED: "Fióktípus módosítása",
            NEW_APPLICATION: "Új kérelem érkezése",
            APPLICATION_CHANGED: "Kérelem módosítása",
            APPLICATION_STATUS_CHANGED: "Kérelem állapotának változása",
            APPLICATION_SENT: "Kérelem elküldése",
            DOCUMENT_CREATED: "Új irat kiállítása",
            DOCUMENT_CANCELLED: "Irat visszavonása",
            TAX_DEADLINE_EXPIRES: "Fizetési határidő lejárata",
            RESPONSE_DEADLINE_EXPIRES: "Válaszadási határidő lejárata",
            MESSAGE_SENT: "Üzenet küldése.",
            NEW_COMPLAIN: "Új bejelentés érkezése",
            COMPLAIN_STATUS_CHANGED: "Bejelentés állapotának változása",
            NEW_COMMENT: "Új üzenet érkezése",
            OTHER_APPLICATION_RELATED_UPDATES: "Újdonságok érkezése az alkalmazásból",
            INTERNAL_DOCUMENT_STATUS_CHANGED: "Belső dokumentum állapotának változása",
            CONTROLS_STATUS_CHANGED: "Ellenőrzés állapotának változása",
            APPLICATION_SIGNED: "Aláírás alkalmazása a kijelölt dokumentumokon",
            APPLICATION_TO_BE_SIGNED: "Aláírandó dokumentum érkezése",
        },
        ERRORS: {
            NOTIFICATIONS: "Hiba történt az értesítések listájának generálásakor!",
            UPDATE: "Hiba történt az értesítés módosításakor!",
        },
        SUCCESS: {
            UPDATE: "Az értesítés módosítása sikeresen megtörtént.",
        },
        TEMPLATES: {
            TITLE: "Értesítési sablonok",
            TABLE: {
                ACTIONS: "Műveletek",
                EDIT: "Szerkesztés",
            },
            EDIT: {
                PAGE_TITLE: "Sablon szerkesztése",
                SUBJECT: "Tárgy",
                MESSAGE: "Üzenet",
                COPY_HINT: "Kattintson egy helyőrzőre a másoláshoz",
                COPIED: "Másolva",
                TITLE: "Cím",
                SMS: "SMS",
                EMAIL: "E-mail",
                IN_APP: "Alkalmazásban",
                ACCEPTED_PLACEHOLDERS: "Elfogadott helyőrzők",
                SAVE: "Mentés",
                MAX_CHARS: "Legfeljebb {chars} karakter.",
                REMAINING_CHARS: "Hátralévő: {chars}",
            },
            FIELDS: {
                TITLE: "Megnevezés",
                TYPE: "Sablonkód",
                CHANNEL: "Kézbesítési csatorna",
            },
            PLACEHOLDERS: {
                TITLE: "Keresés megnevezés szerint",
                CHANNEL: "Kézbesítési csatorna",
            },
            SECTIONS: {
                DETAILS: "Sablon adatai",
                CONTENT: "Üzenet tartalma",
            },
        },
    },
    NOTIFICATIONS_IN_APP: {
        TITLE: "Értesítések",
        MESSAGE: {
            INPUT_CODE: "Bejövő iktatószám",
            BENEFICIARY: "Kedvezményezett",
        },
        LOCALE: {
            FUTURE: "múlva",
            PAST: "ezelőtt",
            SECOND: "néhány másodperce",
            SECONDS: "másodperce",
            MINUTE: "egy perce",
            MINUTES: "perce",
            HOUR: "egy órája",
            HOURS: "órája",
        },
        NOW: "Érkezett",
    },
    BENEFICIARY: {
        BENEFICIARY_DETAILS: {
            HEADER: "Kedvezményezett részletei",
            ADD_BTN: "Kedvezményezett hozzáadása",
            REMOVE_BTN: "Kedvezményezett törlése",
            PERSON: {
                HEADER: "Személy típusa",
                INDIVIDUAL: "Természetes személy",
                LEGAL: "Jogi személy",
            },
            CITIZENSHIP: {
                HEADER: "Állampolgárság",
                ROMANIAN: "Román állampolgár",
                FOREIGNER: "Külföldi állampolgár",
            },
            FOOTER_CHECKBOX: "A kedvezményezett a kapcsolattartó",
            FORM: {
                AUTHORIZATION_CODE: "TNA",
                SUBSIDIARY: "Fiókszervezet",
            },
            ADDRESS: "Cím",
            CONTACT: "Elérhetőség",
            PERSON_DETAILS_HEADER: "TÖRVÉNYES KÉPVISELŐJE",
            ID_DETAILS_HEADER: "SZEMÉLYAZONOSÍTÓ OKMÁNY ADATAI",
            OFFICE_DETAILS_HEADER: "SZÉKHELY ADATAI",
            ID_LEGAL_DETAILS_HEADER: "A TÖRVÉNYES KÉPVISELŐ SZEMÉLYAZONOSÍTÓ OKMÁNYÁNAK ADATAI",
            BANK_DETAILS_HEADER: "A JOGI SZEMÉLY BANKI ADATAI",
        },
        APPLICANT_DETAILS: {
            HEADER: "Kérelmező adatai",
            FOOTER_CHECKBOX: "A kérelmező a kapcsolattartó",
        },
        SINGLE: "Összesen {total} kedvezményezett",
        MULTIPLE: "Összesen {total} kedvezményezett",
        LIST_HEADER: "Kedvezményezettek listája",
        MODAL: {
            ADD_HEADER: "Kedvezményezett hozzáadása",
            EDIT_HEADER: "Kedvezményezett szerkesztése",
        },
        CARD: {
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Lakcím",
            CONTACT: "Elérhetőség",
            CITIZENSHIP: "Állampolgárság",
            ADDRESS_COUNTY: "Megye",
            ADDRESS_STREET: "utca",
            ADDRESS_NUMBER: "sz.",
            ADDRESS_STAIRCASE: "lépcsőház",
            ADDRESS_APARTMENT: "lakás",
        },
        SEARCH_DESCRIPTION: "Válassza ki a kedvezményezettet, vagy adjon hozzá egy újat",
        SEARCH_PLACEHOLDER: "Keresse meg a kedvezményezettet CNP/CUI alapján, vagy adjon hozzá egy újat",
        SEARCH_PLACEHOLDER_ON_APPLICATION: "Keresse meg a kedvezményezettet",
        SEARCH_DESCRIPTION_ON_APPLICATION: "Válassza ki a kedvezményezettet",
        ANAF_VALIDATION: "Az ANAF-validálási rendszer nem érhető el. A kedvezményezettet manuálisan kell hozzáadni, és szerkesztéskor vagy a kérelemhez való hozzáadáskor kerül ellenőrzésre",
        ANAF_ADDRESS_INFO: "ANAF-adatok - megye neve: {county}, település neve: {locality}",
    },
    ERRORS: {
        DEFAULT_ERROR_MESSAGE: "Hiba történt, kérjük, próbálja újra",
        AUTH_REQUIRED: "Engedélyezés szükséges.",
        AUTH_INVALID: "Sikertelen bejelentkezés.",
        AUTH_INVALID_ATTEMPTS_REMAINING: "Sikertelen bejelentkezés. Hátralévő próbálkozások: {0}.",
        REGISTRATION_EMAIL_ALREADY_EXISTS: "Ez az e-mail cím már létezik.",
        REGISTRATION_INVALID_PASSWORD: "Érvénytelen jelszó",
        REGISTRATION_INVALID: "Érvénytelen regisztráció.",
        FACEBOOK_EMAIL_NOT_RECEIVED: "Hiba történt, nem sikerült lekérni az Ön e-mail címét. Ellenőrizze a Facebook-beállításokat, és próbálja újra!",
        PASSWORD_EXPIRED: "Az Ön jelszava lejárt, és meg kell változtatnia.",
        AUTH_FAILED: "Sikertelen bejelentkezés.",
        AUTH_FAILED_ATTEMPTS_REMAINING: "Sikertelen bejelentkezés. Hátralévő próbálkozások: {0}.",
        RESET_PASSWORD_ALREADY_USED: "A jelszónak különböznie kell a jelenlegitől.",
        FORBIDDEN: "Sajnáljuk, nincs megfelelő jogosultsága a folytatáshoz.",
        TOKEN_INVALID: "Érvénytelen token",
        DUPLICATE_FUNCTION_NAME: "A hozzáadott beosztás neve már létezik!",
        CATEGORY_NOT_EMPTY: "A kategória nem törölhető!",
        NAME_NOT_UNIQUE: "A név nem egyedi.",
        ERROR_PAGE_MESSAGE: "HOPPÁ! Valami hiba történt",
        AUTH_ACCOUNT_NOT_FOUND: "A megadott bejelentkezési adatok hibásak!",
        PARENT_MUST_BE_ADMIN_OF_LEGAL_ENTITY: "Nincs jogosultsága fiók hozzáadására vagy szerkesztésére!",
        USER_ALREADY_EXISTS: "Ez a felhasználó már létezik!",
        TAX_ALREADY_EXISTS: "Ez a díj már létezik!",
        VERIFICATION_SERVICE_UNAVAILABLE: "A megadott kód érvénytelen!",
        CANNOT_DELETE_ORGANISATION: "Ez a szervezet nem törölhető, mert felhasználók tartoznak hozzá",
        ORGANISATION_ALREADY_EXISTS: "Ez a szervezet már létezik",
        DOCUMENT_SERIES_ALREADY_EXISTS: "Ez a sorozat már létezik!",
        REGISTER_CONFIG_EXISTS: "Már létezik regiszter ezen a néven.",
        REGISTER_TYPE_EXISTS: "Már létezik regisztertípus ezen a néven.",
        REGISTER_TYPE_CANNOT_BE_DELETED: "Ez a regisztertípus nem törölhető, mert dokumentumok kapcsolódnak hozzá.",
        PREFIXLESS_SERIES_ALREADY_EXISTS: "Ehhez a szervezethez már létezik előtag nélküli sorozat!",
        DOCUMENT_SERIES_NOT_EXIST: "Nincs meghatározott sorozat!",
        DOCUMENT_SERIES_NOT_ACTIVE: "A sorozat nem aktív!",
        RESPONSIBILITY_ALREADY_EXISTS: "Ez a felelősségi kör már létezik!",
        INDEX_CANNOT_BE_LOWER_THAN_CURRENT_VALUE: "Az index értéke nem lehet kisebb a jelenlegi értéknél!",
        CONFLICT: "Duplikált bejegyzés",
        PAYMENT_ALREADY_PROCESSED: "A fizetést már feldolgozták!",
        PAYMENT_STATE_CHANGED: "A befizetés időközben megváltozott.",
        DUPLICATE_MANUAL_PAYMENT: "Ugyanilyen összegű, módú, dátumú és bizonylatszámú befizetés már hozzá van adva.",
        PAYMENT_DATE_IN_FUTURE: "A fizetés dátuma nem lehet jövőbeli.",
        INVALID_MANUAL_PAYMENT: "A befizetés adatai érvénytelenek.",
        PAYMENT_NOT_ALLOWED: "Ez a befizetés nem módosítható.",
        PAYMENT_LOG_NOT_FOUND: "A befizetés nem található.",
        PAYMENTS_SERVICE_UNAVAILABLE: "A fizetési szolgáltatás nem válaszol. Próbálja újra néhány perc múlva.",
        PAYMENT_ACTION_FORBIDDEN: "Nincs jogosultsága ehhez a művelethez, vagy a munkamenet véget ért. Töltse újra az oldalt, és próbálja újra.",
        PAYMENT_RESULT_UNKNOWN: "A fizetési szolgáltatás nem válaszolt. Ellenőrizze a befizetést a listában, mielőtt újra próbálkozik.",
        INVALID_PAYMENT_PROOF: "A befizetés igazolását nem sikerült ellenőrizni. Távolítsa el a fájlt, és töltse fel újra.",
        PAYMENT_PROOF_UNAVAILABLE: "A befizetés igazolása most nem ellenőrizhető, ezért semmi sem lett elmentve. Próbálja újra néhány perc múlva.",
        AUTH_INVALID_CONFIRMATION_VALIDATIONS: "A jelszó-visszaállítási kérés lejárt!",
        CERTSIGN_CONFIRMING_SIGNING_FAILED: "A megadott kód érvénytelen!",
        ATLAS_NO_SEARCH_RESULT: "A cím nem található!",
        DECISION_TARGET_CANNOT_BE_DELETED: "Ez a helyszín nem törölhető, mert egy határozathoz kapcsolódik",
        DECISION_PURPOSE_CANNOT_BE_DELETED: "Ez a cél nem törölhető, mert egy határozathoz kapcsolódik",
        DECISION_PURPOSE_ALREADY_EXISTS: "Ez a cél már létezik!",
        DECISION_TARGET_ALREADY_EXISTS: "Ez a helyszín már létezik!",
        DOCUMENT_SERIES_TYPE_CANNOT_BE_DELETED: "Ez a típus nem törölhető, mert egy sorozathoz kapcsolódik",
        DOCUMENT_SERIES_TYPE_ALREADY_EXISTS: "Ez a típus már létezik!",
        DUPLICATE_COMPLAIN_TYPE_NAME: "A megadott bejelentéstípus neve már létezik!",
        DUPLICATE_RESPONSE_TEMPLATE_NAME: "A megadott sablon neve már létezik!",
        INVALID_EMAIL: "Az e-mail cím érvénytelen",
        INVALID_CERTSIGN_ENROLLMENT: "Hiba történt az aláírási folyamat során, hiányzik az aláírói regisztráció.",
        REQUEST_ALREADY_CONFIRMED: "A kérelmet már aláírták",
        INVALID_TOKEN: "Sajnáljuk, hiba történt. Próbálja újra!",
        SOURCE_FILE_ID_MISSING_ERROR: "Sajnáljuk, a fájl feltöltése nem sikerült. Próbálja újra!",
        UAT_ALREADY_ASSIGNED: "A kiválasztott UAT már egy másik ügyintézőhöz van rendelve!",
        ERROR_VALIDATING_LAYER_CREATION_REQUEST: "Hiba történt, kérjük, próbálja újra",
        NOT_OK: "Hiba történt, ellenőrizze, hogy a dokumentumok alá vannak-e írva, és próbálja újra.",
        ARCHIVE_CONTENT_INVALID_FILES_BY_NAME: "Hiba történt, ellenőrizze a dokumentumcsomag nevét, és próbálja újra.",
        INVALID_FILE: "Hiba történt, a dokumentumcsomag kiterjesztésének .zip-nek kell lennie",
        AUTH_FAILED_ACCOUNT_LOCKED: "Sikertelen bejelentkezés. A fiók zárolva van. Próbálja újra {0} perc múlva",
        AUTH_DISABLED: "Bejelentkezési hiba, a fiók zárolva van vagy inaktív.",
        URBANISM_REQULATION_ZONE_NOT_UNIQUE: "Az övezet megnevezése (UAT-onként és célonként) nem egyedi.",
        AUTH_FAILED_PASSWORD_EXPIRED: "Az Ön jelszava lejárt, és meg kell változtatnia.",
        WORKFLOW_EXISTS: "Ilyen nevű folyamat már létezik",
        MISSING_SIGN_PLACEHOLDER: "Hiba történt az aláírási folyamat során, kérjük, próbálja újra.",
        INVALID_TARGET_FOR_SIGN_PLACEHOLDER: "Hiba történt az aláírási folyamat során, kérjük, próbálja újra.",
        MISMATCH_TARGET_FILES_AND_META: "Hiba történt az aláírási folyamat során, kérjük, próbálja újra.",
        CERTSIGN_SIGNING_ID_NOT_GENERATED: "Hiba történt az aláírási folyamat során, kérjük, próbálja újra.",
        PERMISSIONS_ARE_EQUAL_TO_CURRENT_RESPONSIBILITY: "A mentett jogosultságok megegyeznek az eredetiekkel.",
        TOO_MANY_FILES_OR_FILE_SIZE_EXCEEDED: "Elérte a fájlok maximális számát, vagy a dokumentum meghaladja a megengedett legnagyobb méretet.",
        CERTSIGN_INTERNAL_ERROR: "Hiba történt az aláírási folyamat során, kérjük, próbálja újra.",
        ERROR_INIT_SIGNING: "Hiba történt az aláírási folyamat indításakor, kérjük, próbálja újra.",
        ERROR_DOCUMENT_GENERATION: "Hiba történt, kérjük, próbálja újra később.",
        CANNOT_DELETE_FUNCTION_ASSOCIATED_USERS_EXIST: "Hiba történt a törlés során, a beosztáshoz felhasználók tartoznak.",
        CANNOT_DELETE_FUNCTION_ASSOCIATED_DEPARTMENTS_EXIST: "Hiba történt a törlés során, a beosztás egy osztályhoz van rendelve.",
        APPLICATION_NOT_SUBMITTED: "Hiba történt a benyújtási folyamat során, kérjük, próbálja újra.",
        ERROR_VALIDATING_RU_SCOPE_AND_UAT_ALREADY_EXISTS_FOR_SIMPLE_LAYER: "A kiválasztott UAT-hoz már létezik ilyen RU-cél.",
        ERROR_VALIDATING_CONTAINER_COMPONENT_MISMATCHED_RU_SCOPE: "Az RU-cél nem egyezik meg a Container RU-céljával.",
        ERROR_VALIDATING_RU_SCOPE_ALREADY_EXISTS_FOR_CONTAIANERS: "Az RU-cél már szerepel a Containerek listájában.",
        PDF_INVALID: "A fájl nem rendelkezik érvényes aláírással!",
        PDF_IS_ENCRYPTED: "A fájl nem rendelkezik érvényes aláírással, vagy titkosított!",
        ERROR_VALIDATING_PUBLISHED_LAYER_WAS_ALREADY_PUBLISHED: "A kiválasztott réteget már közzétették. ",
        DUPLICATE_DEPARTMENT_NAME: "Ilyen nevű osztály már létezik",
        CAN_NOT_USE_SYSTEM_FUNCTIONS: "Ilyen nevű rendszerbeosztás már létezik",
        FUNCTION_NAME_ALREADY_EXIST: "Ilyen nevű beosztás már létezik",
        INVALID_PDF_ERROR: "Az aláírás érvénytelen, kérjük, próbálja újra érvényes digitális aláírással.",
        PDF_READING_ERROR: "A fájlt nem sikerült beolvasni, kérjük, próbálja újra.",
        EMPTY_RESPONSIBILITIES: "A beosztáshoz nincsenek felelősségi körök rendelve.",
        REJECT_FORM_STAFF: "Ehhez a kérelemtípushoz hiányzik az elutasításhoz szükséges űrlapfelület vagy dokumentumsablon",
        ERROR_VALIDATING_TARGET_CONTAINER_IS_SYSTEM_LAYER: "Hiba a réteg közzétételekor, a forrásréteg rendszertípusú.",
        AUTH_SERVICE_UNAVAILABLE: "Hiba történt, kérjük, próbálja újra később.",
        ERROR_VALIDATING_LAYER_NAME_ALREADY_EXISTS: "A réteg megnevezése már használatban van.",
        THE_REQUEST_IS_NOT_VALID: "Hiba történt, kérjük, próbálja újra később.",
        EMPTY_TARGET_FILES: "Nincs generált dokumentum, a kérelem nem írható alá",
        ERROR_VALIDATING_ARCGIS_IMPORTED_ITEM_DOES_NOT_EXISTS: "A réteg nem érhető el, vagy nem létezik.",
        ERROR_VALIDATING_ARCGIS_IMPORTED_ITEM_INVALID: "A réteg azonosítója érvénytelen.",
        ERROR_VALIDATING_APPLICATION_TYPE_ALREADY_LINKED_TO_ANOTHER_LAYER: "A kiválasztott kérelemtípusok egyike már egy másik réteghez van rendelve.",
        FILE_NOT_EXISTS: "A törölni kívánt fájl nem létezik!",
        ERROR_MISSING_DOCUMENT_REJECTED_SERIES: "Ehhez a dokumentumhoz nincs beállítva sorozat!",
        INVALID_FORM_VALUE: "Az űrlapon megadott érték érvénytelen!",
        TOO_MANY_INTEREST_AREAS: "Elérte a meghatározható érdeklődési területek maximális számát.",
        TOO_MANY_CITIZEN_FEATURES: "Elérte a feltölthető rétegek maximális számát.",
        APPLICATION_TYPE_EXISTS: "Ilyen megnevezésű kérelemtípus már létezik",
        ERROR_DOWNLOAD_COMPRESSION: "Hiba történt a fájlok letöltése során, kérjük, próbálja újra.",
        APPLICATION_REQUEST_DENIED: "Nincs elegendő jogosultsága a kérelem megtekintéséhez",
        APPLICATION_ALREADY_SUBMITTED: "A kérelmet már benyújtották, nem menthető piszkozatként.",
        CANNOT_INIT_PAYMENT: "A fizetés nem indítható el.",
        USER_PROFILE_ALREADY_EXISTS: "Ilyen e-mail címmel már létezik felhasználó a rendszerben",
        BENEFICIARY_EMAIL_ALREADY_INVITED: "Az ezzel az e-mail címmel rendelkező kedvezményezettet már meghívták",
        UTILS_LINKS_CSV_PARSE_ERROR: "A hasznos linkek fájlja nem dolgozható fel",
        ANAF_VALIDATION: "Az ANAF adatbázisával történő ellenőrzés jelenleg nem érhető el, ezért a kedvezményezett az adatainak ellenőrzése nélkül került be a rendszerbe. Az ellenőrzés automatikusan megismétlődik, amikor a kedvezményezettet egy kérelemhez hozzáadják vagy szerkesztik.",
        EXCEEDED_MAX_COUNT: "A kiválasztott jelentés meghaladja a bejegyzések maximális számát, kérjük, módosítsa az időszakot vagy a típusok számát",
        AUTH_ROEID_ERROR: "Hiba történt a ROeID-hez való kapcsolódás során, kérjük, próbálja újra.",
        AUTH_STS_ERROR: "Hiba történt az STS-sel történő bejelentkezés során, kérjük, próbálja újra.",
        SERIES_TYPE_ID_NOT_FOUND_FOR_VIZA_TYPE_REJECTION_VIZA_SERIES_TYPE_ID: "Az ellenjegyzés elutasításához tartozó sorozat nincs beállítva! Kérjük, lépjen kapcsolatba a rendszergazdával.",
    },
    REQUESTS: {
        BUILDING: {
            DETAILS: "Ingatlan részletei",
            LAND: "Telek",
            LAND_CONSTRUCTIONS: "Telek + építmények",
            COUNTY: "Megye",
            LOCALITY: "Település",
            VILLAGE: "Falu",
            SECTOR: "Kerület",
            STREET: "Utca",
            POSTAL_CODE: "Irányítószám",
            NUMBER: "Házszám",
            STAIRCASE: "Lépcsőház",
            BLOCK: "Tömbház",
            FLOOR: "Emelet",
            APARTMENT: "Lakás",
            LAND_AREA: "Telek területe",
            OTHER_IDENTIFICATION: "Egyéb azonosító",
            CADASTRAL_NUMBER: "Kataszteri szám",
            ADD_CADASTRAL_NUMBER: "Kataszteri szám hozzáadása",
            REMOVE_CADASTRAL_NUMBER: "Kataszteri szám törlése",
        },
    },
    VALIDATION: {
        REQUIRED_FIELD: "Ez a mező kötelező!",
        NUMERIC_FIELD: "Ez a mező csak numerikus értékeket tartalmazhat!",
        EMAIL_FIELD: "Az e-mail cím érvénytelen",
        PHONE_FIELD: "A telefonszám érvénytelen",
        UPLOADED_FILE_SIZE: "A fájl mérete túl nagy",
        UPLOADED_FILE_SIZE_NAME: "A(z) {name} fájl mérete túl nagy",
        UPLOADED_FILE_TYPE: "A fájltípus nem támogatott",
        MAX_UPLOADED_FILES: "A megengedett fájlok maximális száma {max}. Még {amount} fájl tölthető fel.",
        PDF_FIELD: "A kiválasztott fájl kiterjesztésének .pdf-nek kell lennie.",
        MULTIPLE_FILES: "Egyes fájlokat nem sikerült feltölteni a kiterjesztésük vagy méretük miatt",
        ENTER_NUMBER: "Adjon meg egy számot",
    },
    PLACEHOLDERS: {
        MP: "m²",
    },
    INSTITUTION: {
        MAIN_HEADER: "Kiválasztott szervezet",
        PAGE_HEADER: "Szervezetek",
        LOGO_LABEL: "Logó",
        USEFUL_LINKS_CSV_UPLOAD_LABEL: "Hasznos információk",
        USEFUL_LINKS_CSV_UPLOAD_INFO: "Töltsön fel egy .csv fájlt a hasznos információkkal, a következő formátumban: <Nume, Link>",
        LIST: {
            TITLE: "Szervezetek listája",
        },
        FIELDS: {
            NAME: "Megnevezés",
            STATUS: "Állapot",
            COUNTY: "Megye",
            LOCALITY: "Település",
            TYPE: "Típus",
            UAT: "UAT",
            DESCRIPTION: "Leírás",
            IS_TEST: "Tesztszervezet",
            STAFF_USERS: "Ügyintéző",
            ORGANISATION: "Szervezet",
            LOGO: "Logó",
            EXTERNAL_LINK: "Külső link",
            IS_CITIZEN_VISIBLE: "Látható az állampolgár irányítópultján",
            UNIQUE_REGISTRATION_CODE: "CIF vagy CUI",
            LEGAL_REPRESENTATIVE_FUNCTION: "Beosztás",
            LEGAL_REPRESENTATIVE_NAME: "Név",
            ACCOUNT_BANK: "Bank",
            ACCOUNT_IBAN: "IBAN",
            ACCOUNT_ADDRESS: "Cím",
            ACCOUNT_PHONE: "Telefon",
            ACCOUNT_EMAIL: "E-mail",
            REMARKS: "Megjegyzések",
            NOTES: "Jegyzetek",
            ADDITIONAL_DETAILS: "További részletek",
            DETAILS_SECTION: "Szervezet adatai",
            LEGAL_REPRESENTATIVE_SECTION: "Törvényes képviselő adatai",
            ACCOUNT_SECTION: "Számla adatai",
            OTHER_INFO_SECTION: "Egyéb információk",
        },
        PLACEHOLDERS: {
            NAME: "Név",
            STATUS: "Állapot",
            DESCRIPTION: "Adja meg a szervezet leírását",
            IS_TEST: "Tesztszervezet",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
            IS_TEST: {
                YES: "Igen",
                NO: "Nem",
            },
        },
        MAIN_PAGE: {
            SEARCH: {
                PLACEHOLDER: "Szervezet keresése",
                ERASE_BUTTON: "Törlés",
            },
            TABLE_HEADER: {
                NAME: "Név",
                DESCRIPTION: "Leírás",
                STATUS: "Állapot",
                IS_TEST: "Tesztszervezet",
                ACTIONS: "Műveletek",
            },
            TOOLTIPS: {
                EDIT: "Szerkesztés",
                DELETE: "Törlés",
                FUNCTIONS: "Beosztások",
                DEPARTMENTS: "Osztályok",
                USERS: "Felhasználók",
                ACCOUNTS: "Gyűjtőszámlák",
                TAXES: "Díjak",
                RESPONSIBILITIES: "Felelősségi körök",
            },
            STATUS_TYPE: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
        },
        TABS: {
            DETAILS: "Részletek",
            FUNCTIONS: "Beosztások",
            DEPARTMENTS: "Osztályok",
            ORGANISATION_TREE: "Szervezeti ábra",
            TAXES: "Díjak",
            USERS: "Felhasználók",
            ACCOUNTS: "BT iPay-számlák",
            DOCUMENT_SERIES: "Iratsorozatok",
            DOCUMENT_REGISTERS: "Irattári regiszterek",
            RESONSIBILITIES: "Felelősségi körök",
            DECISIONS: "Határozatok",
            URBANISM_REGULATIONS: "Szabályozások",
            AI: "AI",
        },
        ADD_EDIT_FORM: {
            NAME: "Szervezet neve",
            TYPE: "Típus",
            DESCRIPTION: "Leírás",
            COUNTY: "Megye",
            CITY: "Település",
            STATUS_FIELD: "Állapot",
            TEST_INST: "Tesztszervezet",
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
            TYPES: {
                COUNTY_COUNCIL: "Megyei tanács",
                CITY_HALL: "Polgármesteri hivatal",
                SERVICES: "Szolgálatok",
            },
            PLACEHOLDER: "Adja meg a szervezet leírását",
        },
        ADD_MODAL: {
            HEADER: "Szervezet hozzáadása",
        },
        BUTTON: {
            ADD: "Hozzáadás",
            CANCEL: "Mégse",
            SAVE: "Mentés",
            UPDATE: "Módosítás",
        },
        FUNCTIONS: {
            SEARCH: {
                PLACEHOLDER: "Beosztás keresése",
                ERASE_BUTTON: "Törlés",
            },
            TABLE_HEADER: {
                NAME: "Beosztás neve",
                DESCRIPTION: "Leírás",
                ACTIONS: "Műveletek",
            },
            TOOLTIPS: {
                EDIT: "Szerkesztés",
                DELETE: "Törlés",
                USERS: "Felhasználók",
                RESPOSABILITIES: "Felelősségi körök hozzárendelése",
            },
        },
        ERRORS: {
            ORG: "Hiba történt az intézmények listájának betöltésekor!",
            SINGLE_ORG: "Hiba történt az intézmény adatainak betöltésekor!",
            FUNCTIONS: "Hiba történt a beosztások listájának betöltésekor!",
            UPDATE_ORG: "Hiba történt az intézmény módosításakor.",
            ADD_ORG: "Hiba történt az intézmény hozzáadásakor.",
            DELETE_ORG: "Ez az intézmény nem törölhető, mert hozzárendelt felhasználói vannak",
            PROTECTED_FIELDS: "A szervezet típusát, megyéjét, közigazgatási egységét (UAT) és tesztszervezet-jelölését csak szuperadminisztrátor módosíthatja.",
        },
        SUCCESS: {
            UPDATE_ORG: "Az intézmény sikeresen módosítva.",
            ADD_ORG: "Az intézmény sikeresen hozzáadva.",
            DELETE_ORG: "Az intézmény sikeresen törölve.",
        },
        ORG_SELECTION_FORM: {
            HEADER: "Aktív szervezet kiválasztása",
        },
        NAME_FORMAT: {
            COUNTY_COUNCIL_CLUJ: "Kolozs Megyei Tanács",
            CITY_HALL: "{name} Polgármesteri Hivatala",
        },
        ORGANISATION_TREE: {
            SEARCH: {
                PLACEHOLDER: "Osztály/szolgálat/részleg/beosztás/felhasználó keresése",
            },
            LEGEND: "Jelmagyarázat",
            COLLAPSE_ALL: "Összes összecsukása",
            EXPAND_ALL: "Összes kibontása",
            SHOW_INACTIVE: "Inaktívak megjelenítése",
            MODAL: {
                ADD_TITLE: "{parent} - {type} hozzáadása",
                EDIT_TITLE: "{node} - {type} szerkesztése",
            },
            TYPES: {
                COMPARTMENT: "részleg",
                SERVICE: "szolgálat",
                FUNCTION: "beosztás",
                USER: "felhasználó",
                DEPARTMENT: "osztály",
            },
            TOOLTIPS: {
                EDIT_DEPARTMENT: "Osztály szerkesztése",
                ADD_SERVICE: "Szolgálat hozzáadása",
                ADD_COMPARTMENT: "Részleg hozzáadása",
                EDIT_SERVICE: "Szolgálat szerkesztése",
                EDIT_COMPARTMENT: "Részleg szerkesztése",
                EDIT_USER: "Felhasználó szerkesztése",
            },
        },
    },
    INSTITUTION_AI: {
        LOAD_ERROR: "Az AI-beállításokat nem sikerült betölteni.",
        FIELDS: {
            API_KEY: "API-kulcs",
            MONTHLY_CAP_USD: "Havi keret (USD)",
            ALERT_EMAILS: "Értesítési e-mail címek",
            VALIDATED_AT: "Ellenőrizve",
        },
        PLACEHOLDERS: {
            API_KEY: "sk-ant-…",
            MONTHLY_CAP_USD: "Korlátlan keret",
            ALERT_EMAILS: "Nincs megadott e-mail cím",
        },
        KEY: {
            TITLE: "Anthropic API-kulcs",
            DESCRIPTION: "Az összes szervezet AI-fordításához használjuk. A költségeket a kulcshoz tartozó Anthropic-fiók fizeti.",
            STATUS_ACTIVE: "Aktív",
            STATUS_NOT_CONFIGURED: "Nincs beállítva",
            STATUS_UNREADABLE: "A kulcs nem olvasható",
            STATUS_REJECTED: "Elutasítva",
            DISABLED_TEXT: "Az AI-fordítás a kulcs mentéséig szünetel.",
            SAVE_AND_TEST: "Mentés és ellenőrzés",
            REPLACE: "Kulcs cseréje",
            REMOVE: "Kulcs törlése",
            REMOVE_CONFIRM: "Törli az API-kulcsot?",
            REJECTED: "Az Anthropic elutasította ezt a kulcsot. Nem történt mentés.",
            UNAVAILABLE: "A kulcsot most nem sikerült ellenőrizni (az Anthropic vagy a platform nem válaszol). Nem történt mentés, kérjük, próbálja újra.",
            INVALID_FORMAT: "A kulcs formátuma nem megfelelő (sk-ant-…).",
            UNREADABLE_HINT: "A mentett kulcsot nem lehet visszafejteni. Adja meg újra a kulcsot az AI újraindításához.",
            REJECTED_AUTH_HINT: "Az Anthropic elutasította a kulcsot (érvénytelen vagy visszavont). Adjon meg egy új kulcsot.",
            REJECTED_BILLING_HINT: "Az Anthropic-fiókban elfogyott a kredit. Töltse fel a fiókot, majd mentse el újra a kulcsot.",
            STORAGE_HINT: "A kulcsot az Anthropic ellenőrzi, és titkosítva tároljuk.",
            BUDGET_AFTER_KEY: "A keret és az értesítések a kulcs mentése után érhetők el.",
            SAVED: "A kulcs ellenőrizve és elmentve. Az AI aktív, az összes szervezet függőben lévő fordításait sorba állítottuk.",
            REMOVED: "Az API-kulcs törölve. Az AI minden szervezetnél leállt.",
        },
        BUDGET: {
            TITLE: "Keret és értesítések",
            DESCRIPTION: "Az AI minden szervezetnél leáll, amikor eléri a havi keretet. Értesítés 50%, 80% és 100% elérésekor.",
            NO_CAP_WARNING: "Havi keret nélkül a költés korlátlan, és nem küldünk értesítést.",
            INVALID_EMAIL: "Az egyik cím érvénytelen",
            EMAIL_LIMIT: "Legfeljebb {max} címet adhat meg",
            SPEND_THIS_MONTH: "E havi kiadások",
            SPEND_OF_CAP: "{spent} USD a(z) {cap} USD keretből",
            SAVED: "A keret és az értesítések elmentve.",
        },
        ERRORS: {
            FORBIDDEN: "Nincs hozzáférése az AI-beállításokhoz.",
            NOT_MANAGED: "Az AI-beállításokat a megyei tanács kezeli.",
            TOO_MANY_ATTEMPTS: "Túl sok próbálkozás. Próbálja újra néhány perc múlva.",
            UNCONFIRMED: "A módosítást nem sikerült megerősíteni (a platform nem válaszolt). A beállításokat újratöltöttük; ellenőrizze őket, és szükség esetén próbálja újra.",
        },
    },
    DEPARTMENTS: {
        PAGE_HEADER: "Osztályok",
        LIST: {
            TITLE: "Osztályok listája",
        },
        FIELDS: {
            NAME: "Megnevezés",
            STATUS: "Állapot",
            DESCRIPTION: "Leírás",
        },
        PLACEHOLDERS: {
            NAME: "Név",
            STATUS: "Állapot",
            DESCRIPTION: "Leírás",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
        },
        TABLE_HEADER: {
            NAME: "Osztály/szolgálat neve",
            DESCRIPTION: "Leírás",
            STATUS: "Állapot",
            ACTIONS: "Műveletek",
        },
        TOOLTIPS: {
            FUNCTIONS: "Beosztások hozzárendelése",
            USERS: "Felhasználók",
        },
        ADD_EDIT_MODAL: {
            HEADER: {
                ADD: "Osztály hozzáadása",
                EDIT: "Osztály szerkesztése",
            },
            NAME: "Osztály neve",
            DESCRIPTION: "Leírás",
            STATUS: "Állapot",
            STATUS_TYPE: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
            TYPES: {
                COUNTY_COUNCIL: "Megyei tanács",
                CITY_HALL: "Polgármesteri hivatal",
                SERVICES: "Szolgálatok",
            },
            PLACEHOLDER: "Adja meg az osztály leírását",
        },
        ASSOCIATED_FCT_MODAL: {
            HEADER: "Beosztások hozzárendelése",
            ERRORS: {
                LIST: "Hiba történt a hozzárendelt beosztások listájának betöltésekor!",
                ADD_FUNCTION: "Hiba történt a beosztás osztályhoz való hozzáadásakor.",
            },
        },
        ASSOCIATED_USERS_MODAL: {
            HEADER: "Felhasználók hozzárendelése",
            ERRORS: {
                LIST: "Hiba történt a hozzárendelt felhasználók listájának betöltésekor!",
                ADD_FUNCTION: "Hiba történt a felhasználó osztályhoz való hozzáadásakor.",
            },
        },
        ERRORS: {
            DEP_LIST: "Hiba történt az osztályok listájának betöltésekor!",
            ADD: "Hiba történt az osztály hozzáadásakor.",
            UPDATE: "Hiba történt az osztály módosításakor.",
        },
        SUCCESS: {
            ADD: "Az osztály sikeresen hozzáadva.",
            UPDATE: "Az osztály sikeresen módosítva.",
        },
        BUTTON: {
            ADD_DEPARTMENT: "Osztály hozzáadása",
        },
    },
    FUNCTIONS: {
        PAGE_HEADER: "Beosztások",
        LIST: {
            TITLE: "Beosztások listája",
            SYSTEM_FUNCTIONS: "A következő beosztásokat a rendszer automatikusan hozza létre: {systemFunctions}.",
        },
        FIELDS: {
            NAME: "Megnevezés",
            ALIAS: "Alias",
            DESCRIPTION: "Leírás",
        },
        PLACEHOLDERS: {
            NAME: "Név",
            DESCRIPTION: "Leírás",
        },
        ASSOCIATED_RESPOSABILITIES_MODAL: {
            HEADER: "Felelősségi körök hozzárendelése",
            BODY: {
                TOP: "Beosztás",
            },
        },
        ADD_EDIT_FORM: {
            HEADER_ADD: "Beosztás hozzáadása",
            HEADER_EDIT: "Beosztás szerkesztése",
            NAME: "Megnevezés",
            NAME_DESCRIPTION: "Adjon meg egy aliast is. Ez jelenik meg az aláíráson.",
            ALIAS: "Alias",
            DESCRIPTION: "Leírás",
            PLACEHOLDER: "Adja meg a beosztás leírását",
            ALIAS_PLACEHOLDER: "Adja meg a beosztás aliasát.",
            SYSTEM_FUNCTIONS: "A rendszer által létrehozott beosztások nem szerkeszthetők.",
        },
        SUCCESS: {
            ADD: "A beosztás sikeresen hozzáadva.",
            UPDATE: "A beosztás sikeresen módosítva.",
            DELETE: "A beosztás sikeresen törölve.",
        },
        BUTTON: {
            ADD_FUNCTION: "Beosztás hozzáadása",
        },
    },
    TERRITORIAL_UNIT_ALLOCATION: {
        HEADER: "UAT kiosztása",
        FIELDS: {
            TU_NAME: "Megnevezés",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
        },
        PLACEHOLDERS: {
            TU_NAME: "Név",
        },
        MODAL: {
            HEADER: "UAT hozzáadása",
            OBS: "A már kiosztott UAT-ok nem jelennek meg a listában",
        },
        BUTTON: {
            ADD_UAT: "UAT hozzáadása",
        },
        TABLE_EMPTY_TEXT: "Ehhez a felhasználóhoz nincs kiosztott UAT.",
    },
    ADMIN_USERS_MODAL: {
        HEADER: "Felhasználói fiókok listája",
        PLACEHOLDER: "Felhasználó keresése",
        TABLE_HEADER: {
            LAST_NAME: "Vezetéknév",
            FIRST_NAME: "Keresztnév",
            FUNCTION: "Beosztás",
            STATUS: "Állapot",
            STATUS_ACTIVE: "Aktív",
            STATUS_INACTIVE: "Inaktív",
        },
        FUNCTIONS: {
            ERRORS: {
                LIST: "Hiba történt a beosztáshoz tartozó felhasználók listájának generálásakor!",
            },
        },
        DEPARTMENTS: {
            ERRORS: {
                LIST: "Hiba történt az osztályhoz tartozó felhasználók listájának generálásakor!",
            },
        },
    },
    ACCOUNTS: {
        BUTTONS: {
            ADD_ACCOUNT: "Fiók hozzáadása",
            CANCEL: "Mégse",
            INVITE: "Meghívás e-mailben",
            RESEND_LINK: "Link újraküldése",
            SAVE: "Mentés",
        },
        ENUMS: {
            ROLES: {
                ADMINISTRATOR: "Adminisztrátor",
                EDITOR: "Szerkesztő",
            },
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
                PENDING: "Elküldve",
            },
        },
        FIELDS: {
            CREATED_BY_NAME: "Létrehozta",
            EMAIL: "E-mail",
            FIRST_NAME: "Keresztnév",
            LAST_NAME: "Vezetéknév",
            PHONE: "Telefon",
            STATUS: "Állapot",
            ROLE: "Szerepkör",
            USER_NAME: "Név",
        },
        LABELS: {
            CREATED_BY: "Létrehozta",
            USER: "Felhasználó",
        },
        LIST: {
            ACTIONS: "Műveletek",
            EDIT: "Szerkesztés",
            HEADER: "Kapcsolt fiókok",
        },
        MODALS: {
            EDIT_ACCOUNT: "Fiók szerkesztése",
            ADD_NEW_ACCOUNT: "Új fiók hozzáadása",
        },
        NOTIFIERS: {
            EDITED_SUCCESS: "A fiók frissítve!",
            INVITE_TEXT: "A meghívót sikeresen elküldtük a(z) <strong>{email}</strong> e-mail címre. A fiók az érvényesítést követően megjelenik a szervezetben",
            INVITE_TITLE: "Meghívó elküldve",
            RESEND_SUCCESS: "A link újraküldve!",
        },
        PLACEHOLDERS: {
            CHOOSE: "Válasszon",
            ROL: "Szerepkör",
            SEARCH_NAME: "Név keresése",
            STATUS: "Állapot",
        },
        TITLE: "Fiókok kezelése",
    },
    COLLECTOR_ACCOUNTS: {
        PAGE_HEADER: "BT iPay-számlák",
        LIST: {
            TITLE: "BT iPay-számlák listája",
        },
        FIELDS: {
            NAME: "Számla megnevezése",
            BANK: "Bank",
            USERNAME: "BT iPay-felhasználónév",
            PASSWORD: "BT iPay-jelszó",
            STATUS: "Állapot",
        },
        PLACEHOLDERS: {
            NAME: "Számla megnevezése",
            BANK: "Bank",
            USERNAME: "BT iPay-felhasználónév",
            PASSWORD: "BT iPay-jelszó",
            STATUS: "Állapot",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
        },
        TABLE_HEADER: {
            NAME: "Számla megnevezése",
            BANK: "Bank",
            USERNAME: "BT iPay-felhasználónév",
            PASSWORD: "BT iPay-jelszó",
            STATUS: "Állapot",
            ACTIONS: "Műveletek",
        },
        STATUS_TYPE: {
            ACTIVE: "Aktív",
            INACTIVE: "Inaktív",
        },
        TOOLTIPS: {
            EDIT: "Szerkesztés",
            DELETE: "Törlés",
        },
        MANAGE_ACCOUNT_MODAL: {
            HEADER: {
                EDIT: "BT iPay-számla szerkesztése",
                ADD: "BT iPay-számla hozzáadása",
            },
            FORM: {
                NAME: "Megnevezés",
                BANK: "Bank",
                USERNAME: "BT iPay-felhasználónév",
                PASSWORD: "BT iPay-jelszó",
                STATUS: "Állapot",
            },
        },
        CONFIRMATION_MESSAGE: "Biztos törli a gyűjtőszámlát?",
        SUCCESS: {
            DELETE: "A gyűjtőszámla sikeresen törölve.",
            ADD: "A gyűjtőszámla sikeresen hozzáadva.",
            UPDATE: "A gyűjtőszámla sikeresen módosítva.",
        },
        BUTTON: {
            ADD_COLLECTOR_ACCOUNT: "Számla hozzáadása",
        },
    },
    BENEFICIARIES: {
        DGEVP: {
            CONNECT: "Csatlakozás",
            CONNECT_TITLE: "Csatlakozás a DGEVP-hez",
            VALIDATE: "Érvényesítés",
            INFO: "DGEVP-információ: Biztonsági okokból ez a tartalom csak azon felhasználók számára érhető el, akik IP-alapú hozzáférést kaptak a DGEVP-től.",
        },
        BUTTONS: {
            ADD_ACCOUNT: "Kedvezményezett hozzáadása",
            CANCEL: "Mégse",
            SAVE: "Mentés",
        },
        FIELDS: {
            BENEFICIARY: "Kedvezményezett",
            IDENTIFIER: "Név, CNP vagy CIF",
            CREATED_BY_NAME: "Létrehozta",
            EMAIL: "E-mail",
            FIRST_NAME: "Keresztnév",
            LAST_NAME: "Vezetéknév",
            ID_CARD_SERIAL: "Sz. ig. sorozat",
            ID_CARD_NUMBER: "Sz. ig. szám",
            ID_CARD_EXPIRATION_DATE: "Lejárati dátum",
            ID_CARD_ISSUED_DATE: "Kiállítás dátuma",
            ID_CARD_ISSUER: "Kiállította",
            PHONE: "Telefon",
            STATUS: "Állapot",
            ROLE: "Szerepkör",
            USER_TYPE: "Személy típusa",
            PERSONAL_NUMERIC_CODE: "CNP",
            USER_NAME: "Név",
            LOCALITY: "Megyei jogú város / Város / Község",
            PAYMENT: "Fizetés",
            EMPLACEMENT_LOCALITY: "Település",
            USER_TYPE_NAME: "Személy típusa",
            COUNTY: "Megye",
            VILLAGE: "Település",
            SECTOR: "Kerület",
            STREET: "Utca",
            STREET_NUMBER: "Házszám",
            POSTAL_CODE: "Irányítószám",
            STAIRCASE: "Lépcsőház",
            BLOCK: "Tömbház",
            FLOOR: "Emelet",
            APARTMENT: "Lakás",
            USE_PROFILE_DATA: "Profiladatok használata",
            PASSPORT_NUMBER: "Útlevélszám",
            CITY: "Város",
            ADDRESS: "Cím",
            LICENSE: "Licenc",
            COMPANY_NAME: "Entitás megnevezése",
            IBAN: "IBAN-számla",
            BANK: "Számlavezető bank",
            UNIQUE_REGISTRATION_CODE: "CIF vagy CUI",
            REGISTRATION_NUMBER: "Cégjegyzékszám",
            USERNAME: "Felhasználónév",
            PASSWORD: "Jelszó",
        },
        LABELS: {
            CREATED_BY: "Létrehozta",
            USER: "Felhasználó",
        },
        LIST: {
            ACTIONS: "Műveletek",
            EDIT: "Szerkesztés",
            HEADER: "Kedvezményezettek",
            DELETE: "Törlés",
        },
        MODALS: {
            EDIT_ACCOUNT: "Kedvezményezett szerkesztése",
            ADD_NEW_ACCOUNT: "Új kedvezményezett hozzáadása",
        },
        NOTIFIERS: {
            ADDED_SUCCESS: "A kedvezményezett hozzáadva!",
            EDITED_SUCCESS: "A kedvezményezett frissítve!",
            DELETE_SUCCESS: "A kedvezményezett sikeresen törölve!",
        },
        PLACEHOLDERS: {
            CHOOSE: "Válasszon",
            ROL: "Szerepkör",
            SEARCH_NAME: "Keresés név szerint",
            STATUS: "Állapot",
        },
        TITLE: "Kedvezményezettek kezelése",
        SUCCESS: {
            DELETE: "A kedvezményezett sikeresen törölve!",
        },
    },
    TAX_CATEGORY: {
        LIST: {
            TITLE: "Díjkategóriák",
        },
        FILTER: {
            TITLE: "Díjkategóriák",
        },
        ADD_BUTTON: "Új kategória",
        FIELDS: {
            NAME: "Megnevezés",
            STATUS: "Állapot",
        },
        FORM: {
            EDIT_TITLE: "Kategória szerkesztése",
            ADD_TITLE: "Új kategória",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
            STATUS: "Állapot",
        },
    },
    COMPLAIN_TYPE: {
        LIST: {
            TITLE: "Bejelentéstípusok",
        },
        ADD_BUTTON: "Új típus",
        FIELDS: {
            NAME: "Megnevezés",
            STATUS: "Állapot",
            COMPLAIN_DOCUMENT_SERIES_TYPE: "Iratsorozat típusa",
            TENANT_ID: "Szervezet",
        },
        FORM: {
            EDIT_TITLE: "Bejelentéstípus szerkesztése",
            ADD_TITLE: "Új bejelentéstípus",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
            STATUS: "Állapot",
        },
    },
    COMPLAIN: {
        LIST: {
            TITLE: "Bejelentések",
            TABLE_HEADER: "Bejelentések előzményei",
            ADD_BUTTON: "Új bejelentés",
            NO_ASSIGNEE: "Nincs kijelölve",
        },
        STAFF_LIST: {
            TITLE: "Bejelentések",
            TABLE_HEADER: "Bejelentések",
            ADD_BUTTON: "Új ellenőrzés",
        },
        FIELDS: {
            COMPLAIN_TYPE: "Bejelentés típusa",
            LOCALITY: "Település",
            ADDRESS: "Cím",
            ADDRESS_DETAILS: "Helyszín további részletei",
            DESCRIPTION: "Bejelentés leírása",
            FIRST_NAME: "Keresztnév",
            LAST_NAME: "Vezetéknév",
            EMAIL: "E-mail",
            PHONE: "Telefon",
            STATUS: "Állapot",
            REPORTED_BY: "Létrehozta",
            REPORTED_FOR: "Kapcsolattartó",
            IDENTIFICATION_NUMBER: "Bejövő iktatószám",
            CREATED_DATE: "Dátum",
            USE_PROFILE_DATA: "Profilom adatainak használata",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            MESSAGE_COMMENT: "Az Ön üzenete",
            RESPONSE_TEMPLATES: "Válaszsablonok",
            DISMISSED_COMMENT: "Sablonüzenet",
            UAT: "Megyei jogú város / Város / Község",
            ASSIGNED_TO: "Megoldotta",
        },
        FORM: {
            TITLE: "Új bejelentés űrlapja",
            TITLE_CLASSIFY: "Bejelentés irattárazása",
            TITLE_RESOLVED: "Bejelentés megoldása",
            COMPLAIN_DETAIL_SECTION_TITLE: "Bejelentés részletei",
            USER_DETAIL_SECTION_TITLE: "Kapcsolattartó adatai",
            ATLAS_PREVIEW_SECTION_TITLE: "Helyszín",
            DOCUMENTS_SECTION_TITLE: "Dokumentumok / fényképek feltöltése",
            VIEW_DOCUMENTS_SECTION_TITLE: "Dokumentumok / fényképek megtekintése",
            UPLOAD_DOCUMENT_BUTTON: "Dokumentum feltöltése",
            SUBMIT_BUTTON: "Bejelentés elküldése",
            VIEW_GOOGLE_MAPS_BUTTON: "Megtekintés a Google Mapsben",
            CLASSIFY_BUTTON: "Irattárazás",
            RESOLVED_BUTTON: "Megoldás",
            EMPTY_DOCUMENT_LABEL: "Nincsenek csatolt dokumentumok",
            RESOLVE_BUTTON: "Válasz küldése - Megoldva",
            RESPONSE: "Válasz a bejelentésre",
            PREVIEW_TITLE: "Értesítés előnézete",
            NOTIFICATION_TEMPLATE_TEXT: "A(z) '{type}' típusú, {number} egyedi iktatószámú bejelentés, amelyet {user} hozott létre, irattárazásra került a Ghișeul Unic platformon, az alábbi indokkal:",
            FILE_PLACEHOLDER_NAME: "{0}. fájl",
        },
        TABS: {
            COMPLAIN: "Bejelentés",
            DISCUSSIONS: "Tevékenységek",
        },
        PLACEHOLDERS: {
            DESCRIPTION: "Az Ön üzenete",
            STATUS: "Állapot",
            REPORTED_BY: "Létrehozta",
            REPORTED_FOR: "Kapcsolattartó",
            LOCALITY: "Település",
            IDENTIFICATION_NUMBER: "Keresés kód alapján",
            ASSIGNED_TO: "Megoldotta",
        },
        ENUMS: {
            STATUS: {
                NEW: "Iktatva",
                PENDING: "Feldolgozás alatt",
                RESOLVED: "Megoldva",
                REJECTED: "Elutasítva",
                DISMISSED: "Irattárazva",
            },
        },
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "Bejelentés elküldve",
            CREATED_SUCCESS_TEXT: "A(z) <strong>{number}</strong> számú bejelentés sikeresen elküldve.</br> Az elemzést és ellenőrzést követően értesítjük a bejelentés megoldásáról.",
            CLASSIFICATION_MESSAGE: "Biztos irattárazza a bejelentést?",
            CLASSIFICATION_SUCCESS_TEXT: "A bejelentés irattárazásra került.",
            RESOLVE_MESSAGE: "Biztos megoldottnak jelöli a bejelentést?",
            RESOLVE_SUCCESS_TEXT: "A bejelentés megoldásra került.",
            LOCATION_TITLE: "Hiányzó helyszín!",
            LOCATION_TEXT: "Kérjük, válassza ki a térképen a bejelentés helyszínét/települését a bejelentés benyújtásához.",
        },
    },
    FORM_FIELDS: {
        SAVE_BTN: "Mentés",
        INVITE_BTN: "Meghívás e-mailben",
        CANCEL_BTN: "Mégse",
        FIRST_NAME: "Keresztnév",
        LAST_NAME: "Vezetéknév",
        FULL_NAME: "Teljes név",
        EMAIL: "E-mail",
        PHONE: "Telefon",
        DEPARTMENT: "Osztály",
        ORGANISATION: "Intézmény",
        ROLE: "Szerepkör",
        TAG_ID: "Igazolvány száma",
        TAG_RELEASED_BY: "Igazolványt kiállította",
        EXTERNAL_ENROLLMENT_ID: "Külső ID (aláírói regisztráció)",
        FUNCTION: "Beosztás",
        RESPONSIBILITIES: "Felelősségi körök",
        PERMISSIONS: "Jogosultságok",
        STATUS: "Állapot",
        IS_ORGANISATION_ADMIN: "Szervezeti adminisztrátor",
        MESSAGES: {
            ACCOUNT_CREATED: "A fiók létrehozva",
            ACCOUNT_UPDATED: "A fiók módosítva",
            ACCOUNT_NOT_CREATED: "Hiba történt a fiók létrehozása során",
            ACCOUNT_NOT_UPDATED: "Hiba történt a fiók módosítása során",
            NO_FUNCTIONS_SELECTED: "Nincs kiválasztott beosztás",
            ASSIGNMENT_NO_FUNCTIONS: "A(z) {assignmentNumber} számú kiosztásnál ({departmentName}) legalább egy beosztást ki kell választani.",
            ASSIGNMENTS_NO_FUNCTIONS: "A következő kiosztásoknál legalább egy beosztást ki kell választani: {assignmentDetails}",
            NO_ASSIGNMENTS: "Nincs hozzáadott kiosztás.",
        },
        ASSIGNED_TERRITORIAL_ADMINISTRATIVE_UNIT: "Kiosztott UAT-ok",
        SERVICE: "Szolgálat",
        COMPARTMENT: "Részleg",
        SERVICE_COMPARTMENT: "Szolgálaton belüli részleg",
        FUNCTIONS: "Beosztások",
        SELECTED_FUNCTIONS_SUMMARY: "Beosztások",
        DEPARTMENT_FUNCTIONS: "Osztály beosztásai",
        ASSIGNMENT: "Válasszon a meglévő kiosztások közül",
        ALREADY_ASSIGNED: "Már kiosztva",
        SERVICES: "Szolgálatok",
        SERVICE_FUNCTIONS: "Szolgálat beosztásai",
        COMPARTMENTS: "Részlegek",
        COMPARTMENT_FUNCTIONS: "Részleg beosztásai",
        SERVICE_COMPARTMENTS: "Szolgálat alá tartozó részlegek",
        SERVICE_COMPARTMENTS_SECTION_TITLE: "Szolgálatok alá tartozó részlegek",
        SERVICE_COMPARTMENT_FUNCTIONS: "Szolgálati részleg beosztásai",
        NO_COMPARTMENTS_AVAILABLE: "Nincs elérhető részleg",
        NO_DEPARTMENTS_AVAILABLE: "Nincs elérhető osztály",
        NO_SERVICES_AVAILABLE: "Nincs elérhető szolgálat",
        NO_FUNCTIONS_AVAILABLE: "Nincs elérhető beosztás",
        NO_SERVICE_COMPARTMENTS_AVAILABLE: "Nincs elérhető szolgálati részleg",
        NO_DEPARTMENT_FUNCTIONS_AVAILABLE: "Nincs elérhető beosztás az osztályon",
        NO_SERVICE_FUNCTIONS_AVAILABLE: "Nincs elérhető beosztás a szolgálatnál",
        NO_COMPARTMENT_FUNCTIONS_AVAILABLE: "Nincs elérhető beosztás a részlegen",
        NO_SERVICE_COMPARTMENT_FUNCTIONS_AVAILABLE: "Nincs elérhető beosztás a szolgálati részlegen",
        PERSONAL_INFORMATION: "Személyes adatok",
        IDENTIFICATION_AND_ORGANIZATION: "Szervezet részletei",
        ORGANIZATIONAL_ASSIGNMENTS: "Szervezeti kiosztások",
        DEPARTMENT_AND_STRUCTURE: "Osztály felépítése",
        FUNCTIONS_AND_ROLES: "Beosztások kiosztása az osztályon",
        FUNCTIONS_AND_ROLES_STAFF: "Beosztások az osztályon",
        SELECT_SERVICES: "Válasszon szolgálatokat",
        SELECT_COMPARTMENTS: "Válasszon részlegeket",
        SELECT_SERVICE_COMPARTMENTS: "Válasszon a szolgálat alá tartozó részlegek közül",
        NO_DEPARTMENT: "Nincs kiválasztott osztály",
        NO_RESPONSIBILITIES: "Nincs elérhető felelősségi kör",
        NO_TERRITORIAL_UNITS: "Nincs kiosztott UAT",
    },
    FUNCTIONARY: {
        LIST: {
            TITLE: "Ügyintézők listája",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
                PENDING: "Függőben",
            },
        },
        FIELDS: {
            FIRST_NAME: "Keresztnév",
            LAST_NAME: "Vezetéknév",
            EMAIL: "E-mail",
            STATUS: "Állapot",
            FULL_NAME: "Teljes név",
            DEPARTMENTS: "Osztályok",
            SERVICES: "Szolgálatok",
            COMPARTMENTS: "Részlegek",
            SERVICE_COMPARTMENTS: "Alrészlegek",
            FUNCTIONS: "Beosztások",
            ACCOUNT_TYPE: "Fióktípus",
            ADMIN: "Adminisztrátor",
            STAFF: "Ügyintéző",
        },
        PLACEHOLDERS: {
            EMAIL: "E-mail",
            STATUS: "Állapot",
            FULL_NAME: "Teljes név",
            DEPARTMENTS: "Osztály",
            FUNCTIONS: "Beosztás",
            SERVICES: "Szolgálat",
            COMPARTMENTS: "Részleg",
            SERVICE_COMPARTMENTS: "Alrészleg",
            LAST_NAME: "Vezetéknév",
        },
        HEADER_LIST: "Ügyintézői fiókok kezelése",
        ADD_BTN: "Fiók hozzáadása",
        ADD_ACCOUNT_HEADER: "Új fiók hozzáadása",
        EDIT_ACCOUNT_HEADER: "Fiók szerkesztése",
        TABLE_HEADER: {
            ACTIONS: "Műveletek",
        },
        DELETE_ACCOUNT_MESSAGE: "Biztos törli az ügyintézői fiókot?",
        DELETED_ACCOUNT_SUCCESS: "A fiók törölve",
        RESET_PASS_SUCCESS: "Jelszó-visszaállítási linket küldtünk a(z) <strong>{email}</strong> e-mail-címre.",
        CHANGE_STATUS_SUCCESS: "A fiók állapota módosítva",
        DENY_DELETE_ACCOUNT: "A fiók nem törölhető",
        CHANGE_ACCOUNT_STATUS: "<p>Biztos módosítja a fiók állapotát?<p><small>Jelenlegi állapot: <b>{status}</b></small>",
        RESET_PASSWORD: "Jelszó visszaállítása",
        RESET_PASSWORD_CONFIRM: "Biztos visszaállítja a jelszót?",
        CHANGE_ACCOUNT_STATUS_ACTION: "Fiók aktiválása/deaktiválása",
        DENY_RESET_PASSWORD: "Inaktív fiók jelszava nem állítható vissza",
        PERMISSIONS_TOOLTIP: "Jogosultságok",
        PERMISSIONS: {
            HEADER: "Jogosultságok listája",
            FILTER_PLACEHOLDER: "Keresés megnevezés szerint",
            PERMISSION_NAME_LABEL: "Megnevezés",
        },
        TOOLTIPS: {
            TERRITORIAL_UNIT_ALLOCATION: "UAT-ok hozzáadása/törlése",
        },
        UNKNOWN: {
            SERVICE: "Ismeretlen szolgálat",
            SERVICE_COMPARTMENT: "Ismeretlen alrészleg",
            COMPARTMENT: "Ismeretlen részleg",
        },
    },
    RESPONSE_TEMPLATES: {
        LIST: {
            TITLE: "Válaszsablonok",
            ACTIONS: "Műveletek",
        },
        ADD_BUTTON: "Sablon hozzáadása",
        FIELDS: {
            TITLE: "Cím",
            CATEGORY: "Kategória",
            MESSAGE: "Sablon üzenete",
        },
        FORM: {
            EDIT_TITLE: "Sablon szerkesztése",
            ADD_TITLE: "Sablon hozzáadása",
        },
        ENUMS: {
            CATEGORY: {
                COMPLAINS: "Bejelentések",
                APPLICATIONS: "Kérelmek",
                NOTICE: "Láttamozások",
            },
        },
        PLACEHOLDERS: {
            TITLE: "Keresés cím szerint",
            CATEGORY: "Kategória",
            MESSAGE: "Sablon üzenete",
        },
        CATEGORY: {
            COMPLAINS: "bejelentés",
            APPLICATIONS: "kérelem",
            NOTICE: "láttamozás",
        },
    },
    TRANSLATIONS: {
        LIST: {
            TITLE: "Fordítások",
            ACTIONS: "Műveletek",
            OVERRIDE: "Kézi javítás",
            RETRANSLATE: "Újrafordítás",
            RETRANSLATE_SELECTED: "Újrafordítás ({count})",
        },
        FIELDS: {
            NAMESPACE: "Terület",
            ENTITY_ID: "Entitás",
            PATH: "Mező",
            SOURCE_TEXT: "Forrás (RO)",
            TEXT: "Fordítás",
            CONTENT: "Szövegkeresés",
            LANGUAGE: "Nyelv",
            STATUS: "Állapot",
            ORIGIN: "Eredet",
            TRANSLATED_AT: "Frissítve",
            SOURCE_TERM: "Forráskifejezés (RO)",
            TARGET_TERM: "Lefordított kifejezés",
            NOTES: "Megjegyzések",
            TERM: "Kifejezés",
            UPDATED_AT: "Frissítve",
        },
        PLACEHOLDERS: {
            NAMESPACE: "Terület",
            ENTITY_ID: "Entitás-azonosító",
            CONTENT: "Keresés a forrásban és a fordításban",
            LANGUAGE: "Nyelv",
            STATUS: "Állapot",
            ORIGIN: "Eredet",
            SOURCE_TERM: "Forráskifejezés",
            TARGET_TERM: "Lefordított kifejezés",
            NOTES: "Megjegyzések",
            TERM: "Kifejezés keresése",
        },
        ENUMS: {
            LANGUAGE: {
                HU: "Magyar",
                EN: "Angol",
            },
            STATUS: {
                PUBLISHED: "Közzétéve",
                STALE: "Elavult",
                FAILED: "Sikertelen",
                UNTRANSLATABLE: "Nem fordítható",
                NO_API_KEY: "Nincs API-kulcs",
            },
            ORIGIN: {
                MACHINE: "Automatikus",
                HUMAN: "Kézi",
            },
        },
        OVERRIDE: {
            TITLE: "Kézi javítás",
            NOTE: "A kézi javítást az automatikus újrafordítás soha nem írja felül.",
            SUCCESS: "A fordítás javítva.",
            REJECTED: "A fordítást nem sikerült menteni: {reason}",
            SOURCE_LABEL: "Forrásszöveg (RO)",
            TEXT_LABEL: "Fordítás",
        },
        RETRANSLATE: {
            QUEUED: "Az újrafordítás ütemezve.",
            QUEUED_COUNT: "Újrafordításra ütemezve: {count}.",
            PARTIALLY_FAILED: "Újrafordításra ütemezve: {queued}. Nem sikerült ütemezni: {failed}.",
        },
        GLOSSARY: {
            TITLE: "Fordítási szószedet",
            ADD_BUTTON: "Kifejezés hozzáadása",
            RETRANSLATE_ALL_BUTTON: "Összes újrafordítása",
            FUTURE_ONLY_NOTE: "A szószedet módosításai csak a jövőbeli fordításokat érintik. A meglévő fordítások az újrafordításig változatlanok maradnak.",
            FORM: {
                ADD_TITLE: "Kifejezés hozzáadása",
                EDIT_TITLE: "Kifejezés szerkesztése",
            },
            RETRANSLATE_MODAL: {
                TITLE: "Összes űrlap újrafordítása",
                SCOPE_LABEL: "Újrafordítandó nyelvek",
                ONLY_LANGUAGE: "Csak {language}",
                BOTH_LANGUAGES: "Mindkét nyelv",
                COST_ESTIMATE: "Becsült költség {forms} űrlap esetén: ~{cost} USD.",
                COST_UNAVAILABLE: "A becsült költség jelenleg nem érhető el.",
                CONFIRM: "Újrafordítás indítása",
            },
        },
        DASHBOARD: {
            TITLE: "Fordítási irányítópult",
            CATALOGUE_COVERAGE: "Katalógus lefedettsége — {language}",
            FORMS_OPTED_IN: "Fordítható űrlapok",
            SPEND: "E havi kiadások",
            SPEND_OF_CAP: "{spent} USD a(z) {cap} USD keretből",
            USAGE_UNAVAILABLE: "Az AI-használati adatok jelenleg nem érhetők el.",
            STATUS_BREAKDOWN: "Állapotok nyelvenként",
            SPEND_PANEL: "AI-használat",
            REQUESTS: "Kérések",
            REFUSED: "Elutasított",
            CACHE_HIT: "Gyorsítótár-találat",
            BY_PURPOSE: "Cél szerint",
            PURPOSE: {
                BACKFILL: "Kezdeti fordítás",
                CHURN: "Tartalomfrissítések",
                LAZY_FILL: "Igény szerint",
            },
            BY_LANGUAGE: "Nyelvenként",
            NO_DATA: "—",
        },
    },
    TAXES: {
        BUTTONS: {
            ADD_TAX: "Díj hozzáadása",
        },
        FIELDS: {
            NAME: "Megnevezés",
            ENTRY_DATE: "Hatálybalépés dátuma",
            JUSTIFICATION: "HCL/SZÁM/DÁTUM",
            CATEGORY: "Kategória",
            FIXED_VALUE: "Fix érték",
            PERCENTAGE_VALUE: "Százalékos érték",
            PRICE_CALCULATION_MODEL: "Számítás típusa",
            START: "Kezdet",
            END: "Vég",
            VALUE: "Érték",
        },
        LABELS: {},
        LIST: {
            ACTIONS: "Műveletek",
            EDIT: "Szerkesztés",
            HEADER: "Díjak listája",
        },
        MODALS: {
            ADD_TITLE: "Díj hozzáadása",
            EDIT_TITLE: "Díj szerkesztése",
            HCL: "HCL / Egyéb indoklás",
            ADD: "Hozzáadás",
            SAVE: "Mentés",
            CANCEL: "Mégse",
        },
        NOTIFIERS: {
            SAVED: "A díj sikeresen mentve",
            EDITED: "A díj sikeresen frissítve",
            INVALID_RANGES: "Az intervallumok vagy az értékek érvénytelenek",
        },
        PLACEHOLDERS: {
            NAME: "Megnevezés",
            CATEGORY: "Kategória",
        },
        ENUMS: {
            PRICE_CALCULATION_MODEL: {
                FIXED: "Fix",
                RANGE: "Intervallumok",
                MIXED: "Vegyes",
                PERCENTAGE: "Százalékos",
            },
        },
    },
    DOCUMENT_SERIES: {
        BUTTONS: {
            ADD_SERIES: "Sorozat hozzáadása",
        },
        FIELDS: {
            NAME: "Megnevezés",
            SEPARATOR: "Elválasztó",
            DESCRIPTION: "Leírás",
            PREFIX: "Előtag",
            REJECTED_PREFIX: "Válaszlevél előtagja",
            CURRENT_INDEX: "Aktuális sorszám",
            CATEGORY: "Kategória/Nyilvántartások",
            YEARLY_RESET: "Éves visszaállítás",
            ACTIVE: "Aktív",
            SERIES_TYPE: "Sorozattípus",
            REJECTED_INDEX: "Válaszlevél sorszáma",
        },
        LIST: {
            EDIT: "Szerkesztés",
            HEADER: "Iratsorozatok listája",
        },
        MODALS: {
            ADD_TITLE: "Iratsorozat hozzáadása",
            EDIT_TITLE: "Iratsorozat szerkesztése",
            ADD: "Hozzáadás",
            SAVE: "Mentés",
            CANCEL: "Mégse",
        },
        NOTIFIERS: {
            SAVED: "Az iratsorozat sikeresen mentve",
            EDITED: "Az iratsorozat sikeresen frissítve",
            LOCATION_ALREADY_ADDED: "Ez a helyszín már hozzá van adva",
        },
        PLACEHOLDERS: {
            NAME: "Megnevezés",
        },
    },
    DOCUMENT_REGISTERS: {
        BUTTONS: {
            ADD_REGISTER: "Regiszter hozzáadása",
        },
        FIELDS: {
            NAME: "Megnevezés",
            DESCRIPTION: "Leírás",
            REGISTER_TYPE: "Regisztertípus",
            IS_CUSTOM: "Egyedi regiszter",
            APPLICATION_TYPE_IDS: "Kérelem típusok",
            DOCUMENT_SERIES_IDS: "Iratsorozatok",
        },
        LIST: {
            VIEW: "Megtekintés",
            EDIT: "Szerkesztés",
            DELETE: "Törlés",
            HEADER: "Irattári regiszterek listája",
        },
        MODALS: {
            ADD_TITLE: "Irattári regiszter hozzáadása",
            EDIT_TITLE: "Irattári regiszter szerkesztése",
            ADD: "Hozzáadás",
            SAVE: "Mentés",
            CANCEL: "Mégse",
        },
        NOTIFIERS: {
            SAVED: "Az irattári regiszter sikeresen mentve",
            EDITED: "Az irattári regiszter sikeresen frissítve",
            DELETED: "Az irattári regiszter sikeresen törölve",
        },
        VALIDATION: {
            REQUIRED_SELECTION_TITLE: "Kötelező kiválasztás",
            REQUIRED_SELECTION_TEXT: "Válasszon ki legalább egy {field} értéket.",
            NO_APPLICATION_TYPES_TEXT: "A kiválasztott dokumentumsorozatokhoz nem tartozik kérelemtípus. Válasszon olyan sorozatot, amelyhez legalább egy kérelemtípus tartozik.",
            MAX_COLUMNS_TITLE: "Oszlopok maximális száma",
            MAX_COLUMNS_TEXT: "{selected} oszlopot választott ki. Egy regiszter legfeljebb {max} oszlopot tartalmazhat.",
            RECOMMENDED_COLUMNS_TITLE: "Nagy számú oszlop",
            RECOMMENDED_COLUMNS_TEXT: "{selected} oszlopot választott ki. Több mint {recommended} oszlop csökkentheti a teljesítményt. Legfeljebb {max} oszlop választható ki.",
            MIN_COLUMNS_TITLE: "Kötelező oszlopok",
            MIN_COLUMNS_TEXT: "Válasszon ki legalább egy oszlopot a regiszterhez.",
        },
        PLACEHOLDERS: {
            NAME: "Megnevezés",
            DESCRIPTION: "Leírás",
            APPLICATION_TYPE: "Válassza ki a kérelem típusát",
            DOCUMENT_SERIES: "Válassza ki az iratsorozatot",
            SEARCH_APPLICATION_TYPES: "Kérelemtípusok keresése",
        },
    },    
    ORG_RESPONSIBILITIES: {
        BUTTONS: {
            ADD_RESPONSIBILITY: "Felelősségi kör hozzáadása",
        },
        LIST: {
            TITLE: "Felelősségi körök",
        },
        FILTER: {
            TITLE: "Felelősségi körök listája",
        },
        FIELDS: {
            RESPONSIBILITY_NAME: "Megnevezés",
            RESPONSIBILITIES: "Felelősségi körök",
        },
        PLACEHOLDERS: {
            RESPONSIBILITY_NAME: "Keresés megnevezés szerint",
            RESPONSIBILITIES: "Felelősségi körök",
        },
        FORM: {
            ADD_TITLE: "Felelősségi kör hozzáadása",
            EDIT_TITLE: "Felelősségi kör szerkesztése",
            SELECTED_RESPONSIBILITY: "Kiválasztott felelősségi kör",
            PERMISSIONS: "Jogosultságok",
            CLONE_TITLE: "Felelősségi kör klónozása",
        },
        CLARIFICATION: {
            ADD: "A felelősségi kör akkor adható hozzá, ha felelősségi kör és jogosultságok is ki vannak választva.",
            EDIT: "A felelősségi kör csak akkor módosítható, ha vannak kiválasztott jogosultságok.",
        },
    },
    RESPONSIBILITY: {
        FILTER: {
            TITLE: "Felelősségi körök",
        },
        FIELDS: {
            NAME: "Megnevezés",
            DESCRIPTION: "Leírás",
            CREATED_DATE: "Létrehozás dátuma",
            UPDATED_DATE: "Utolsó frissítés",
            ACTIONS: "Műveletek",
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
            PERMISSIONS: "Jogosultságok keresése",
        },
        FORM: {
            ASSOCIATED_PERMISSIONS: "Társított jogosultságok",
            EDIT_TITLE: "Felelősségi kör szerkesztése",
            ADD_TITLE: "Felelősségi kör hozzáadása",
        },
        LOGS: {
            TITLE: "Előzmények",
        },
    },
    APPLICATION: {
        LIST: {
            TITLE_STAFF: "Általános iktató",
            TITLE: "Kérelmek",
            TABLE_HEADER: "Kérelmek listája",
            ADD_BUTTON: "Új kérelem",
            REFRESH_BUTTON: "Frissítés",
            REPORT_BUTTON: "Jelentés generálása",
            ADD_DOCUMENT_BUTTON: "Dokumentum",
            DOCUMENT_CREATED_HEADER: "Létrehozott dokumentumok",
            DOCUMENT_RECEIVED_HEADER: "Beérkezett dokumentumok",
            DOCUMENT_PUBLIC_HEADER: "Nyilvános iratok",
            PAYMENTS_HEADER: "Rögzített fizetések",
            NO_ASSIGNEE: "Nincs kijelölve",
            SIGN_DOCUMENT_BULK: "Dokumentumok aláírása",
            SIGN_DOCUMENT_BULK_PERSONALIZED: "Dokumentumok személyre szabott aláírása",
            SIGN_DOCUMENT_BULK_STS: "Dokumentumok aláírása STS-sel",
            CONFIRM_DELETE_TEXT: "Biztos törli ezt a kérelmet? A törölt kérelmek többé nem érhetők el!",
            REFRESH_DOCUMENT_BUTTON: "Frissítés",
            REFRESH_PAYMENTS_BUTTON: "Frissítés",
            OFFLINE_APPLICATION: "Ügyfélszolgálat",
            ASSIGN_MULTIPLE: "Csoportos kijelölés",
        },
        FIELDS: {
            APPLICATION_TYPE_NAME: "Válassza ki a kérelem típusát",
            ORGANISATION_NAME: "Válassza ki az intézményt",
            APPLICATION_REGISTER_TYPE_NAME: "Válassza ki a dokumentum típusát",
            APPLICATION_TYPE_NAME_COLUMN: "Típus",
            ORGANISATION_NAME_COLUMN: "Intézmény",
            APPLICATION_TYPE_PURPOSE: "Válassza ki a kérelem célját",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "UAT típusa",
            PAYMENT: {
                CREATED_DATE: "Rögzítés dátuma",
                AMOUNT: "Összeg",
                CURRENCY: "Pénznem",
                DESCRIPTION: "Részletek",
                PAYMENT_TYPE: "Fizetés módja",
                STATUS: "Állapot",
                EMAIL: "E-mail",
                CLIENT_USER_NAME: "Ügyfél neve",
                CLIENT_USER_EMAIL: "Ügyfél e-mail-címe",
                CLIENT_USER_PERSONAL_NUMERIC_CODE: "CNP",
                PRODUCT_IDENTIFIER_TYPE_DESCRIPTION: "Leírás",
                BT_PAYMENT_ID: "Tranzakcióazonosító",
                APPLICATION_TYPE_NAME: "Kérelem típusa",
                RECEIPT_FILE_ID: "Fizetési igazolás",
            },
            STATUS: "Állapot",
            LOCALITY: "Megyei jogú város / Város / Község",
            EMPLACEMENT_LOCALITY: "Település",
            FIRST_NAME: "Keresztnév",
            LAST_NAME: "Vezetéknév",
            ID_CARD_SERIAL: "Sz. ig. sorozat",
            ID_CARD_NUMBER: "Sz. ig. szám",
            ID_CARD_EXPIRATION_DATE: "Lejárati dátum",
            ID_CARD_ISSUED_DATE: "Kiállítás dátuma",
            ID_CARD_ISSUER: "Kiállította",
            EMAIL: "E-mail",
            PHONE: "Telefon",
            SIGNER_FUNCTION_CURRENT: "Jelenlegi aláíró",
            SIGNER_FUNCTION_NEXT: "Következő aláíró",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Szülőkérelem",
            IDENTIFICATION_NUMBER: "Bejövő iktatószám",
            CREATED_DATE: "Létrehozás dátuma",
            APPLICATION_DATE: "Beérkezés dátuma",
            LAST_REVIEW_DATE: "Utolsó kiegészítés",
            ISSUED_DATE: "Lezárás dátuma",
            RESPONSE_DUE_IN: "Hátralévő idő",
            CADASTRAL_NUMBER: "Kataszteri szám",
            USER_TYPE_NAME: "Személy típusa",
            PERSONAL_NUMERIC_CODE: "CNP",
            COUNTY: "Megye",
            VILLAGE: "Település",
            SECTOR: "Kerület",
            STREET: "Utca",
            STREET_NUMBER: "Házszám",
            POSTAL_CODE: "Irányítószám",
            STAIRCASE: "Lépcsőház",
            BLOCK: "Tömbház",
            FLOOR: "Emelet",
            APARTMENT: "Lakás",
            REAL_ESTATE_TYPE: "Helyszín típusa",
            AUTHORISATION_CODE: "TNA",
            SUBSIDIARY: "Fiókszervezet",
            LAND_AREA: "Telek területe",
            OTHER_IDENTIFICATION: "Egyéb azonosító",
            CREATED_BY: "Létrehozta",
            FILE_TYPE: "Dokumentumtípus",
            RESOLVED_DATE: "Megoldás dátuma",
            PIN: "Megerősítő kód",
            USE_PROFILE_DATA: "Profiladatok használata",
            PASSPORT_NUMBER: "Útlevélszám",
            CITY: "Város",
            ADDRESS: "Cím",
            LICENSE: "Licenc",
            COMPANY_NAME: "Jogi személy megnevezése",
            IBAN: "IBAN-számla",
            BANK: "Számlavezető bank",
            UNIQUE_REGISTRATION_CODE: "CIF vagy CUI",
            REGISTRATION_NUMBER: "Cégjegyzékszám",
            FILENAME: "Dokumentum neve",
            IS_CONTACT_PERSON: "A kérelmező a kapcsolattartó",
            TITLE: "Cím",
            MESSAGE: "Üzenet",
            COMMENTS: "Megjegyzések",
            CITIZEN_REVIEW: "Kérjük, sorolja fel a kérelmen végzett módosításokat",
            ASSIGNED_TO: "Felelős",
            ASSIGNMENT_NOTE: "Kijelölési megjegyzés",
            CLARIFICATION_COMMENT: "Észrevételek",
            MESSAGE_COMMENT: "Az Ön nyilvános üzenete",
            CONTACT_PERSON: "Kapcsolattartó",
            BENEFICIARY: "Kedvezményezett",
            BENEFICIARY_LEGAL: "Cég",
            PAYMENT_STATUS: "Fizetés",
            IS_PAID: "Fizetés",
            IS_SIGNED: "Aláírás",
            TOTAL_TAX: "Összesen",
            ALLOCATED_DOCUMENT_SERIES: "Kimenő iktatószám",
            FIRST_VIZA_SERIES_NUMBER: "CFP-ellenjegyzés kódja",
            SECOND_VIZA_SERIES_NUMBER: "Törvényességi ellenjegyzés kódja",
            REJECTION_VIZA_SERIES_NUMBER: "Elutasítási ellenjegyzés kódja",
            SCOPE_CU: "Tárgy",
            PAYMENT_TYPE: "Fizetés módja",
            PAYMENT_TYPE_CARD: "Online bankkártyás fizetés",
            PAYMENT_TYPE_OP: "Átutalási megbízás",
            PAYMENT_TYPE_DISCOUNT: "Fizetési mentesség",
            TRANSACTION_NUMBER: "Tranzakciószám",
            QUICK_SEARCH_VALUES: "Gyorskeresés",
            REJECTED_REASON: "Elutasítás indoka - csak az ügyintézők számára látható",
            PERSONAL_NUMERIC_CODE_OR_CIF: "CNP/CIF",
            DOCUMENT_SERIES_REGISTERS: "Kategória / Nyilvántartások",
            STATUS_RESOLUTION: "Ügyintézési állapot",
            PROJECT_ID: "Projektazonosító",
            CATEGORY_TYPE: "Kategória",
        },
        ENUMS: {
            STATUS_RESOLUTION: {
                PENDING_DOCUMENT_REGENERATION: "Dokumentum újragenerálása",
                PENDING_APPLICATION_ALLOCATED: "Kérelem kijelölve",
                PENDING_CLARIFICATION_RESPONSE: "Tisztázási válasz",
                PENDING_CLARIFICATION_REJECTED: "Tisztázási dokumentum elutasítva",
            },
            STATUS: {
                REGISTERED: "Iktatva",
                NEW: "Új",
                PENDING: "Ellenőrzés alatt",
                RESOLVED: "Megoldva",
                REJECTED: "Elutasítva",
                APPROVED: "Folyamatban",
                DRAFT: "Piszkozat",
                GENERATED: "Generálva",
                SIGNED: "Aláírva",
                SIGN_PENDING: "Aláírás alatt",
                CLOSED: "Lezárva",
                REVIEW: "Tisztázás alatt",
                REJECTED_IN_PROGRESS: "Elutasítás alatt",
                ERROR: "Hiba",
                SEALED: "Lebélyegezve",
                INTERNAL: "Belső",
                SEAL_ERROR: "Bélyegzési hiba",
                SEAL_PENDING: "Bélyegzés alatt",
                SIGN_APPLICANT_USER_PENDING: "Kérelmező aláírására vár",
                WAITING_FOR_CITIZEN: "Tisztázás szükséges",
                CLARIFICATION_PENDING: "Tisztázás ellenőrzés alatt",
                CLARIFICATION_SIGN_PENDING: "Tisztázás aláírás alatt",
                CLARIFICATION_SIGNED: "Tisztázás aláírva",
                CLARIFICATION_SEALED: "Tisztázás lebélyegezve",
                CLARIFICATION_APPROVED: "Tisztázás folyamatban",
                PROCESSED: "Feldolgozva",
            },
            REAL_ESTATE_TYPE: {
                LAND: "Telek",
                LAND_CONSTRUCTIONS: "Telek + építmények",
            },
            PAYMENT_TYPE: {
                DISCOUNT: "Fizetési mentesség",
                LINK: "Link",
                CARD: "Bankkártya",
                OP: "Átutalási megbízás",
                OFFICE: "Pénztár",
                MANUAL: "Hozzáadott befizetés",
            },
            PAYMENT_STATUS: {
                CREATED: "Függőben",
                SUCCESSFUL: "Feldolgozva",
                FAILED: "Sikertelen",
            },
            PAYMENT_METHOD: {
                TRANSFER: "Banki átutalás",
                CASH: "Készpénz",
                POS: "Bankkártya a pénztárnál",
                OTHER: "Egyéb mód",
            },
        },
        PLACEHOLDERS: {
            TYPE_OF_SUBMISSION: "Benyújtva",
            DIGITALIZED_APPLICATION: "Személyesen benyújtva",
            ONLINE_APPLICATION: "Online benyújtva",
            BENEFICIARY: "Természetes személy teljes neve",
            BENEFICIARY_LEGAL: "Jogi személy cégneve",
            BENEFICIARY_PNC_OR_UNIQUE_CODE: "Kedvezményezett CNP/CIF",
            SERVICE: "Válasszon",
            ALLOCATED_STAFF: "Válasszon",
            IDENTIFICATION_NUMBER: "Bejövő iktatószám",
            APPLICATION_TYPE_NAME: "Kérelem típusa",
            ORGANISATION_NAME: "Intézmény",
            CADASTRAL_NUMBER: "CF-szám",
            APPLICATION_TYPE_PURPOSE: "Kérelem célja",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            STATUS: "Állapot",
            COUNTY: "Megye",
            LOCALITY: "Település",
            RESPONSE_DUE_IN: "Hátralévő idő",
            VILLAGE: "Település",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "UAT típusa",
            CREATED_BY: "Létrehozta",
            EMPLACEMENT_LOCALITY: "Település",
            COMMENTS: "Megjegyzések",
            MESSAGE: "Üzenet",
            ASSIGNED_TO: "Felelős",
            ASSIGNMENT_NOTE: "Megjegyzés a felelős számára (nem kötelező)",
            EMAIL: "E-mail",
            QUICK_SEARCH_VALUES: "Kérelem száma",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Szülőkérelem",
            DOCUMENT_SERIES_REGISTERS: "Kategória/Nyilvántartások",
            PAYMENT: {
                CREATED_DATE: "Iktatás dátuma",
                AMOUNT: "Összeg",
                CURRENCY: "Pénznem",
                DESCRIPTION: "Részletek",
                PAYMENT_TYPE: "Fizetés módja",
                STATUS: "Állapot",
                EMAIL: "E-mail",
                CLIENT_USER_NAME: "Ügyfél neve",
                CLIENT_USER_EMAIL: "Ügyfél e-mail-címe",
                CLIENT_USER_PERSONAL_NUMERIC_CODE: "CNP",
                PRODUCT_IDENTIFIER_TYPE_DESCRIPTION: "Leírás",
                BT_PAYMENT_ID: "Tranzakcióazonosító",
                APPLICATION_TYPE_NAME: "Kérelem típusa",
            },
            STATUS_RESOLUTION: "Ügyintézési állapot",
        },
        FORM: {
            TITLE: "Új kérelem űrlapja",
            SUBMIT_BUTTON: "Kérelem elküldése",
            SAVE_AS_DRAFT_BUTTON: "Mentés piszkozatként",
            CONTINUE_BUTTON: "Folytatás",
            FILL_APPLICATION_BUTTON: "Kérelem kitöltése",
            CANCEL_BUTTON: "Kérelem visszavonása",
            DETAILS_SECTION: "Kérelem részletei",
            TAXES_BUTTON: "Díjak kiszámítása",
            TAXES_ERROR: "Kérjük, válassza ki a kérelem típusát, és adja meg a telek területét",
            WIZARD_TITLE: "Kérelem benyújtása",
            GO_BACK: "Vissza",
            GENERATE_DOCUMENT: "Dokumentum véglegesítése",
            NO_TEMPLATE: "Ehhez a kérelemtípushoz nincs sablon",
            PAY_BUTTON: "Fizetés",
            SEND_LINK_BUTTON: "Fizetési link küldése",
            SIGN_BUTTON: "Aláírás és benyújtás",
            APPLY_BUTTON: "Kérelem benyújtása",
            SEND_MESSAGE_BUTTON: "Üzenet küldése",
            PREVIEW_DOC: "Előnézet",
            SEND_REVIEW: "Tisztázások küldése",
            PENDING_RELATED_APPLICATIONS: "Polgármesteri láttamozás folyamatban",
            PENDING_INTERNAL_APPLICATIONS: "Belső dokumentumok folyamatban",
            HELP_DESCRIPTION: "Ha segítségre van szüksége, keresse fel a következő oldalt:",
            HELP_FREQUENT_QUESTIONS: "Gyakori kérdések",
            DOWNLOAD_BUTTON: "Letöltés",
            VALIDATE_FILE_BUTTON: "Fájl ellenőrzése és mentése",
            GIS_ATTACHMENTS: "GIS-mellékletek",
            GENERATE_BUTTON: "Kérelem generálása",
            FINALIZE_BUTTON: "Véglegesítés",
            TAKE_DATA_FROM_CONNECTED_APPLICATIONS: "Adatok átvétele",
            SIGNATURE_TITLE: "Ez a terület a dokumentum aláíróinak beállítására szolgál",
            SIGNATURE_DESCRIPTION: "Ez a terület a dokumentum aláíróinak beállítására szolgál. </br> AZ ALÁÍRÁSI SORREND ALULRÓL FELFELÉ ÉS BALRÓL JOBBRA HALAD. </br> A szám az aláírás sorrendjét jelzi, 1 = első aláíró",
            SAVE_AS_DRAFT_TITLE: "Figyelem: az oldal elhagyásával a módosítások elvesznek!",
            SAVE_AS_DRAFT_CONFIRM: "Szeretné menteni, mielőtt folytatja?",
        },
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "Kérelem elküldve",
            CREATED_SUCCESS_TEXT: "A(z) {number} számú kérelem sikeresen elküldve. Az elemzést és ellenőrzést követően értesítjük a kérelem elbírálásáról.",
            DRAFT_SAVED_SUCCESS: "A kérelem piszkozatként mentve",
            CHOOSE_SIGN_PACKAGE: "Kérjük, válassza ki az aláírási csomagot",
            OFFLINE_SIGN_FAILED: "A dokumentumok nincsenek aláírva",
            PAYMENT_FAILED: "Sikertelen fizetés",
            PAYMENT_SUCCESS: "A fizetés sikeresen megtörtént",
            INVALID_PROFILE_FOR_SIGNING_TITLE: "A profiladatok nem érvényesek",
            INVALID_PROFILE_FOR_SIGNING_TEXT: "Kérjük, ellenőrizze a <b>Profilom</b> oldalon a személyi számot (CNP) és a személyi igazolvány adatait, amelyek az online aláíráshoz szükségesek!",
            INVALID_PROFILE_FOR_SIGNING_BUTTON_TEXT: "Ugrás a Profilom oldalra",
            INVALID_STAFF_ENROLLMENT_TITLE: "Hiba történt az aláírási folyamat során",
            INVALID_STAFF_ENROLLMENT_TEXT: "Kérjük, végezze el az aláírói regisztrációt, hogy aláírhasson",
            INVALID_STAFF_ENROLLMENT_BUTTON_TEXT: "Ugrás a Profilom oldalra",
            DUPLICATE_BENEFICIARY_PNC: "Az azonos CNP-vel ({pnc}) rendelkező kedvezményezett már hozzá van adva.",
            DUPLICATE_BENEFICIARY_REG_CODE: "Az azonos CIF/CUI-val ({unique_registration_code}) és CNP-vel rendelkező kedvezményezett már hozzá van adva.",
            GENERATE_OFFLINE_PACKAGE: "A kérelem letöltése folyamatban. Kérjük, várjon!",
            REVIEW_SENT: "A tisztázások elküldve",
            REVIEW_NOT_SENT: "Hiba történt a tisztázások küldésekor. Kérjük, próbálja újra",
            UPLOADING_FILES: "A fájlok feltöltése folyamatban",
            AUTOSAVE_LOADER_TEXT: "A kérelem 10 percenként 1 alkalommal automatikusan mentődik, hogy a bevitt adatok ne vesszenek el.",
            MISSING_UAT: "A helyszín(ek)hez kiválasztott település nem érhető el",
            UNAUTHORIZED_PAYMENT: "Elnézést kérünk, ennek a kérelemnek a díja jelenleg nem fizethető be. A kérelemtípus jelenleg inaktív.",
            INACTIVE_APPLICATION_TYPE: "A kérelemtípus inaktív. Ez a kérelem már nem fizethető be és nem nyújtható be.",
            GENERATION_ERROR: "Hiba történt a dokumentum generálása során!",
            GENERATION_ERROR_TEXT: "Kérjük, próbálja meg újra elküldeni a tisztázásokat.",
            SENDING_ERROR: "Hiba történt. Kérjük, próbálja meg később újra benyújtani a kérelmet",
            BULK_SIGN_LIMIT: "Kérjük, ne válasszon ki {number} kérelemnél többet a csoportos aláíráshoz",
            REVIEW_APPLICATION_TYPE: "Kérjük, állítsa be az adminisztrációs részben a vonatkozó tisztázási megjegyzést",
            INVALID_GIS_FILE: "A feltöltött fájl nem érvényes. Kérjük, töltsön fel egy másik fájlt!",
            DOC_RECEIVED_BULK_SIGN_LIMIT: "Egyszerre legfeljebb {number} dokumentum írható alá.",
            TAKE_DATA_FROM_CONNECTED: "A csak egyetlen kapcsolódó dokumentumban szereplő adatok kerülnek átvételre, és felülírják a jelenlegi értékeket. Biztos át szeretné venni az adatokat?",
            CLARIFICATION_SIGNED: "A tisztázás sikeresen aláírva és elküldve.",
        },
        VIEW: {
            TITLE_STAFF: "Kérelemnyilvántartás",
            TITLE: "Kérelmek",
            SAVE_AS_DRAFT_BUTTON: "Mentés piszkozatként",
            REASSIGN_STAFF: "Kérelem újbóli kijelölése",
            ASSIGN_STAFF: "Kérelem kijelölése",
            SEARCH_PLACEHOLDER_USERS: "Keresés az ügyintéző neve szerint",
            MODIFY_APPLICATION_TYPE: "Kérelemtípus módosítása",
            SEND_TO_REVIEW: "Véleményezésre küldés",
            REVIEW_STATUS: "Véleményezés",
            ASSIGN_REVIEWER: "Véleményező kiválasztása",
            REASSIGN_REVIEWER: "Véleményező módosítása",
            SEND_TO_REVIEW_DOCUMENT_MESSAGE: "Biztos véleményezésre szeretné küldeni ezt a dokumentumot?",
            SEND_RESPONSE: "Válasz küldése",
            APPLICATION_DETAILS_SECTION_TITLE: "Kérelem részletei",
            BENEFICIARY_DETAILS_SECTION_TITLE: "Kedvezményezettek részletei",
            BENEFICIARY_DETAILS_TITLE: "Kedvezményezett",
            REAL_ESTATE_DETAILS_SECTION_TITLE: "Ingatlan részletei",
            REAL_ESTATE_EMPLACEMENT_DETAILS_SECTION_TITLE: "Helyszín részletei",
            APPLICANT_DETAILS_SECTION_TITLE: "Kérelmező / tervező adatai",
            PAYMENT_DETAILS_SECTION_TITLE: "Fizetések",
            ATLAS_DETAILS_SECTION_TITLE: "Előnézet a Területi Atlaszból",
            ATTACHMENTS_DETAILS_SECTION_TITLE: "Dokumentumok",
            CITIZEN_ATTACHMENTS_DETAILS_SECTION_TITLE: "Állampolgár dokumentumai",
            ATTACHMENTS_SECTION_OUTPUT: "Kiállított iratok",
            ATTACHMENTS_SECTION_INPUT: "Benyújtott iratok",
            ATTACHMENTS_SECTION_PUBLIC: "Nyilvános iratok",
            ATTACHMENTS_SECTION_REVIEW: "Tisztázások",
            NEXT_STEP: "Következő lépés",
            SIGN_DOCUMENT: "Dokumentum aláírása",
            SIGN_DOCUMENT_PERSONALIZED: "Dokumentum személyre szabott aláírása",
            SIGN_DOCUMENT_STS: "Dokumentum aláírása STS-sel",
            ASSIGN_STAFF_MESSAGE: "Biztos átveszi ezt a kérelmet?",
            APPROVE_DOCUMENT: "Jóváhagyás",
            REJECT_DOCUMENT: "Elutasítás",
            APPROVE_DOCUMENT_MESSAGE: "Biztos jóváhagyja ezt a kérelmet?",
            REJECT_DOCUMENT_MESSAGE: "Biztos elutasítja ezt a kérelmet?",
            GENERATE_DOCUMENT_MESSAGE: "A dokumentum elkészült",
            GENERATE_DOCUMENT_ERROR: "A dokumentum nem generálható",
            SIGN_DOCUMENT_ERROR: "A dokumentum nem írható alá",
            SIGN_SUCCESS: "A dokumentum aláírása megtörtént",
            AUTOSAVE_SUCCESS: "Sikeres mentés",
            AUTOSAVE_FAILED: "Hiba a mentés során",
            SEND_CLARIFICATIONS: "Tisztázás szükséges",
            CREATE_INTERNAL_DOCUMENT: "Belső dokumentum létrehozása",
            RETURN_DOCUMENT: "Dokumentum újragenerálása",
            RETURN_DOCUMENT_MESSAGE: "Biztos visszaküldi ezt a dokumentumot? Ez a művelet visszafordíthatatlan, és az irat újragenerálásával jár.",
            SIGN_ATTACHMENTS_BUTTON: "Mellékletek aláírása",
            SIGN_ATTACHMENTS_BUTTON_PERSONALIZED: "Mellékletek személyre szabott aláírása",
            SIGN_ATTACHMENTS_BUTTON_STS: "Mellékletek aláírása STS-sel",
            DOWNLOAD_COMPRESSION: ".zip letöltése",
            VIEW_INTERNAL_DOCUMENTS: "Belső dokumentumok megtekintése",
            CLOSE_APPLICATION: "Kérelem lezárása",
            CREATE_PAYMENT_LINK: "Fizetési link küldése",
            UPLOAD_FILES: "Kérjük, töltse fel a szükséges dokumentumokat az alábbi Mellékletek részben",
            PROCESS_ERROR: "Folyamathiba",
            SUBPROCESS_ERROR: "Alfolyamathiba",
            START_PROCESS: "Folyamat indítása",
            START_SUBPROCESS: "Alfolyamat indítása",
            SEAL_ATTACHMENTS_BUTTON: "Mellékletek lebélyegzése",
            ASSIGN_MULTIPLE_DIFFERENT_APPLICATION_TYPE_ERROR: "A kérelmek csoportos kijelölése csak azonos típusú kérelmek esetén lehetséges.",
            SEND_TO_CLARIFICATION_MESSAGE: "A tisztázási folyamat elindult",
            SEND_TO_CLARIFICATION_CITIZEN_MESSAGE: "A tisztázás elküldve",
            SEND_CLARIFICATION_ERROR: "Hiba a tisztázás küldése során",
            WAITING_FOR_CITIZEN: "Az állampolgár válaszára vár",
            CLARIFICATION_REVIEW_STATUS: "Tisztázás alatt",
            FORM_DATA_ERROR: "Hiba történt az űrlapadatok generálása során",
            FILE_UPLOAD_ERROR: "Hiba történt a fájlok feltöltése során",
            CLARIFICATION_ID_MISSING: "A tisztázást nem sikerült azonosítani",
            PREVIEW_DOCUMENT_ERROR: "A dokumentum előnézete nem jeleníthető meg",
            SEAL_DOCUMENT_ERROR: "A dokumentumok nem bélyegezhetők le",
        },
        INIT_SIGN_MODAL: {
            TITLE: "Digitális aláírás személyre szabása",
            MESSAGE: "Adjon hozzá egy kiegészítő képet az aláíráshoz",
            MAX_FILE_SIZE: "Legfeljebb 10MB (png, jpg, jpeg)",
            FILE_UPLOAD_INFO_MESSAGE: "Húzza ide a képet, vagy kattintson a feltöltéshez",
            FILE_UPLOAD_ERROR_INVALID: "A fájl érvénytelen!",
            FILE_UPLOAD_ERROR_SIZE: "A fájl túl nagy!",
        },
        CONFIRM_SIGN_MODAL: {
            TITLE: "Digitális aláírás érvényesítése",
            MESSAGE_SENT: "SMS-t küldtünk a <strong>{0}</strong> telefonszámra. Adja meg a kapott kódot a kérelem elektronikus aláírással történő aláírásához és elküldéséhez.",
            STS_SIGNING: "E-mailt vagy push-értesítést fog kapni a StSign mobilalkalmazásban (ha kiválasztotta a megerősítést). Engedélyezze, majd írja alá a kérelmet.",
        },
        REJECT_VIZA_MODAL: {
            REJECTION_TITLE: "Ellenjegyzés elutasítása",
            REJECTION_COMMENT: "Az elutasítás indoka: ",
        },
        GENERATE_REPORT_MODAL: {
            DEFAULT_COLUMNS: {
                STATUS: "Állapot",
                PROJECT_IDS: "Project ID",
                APPLICATION_TYPE_NAME: "Kérelem típusa",
                IDENTIFICATION_NUMBER: "Azonosító szám",
                APPLICATION_DATE: "Kérelem dátuma",
                TERRITORIAL_ADMINISTRATIVE_UNIT_NAME: "UAT",
                REAL_ESTATE_TARGET: {
                    COUNTY: "Megye",
                    TERRITORIAL_ADMINISTRATIVE_UNIT: "Közigazgatási egység",
                    LAND_AREA: "Terület",
                },
                PAYMENT_DATE: "Fizetés dátuma",
                TOTAL: "Összesen",
                ORDER_NUMBER: "Sorszám",
                ISSUED_DATE: "Kibocsátás dátuma",
                ALLOCATED_DOCUMENT_SERIES: "Kiosztott dokumentumsorozat",
                OP_PAYMENT_ID: "Fizetési azonosító (OP)",
                PAYMENT_DETAILS: {
                    PAYMENT_TYPE: "Fizetés típusa",
                    PAYMENT_DATE: "Fizetés dátuma (OP)",
                },
            },
            GENERATE: "Generálás",
            NAME_DESCRIPTION: "Válasszon egy már meglévő előre meghatározott jelentést, vagy adjon meg egy új nevet",
            NAME: "Név",
            NAME_PLACEHOLDER: "Adja meg vagy válasszon",
            APPLICATION_TYPE_PLACEHOLDER: "Válasszon ki egy vagy több típust",
            APPLICATION_TYPE_NAME: "Kérelem típusa",
            APPLICATION_TYPE_NAME_PLACEHOLDER: "Válasszon",
            DATE_RANGE: "Jelentés időszaka",
            COLUMNS: "Jelentés oszlopai",
            SAVE_AS_PREDEFINED: "Mentés előre meghatározott jelentésként",
            MAX_APPLICATION_TYPES_TITLE: "Típusok maximális száma",
            MAX_APPLICATION_TYPES_TEXT: "Egy jelentéshez legfeljebb 5 típus választható",
            MAX_COLUMNS_TITLE: "Oszlopok maximális száma",
            MAX_COLUMNS_TEXT: "Egy jelentéshez legfeljebb 50 oszlop választható",
            INVALID_DATE_RANGE_TITLE: "Érvénytelen dátumtartomány",
            INVALID_DATE_RANGE_TEXT: "Válasszon érvényes kezdő- és záródátumot",
            END_BEFORE_START_TEXT: "A záródátum nem lehet a kezdődátum előtt",
        },
        TABS: {
            APPLICATION: "Kérelem részletei",
            DOCUMENTS: "Dokumentumok",
            ACTIVITY: "Tevékenységek",
            ACTIVITY_SUBTAB_ACTIVITIES: "Tevékenységek",
            ACTIVITY_SUBTAB_COMMENTS: "Megjegyzések",
            PAYMENTS: "Fizetések",
            DOCUMENT_CREATED: "Benyújtott iratok",
            DOCUMENT_RECEIVED: "Kiállított iratok",
            DOCUMENT_PUBLIC: "Nyilvános iratok",
            DOCUMENT_REVIEW: "Tisztázások",
            DOCUMENT_INTERNAL: "Belső",
            REAL_ESTATE: "Ingatlan",
            TAXES: "Díjak",
            BENEFICIARY: "Kedvezményezett",
            NEW_APPLICATION: "Részletek",
            SIGN: "Aláírás",
            SUMMARY: "Összegzés",
            CERTIFICAT_URBANISM: "Urbanisztikai bizonyítvány",
            APPLICATION_FORM: "Kérelem kitöltése",
            REGISTRY_DETAILS: "Iktatási adatok",
            CLARIFICATIONS: "Tisztázások",
        },
        TERRITORIAL_ATLAS: {
            HEADER: "Előnézet a Területi Atlaszból",
            SUBTITLE: "A térkép a helyszínek hozzáadásával töltődik fel.",
            GENERATE_BUTTON: "Megtekintés",
            REAL_ESTATES_LABEL: "Helyszín megtekintése",
            PLACEHOLDER: "Adja meg az ingatlan adatait, majd kattintson a „Generálás” gombra a térkép előnézetéhez.",
            NOT_FOUND: "Sajnáljuk, a kataszteri szám nem található. Próbálja újra!",
            ERROR: "Sajnáljuk, a szinkronizálás nem sikerült. Próbálja újra!",
            INACTIVE: "A kataszteri szám inaktív az ANCPI nyilvántartásában.",
            PRESET_SELECT_PLACEHOLDER: "Réteg-láthatósági beállítás",
        },
        PAYMENT: {
            SECTION_TITLE: "Fizetés",
            TITLE: "Válassza ki a fizetési módot",
            HELP_TEXT_CARD: "A kérelem online benyújtásához a díjak online, bankkártyával fizethetők. A fizetés távolról is elvégezhető, ehhez azonban a kártyát kibocsátó bank beállításai szerinti fizetési megerősítésre van szükség.",
            HELP_TEXT_LINK: "A kérelem online benyújtásához a díjakat a tényleges kedvezményezett is kifizetheti a megadott e-mail-címre küldött fizetési linken keresztül. A fizetés távolról, online, bankkártyával végezhető el a kedvezményezett e-mail-címére érkezett link megnyitásával.",
            HELP_TEXT_EXEMPT: "A választott mentesség minden díjat fedez, nincs szükség fizetési módra.",
            HELP_TEXT_NO_FEES: "A kérelemhez nem tartozik fizetendő díj, nincs szükség fizetési módra.",
            STATUS_PAID: "kifizetve",
            STATUS_UNPAID: "kifizetetlen",
            STATUS_UNPROCESSED: "feldolgozatlan",
            SELECT: {
                ONLINE: "bankkártya",
                LINK: "kedvezményezetti link",
            },
            RECEIPT_DEFAULT_FILE_NAME: "Fizetési igazolás.pdf",
            LINK_EMAIL_REQUIRED: "A fizetési link elküldéséhez meg kell adni a kedvezményezett e-mail-címét.",
        },
        PAYMENT_ORDER: {
            FIELDS: {
                ORDER_NUMBER: "Megbízás száma",
                PAYMENT_DATE: "Fizetés dátuma",
            },
        },
        PAYMENT_LINK: {
            TITLE: "Fizetési link",
        },
        MANUAL_PAYMENT: {
            ACTIONS: {
                RECORD: "Befizetés rögzítése",
                ADD: "Beérkezett befizetés hozzáadása",
                CHECK: "Ellenőrzés a banknál",
                HISTORY: "Előzmények",
            },
            HINTS: {
                VALID_UNTIL: "lejár: {date}",
                LINK_EXPIRED: "lejárt: {date}",
                INITIAL_TYPE: "eredetileg: {type}",
                ADDED: "hozzáadott befizetés",
                PREVIOUS_STATUS: "korábban: {status}",
                RECORDED_BY_INSTITUTION: "Az intézmény rögzítette",
                RECORDED_MANUALLY: "kézzel rögzítve",
            },
            LABELS: {
                AMOUNT: "Összeg",
                STATUS: "Állapot",
                STATUS_NOW: "Jelenlegi állapot",
                STATUS_BEFORE: "Korábbi állapot",
                INITIAL_TYPE: "Eredeti típus",
                SENT_TO: "Címzett",
                VALID_UNTIL: "Érvényes eddig",
                REQUEST_DATE: "A kérés dátuma",
            },
            FORM: {
                RECORD_TITLE: "Befizetés rögzítése",
                ADD_TITLE: "Beérkezett befizetés hozzáadása",
                APPLICATION: "Kérelem {number}",
                PAYMENT_REQUEST: "Fizetési kérés",
                REQUEST_LINK: "Link elküldve ide: {email}",
                REQUEST_CARD: "Bankkártyás fizetés",
                AMOUNT_DUE: "Fizetendő összeg",
                APPLICATION_TOTAL: "A kérelem végösszege",
                COLLECTED_SO_FAR: "Eddig befolyt",
                METHOD: "Fizetési mód",
                PAID_AT: "Fizetés dátuma",
                DOCUMENT_NUMBER: {
                    TRANSFER: "Átutalási megbízás száma",
                    CASH: "Nyugta száma",
                    POS: "POS-bizonylat száma",
                    OTHER: "Bizonylat száma",
                },
                OPTIONAL: "nem kötelező",
                METHOD_DESCRIPTION: "A fizetési mód leírása",
                AMOUNT: "Befolyt összeg",
                DESCRIPTION: "Részletek",
                DESCRIPTION_DEFAULT: "Díjak",
                PAYER: "Befizető",
                PROOF: "Fizetési igazolás",
                NOTE: "Megjegyzések",
                SUBMIT_RECORD: "Befizetés rögzítése",
                SUBMIT_ADD: "Befizetés hozzáadása",
                PAID_AT_FUTURE: "A fizetés dátuma nem lehet jövőbeli.",
                AMOUNT_INVALID: "Az összegnek nullánál nagyobbnak kell lennie, legfeljebb két tizedesjeggyel.",
                NOTE_TOO_LONG: "Legfeljebb {max} karakter.",
                PENDING_WARNING: "Ennek a kérelemnek van egy függőben lévő, {amount} összegű befizetése ({date}). Ha éppen azt a befizetést adná hozzá, lépjen vissza, és használja a „Befizetés rögzítése” műveletet annak a sorában.",
                PENDING_WARNING_MANY: "Ennek a kérelemnek több függőben lévő befizetése van: {payments}. Ha a hozzáadott befizetés ezek egyike, lépjen vissza, és használja a „Befizetés rögzítése” műveletet annak a sorában.",
                PENDING_ITEM: "{amount} ({date})",
                CONFIRM_RECORD: "Rögzíti a(z) {amount} összegű befizetést ({method}) a(z) {application} kérelemhez?",
                CONFIRM_ADD: "Hozzáad egy {amount} összegű beérkezett befizetést ({method}) a(z) {application} kérelemhez?",
                RECORDED: "A befizetés rögzítve.",
                ADDED: "A befizetés hozzáadva.",
                PROOF_UPLOAD_FAILED: "A fájlt nem sikerült feltölteni. Semmi sem lett elmentve. Próbálja újra, vagy távolítsa el a fájlt.",
            },
            HISTORY: {
                TITLE: "A befizetés előzményei",
                EMPTY: "Ennél a befizetésnél nincs előzmény.",
                ACTORS: {
                    BANK: "A bank",
                    SYSTEM: "Rendszer",
                    CITIZEN: "Kérelmező",
                    STAFF: "Ügyintéző",
                },
                EVENTS: {
                    LINK_SENT: "Fizetési link elküldve",
                    CARD_STARTED: "Bankkártyás fizetés indítva",
                    PAID_ONLINE: "Online kifizetve",
                    FAILED_AT_BANK: "Sikertelen a banknál",
                    EXEMPTION: "Fizetési mentesség",
                    RECORDED: "Befizetés kézzel rögzítve",
                    ADDED: "Befizetés hozzáadva",
                    BANK_CHECKED: "Ellenőrizve a banknál",
                },
                DETAILS: {
                    EXEMPTION: "a kérelemnek nincs fizetendő díja",
                },
                BANK_RESULTS: {
                    CONFIRMED: "A bank megerősítette a befizetést.",
                    NOT_PAID: "A bank nem rögzített befizetést.",
                    EXPIRED: "A befizetés nem történt meg. A megrendelés lejárt a banknál.",
                    DECLINED: "A befizetés nem történt meg. A bank elutasította, vagy elfogytak a próbálkozások.",
                    REFUNDED: "A bank szerint az összeget visszatérítették a befizetőnek.",
                    UNAVAILABLE: "A bank nem válaszolt.",
                    ALREADY_PROCESSED: "A befizetés már fel volt dolgozva.",
                },
            },
            CHECK: {
                CONFIRMED_TITLE: "A bank megerősíti a befizetést",
                CONFIRMED_TEXT: "A(z) {amount} összegű befizetés „Feldolgozva” állapotba került, a kérelem pedig kifizetettként jelenik meg.",
                NOT_PAID_TITLE: "A bank nem rögzített befizetést",
                NOT_PAID_TEXT: "Semmi sem változott.",
                NOT_PAID_TEXT_LINK: "A link eddig érvényes: {date}. Semmi sem változott.",
                NOT_PAID_TEXT_LINK_EXPIRED: "A link lejárt: {date}. Semmi sem változott.",
                EXPIRED_TITLE: "A befizetés nem történt meg",
                EXPIRED_TEXT: "A megrendelés lejárt a banknál. Rögzítheti a befizetést, ha más módon történt meg.",
                EXPIRED_TEXT_LINK: "A link lejárt a banknál. Küldhet új linket, vagy rögzítheti a befizetést, ha más módon történt meg.",
                DECLINED_TITLE: "A befizetés nem történt meg",
                DECLINED_TEXT: "A bank elutasította a befizetést, vagy elfogytak a próbálkozások. Rögzítheti a befizetést, ha más módon történt meg.",
                DECLINED_TEXT_LINK: "A bank elutasította a befizetést, vagy elfogytak a próbálkozások. Küldhet új linket, vagy rögzítheti a befizetést, ha más módon történt meg.",
                REFUNDED_TITLE: "Az összeget visszatérítették",
                REFUNDED_TEXT: "A bank szerint az összeget befizették, majd visszatérítették a befizetőnek. Semmi sem változott.",
                UNAVAILABLE_TITLE: "A bank nem válaszolt",
                UNAVAILABLE_TEXT: "Próbálja újra néhány perc múlva. Semmi sem változott.",
                ALREADY_PROCESSED_TITLE: "A befizetés már fel van dolgozva",
                ALREADY_PROCESSED_TEXT: "A kérelem frissítve lett.",
            },
            BANNER: {
                TEXT: "A kérelem fizetési állapota nem egyezik a listában szereplő befizetésekkel.",
                BUTTON: "Kérelem frissítése",
                DONE: "A kérelem frissítve lett.",
                UP_TO_DATE: "A kérelem már összhangban van a befizetésekkel.",
            },
        },
        DISCOUNTS: {
            TITLE: "Válasszon fizetési mentességet",
            NO_DISCOUNT: "Nincs mentesség",
            HELP_TEXT: "A kérelem online benyújtásakor az adótörvénykönyv és a hatályos jogszabályok szerint díjfizetési mentesség alkalmazható.",
            DESCRIPTION_HEADER: "A mentesség csak a következőkre vonatkozik:",
            DESCRIPTION_WARNING: "A mentesség sikeres alkalmazásához a kérelemhez igazoló iratokat kell csatolni mellékletként.",
        },
        MODALS: {
            ADD: "Hozzáadás",
            CANCEL: "Mégse",
            SAVE: "Mentés",
            SIGN_STATUS: {
                TITLE: "Aláírási állapot",
                IDENTIFICATION_NUMBER: "Bejövő iktatószám",
                LOCALITY: "Megyei jogú város/Város/Község",
                SIGNING_BY: "Aláírás folyamatban:",
                LAST_SIGNING_DATE: "Utolsó aláírás dátuma",
                CITIZEN_SIGNING: "Állampolgár",
                LAST_SIGNING_DATE_CITIZEN: "Állampolgár aláírásának dátuma",
            },
            COMMENT_TITLES: {
                APPROVE: "Jóváhagyta: {userName}, megjegyzés: {comment}",
                REJECT: "Elutasította: {userName}, indok: {comment}",
                RETURN: "Újragenerálta: {userName}, indok: {comment}",
                REJECT_VIZA: "Elutasította: {userName}. ",
            },
        },
        SIGNATURE: {
            TITLE: "Válassza ki az aláírás módját",
            SECTION_TITLE: "Kérelmek és mellékletek aláírása",
            TABS: {
                ONLINE: "Online aláírás",
                OFFLINE: "Offline aláírás",
            },
            ONLINE: {
                HELP_TEXT: "A kérelem online benyújtásához azt digitálisan, digitális aláírással kell aláírni. Az aláírás távolról is elvégezhető, ehhez azonban digitális aláírásra van szükség.",
                INFO_TEXT: "A certSIGN aláírásra szolgáló digitális tanúsítványának beszerzéséhez az Ön fiókjában szereplő azonosító adatokat használjuk fel. Ezeket csak egyszer kell megadnia, és ezek alapján egyedi azonosító kód jön létre, amely garantálja kérései hitelességét.",
                PACKAGE_LABEL: "Ezek költsége a végösszegben szerepel.",
                SUMMARY_DIGITAL_SIGNATURE_LABEL: "Digitális aláírások",
                SUMMARY_REQUIRED_SIGNATURES: "Szükséges",
                SUMMARY_AVAILABLE_SIGNATURES: "Elérhető",
                SUMMARY_LEFTOVER_SIGNATURES: "Fennmaradó",
                SUMMARY_TEXT: "Távoli elektronikus aláírás",
            },
            OFFLINE: {
                HELP_TEXT: "Válassza az \"ONLINE ALÁÍRÁS\" lehetőséget, ha tanúsítványt szeretne vásárolni a szükséges digitális aláírásokhoz, vagy az \"OFFLINE ALÁÍRÁS\" lehetőséget, ha már rendelkezik ilyennel egy engedélyezett szolgáltatótól.",
                INFO_TEXT: "Töltse le a dokumentumot az eszközére, írja alá, majd töltse fel a dokumentumot a folytatáshoz. Figyelem: minősített tanúsítvánnyal hitelesített digitális aláírás szükséges, nem egyszerű elektronikus (vagy saját kezű) aláírás.",
                ACTION_DOWNLOAD_TITLE: "Kérelem letöltése",
                ACTION_DOWNLOAD_SUBTITLE: "amelyet digitálisan alá kell írni",
                ACTION_UPLOAD_TITLE: "Kérelem feltöltése",
                ACTION_UPLOAD_SUBTITLE: "amelyet digitálisan alá kell írni",
                STEP_DOWNLOAD: "Letöltés",
                STEP_SIGN: "Aláírás",
                STEP_VERIFY: "Ellenőrzés",
                STEP_CHECKED: "Dokumentumok rendben",
                SUMMARY_TEXT: "Saját elektronikus aláírás",
                UPLOAD_NOTIFICATION: "Az aláírt dokumentumok feltöltése után a kérelem már nem módosítható. Biztos folytatja?",
            },
            OFFICE: {
                SUMMARY_TEXT: "Saját kezű aláírás",
            },
        },
        CLARIFICATION_MODAL: {
            TITLE: "Válasz küldése",
        },
        SEND_REVIEW_MODAL: {
            TITLE: "Tisztázási kérés küldése",
        },
        SUMMARY: {
            SIGN_TYPE_TITLE: "Aláírás módja",
            APPLICATION_DETAIL_TITLE: "Kérelem részletei",
            PAYMENT_TYPE_TITLE: "Fizetés módja",
            SIGN_TYPE_FOOTER: "CertSign által biztosítva",
            APPLICATION_OBJECTIVE: "Kérelem tárgya",
            APPLICANT: "Kérelmező",
            PAYMENT_TYPE: "Online bankkártyás fizetés",
            PAYMENT_TYPE_OP: "Átutalási megbízás",
            PAYMENT_TYPE_LINK: "Fizetési link",
            FILE_NAME: "Átutalási megbízás",
            PAYMENT_TYPE_HELP_TEXT: "A fizetés elindítása után átirányítjuk a fizetési szolgáltatóhoz a fizetés teljesítéséhez.",
            PAYMENT_TYPE_HELP_TEXT_FAILED: "A fizetés nem sikerült.",
            PAYMENT_TYPE_HELP_TEXT_SUCCESS: "A fizetés sikeresen megtörtént.",
            PAYMENT_TYPE_LINK_HELP_TEXT_SUCCESS: "A fizetési link sikeresen elküldve.",
            PAYMENT_TYPE_LINK_HELP_TEXT: "A megadott e-mail-címre fizetési linket küldünk, amely a kedvezményezettet a fizetési szolgáltatóhoz irányítja a fizetés teljesítéséhez.",
            PAYMENT_TYPE_HELP_OP_TEXT_SUCCESS: "Az átutalási megbízás sikeresen feltöltve.",
            PAYMENT_DISCOUNT: "Fizetési mentesség",
            PAYMENT_DISCOUNT_TEXT: "Ön mentesül a fizetés alól. A megerősítés után átirányítjuk a kérelem oldalára.",
            PAYMENT_DISCOUNT_TEXT_SUCCESS: "A fizetési mentesség rögzítve.",
            PAYMENT_NO_FEES: "Díjmentes",
            PAYMENT_NO_FEES_TEXT: "A kérelemhez nem tartozik fizetendő díj. A megerősítés után átirányítjuk a kérelem oldalára.",
            PAYMENT_NO_FEES_TEXT_SUCCESS: "A kérelemhez nem tartozott fizetendő díj.",
            DETAILS: "Részletezés",
            CERTIFICATE_TOTAL_TAXES: "Digitális tanúsítványok költsége összesen",
            TOTAL_TAXES: "Díjak és láttamozások összesen",
            SECTION_TITLE: "Kérelem áttekintése és elküldése",
            TOTAL: "Összesen",
            SELECTED_REAL_ESTATES_TEXT: "nincs kiválasztott ingatlan | + 1 kiválasztott ingatlan | + {count} kiválasztott ingatlan",
            PAY_AS_YOU_GO_SUMMARY_TEXT: "Digitális aláírás",
            TAX_TEXT: "Díj",
            DISCOUNT: "Mentesség",
        },
        ENROLLMENT_DETAILS: {
            PERSON: {
                HEADER: "Személy típusa",
                INDIVIDUAL: "Természetes személy",
                LEGAL: "Jogi személy",
            },
            CITIZENSHIP: {
                HEADER: "Állampolgárság",
                ROMANIAN: "Román állampolgár",
                FOREIGNER: "Külföldi állampolgár",
            },
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Lakcím",
            CONTACT: "Elérhetőség",
            ADDRESS_COUNTY: "Megye",
            ADDRESS_STREET: "utca",
            ADDRESS_NUMBER: "sz.",
            ADDRESS_STAIRCASE: "lépcsőház",
            ADDRESS_APARTMENT: "lakás",
        },
        SEND_SUCCESS_TITLE: "Gratulálunk, kérelmét papírpazarlás nélkül küldte el! Eddig <span>{treeNumbers}</span> fát mentettünk meg.",
        SEND_SUCCESS_TEXT: "A(z) <strong>{number}</strong> számú kérelem sikeresen iktatva.</br> Miután elemeztük és ellenőriztük, értesítjük Önt (itt és e-mailben) a kérelem elbírálásáról.",
        PAYMENT_SUCCESS_TITLE: "A fizetés sikeresen rögzítve.",
        PAYMENT_FAILED_TITLE: "A fizetést nem sikerült feldolgozni.",
        PAYMENT_SUCCESS_TEXT: "A fizetés nem zárja le automatikusan a kérelmet. Folytassa a kérelem aláírásával és benyújtásával.",
        PAYMENT_FAILED_TEXT: "A fizetést a kérelemből újra megkísérelheti.",
        PAYMENT_FAILED_LINK_TEXT: "Új fizetési linkért forduljon az intézményhez.",
        PAYMENT_STEP_PAY: "Fizetés",
        PAYMENT_STEP_SIGN: "Aláírás",
        PAYMENT_STEP_SUBMIT: "Benyújtás",
        MISSING_PAYMENT_CALLBACK_PAYLOAD: "Hiba történt a fizetés feldolgozása során, kérjük, próbálja újra.",
        RESPONSE_MODAL: {
            APPROVE_APPLICATION_TITLE: "Jóváhagyási értesítés",
            REJECT_APPLICATION_TITLE: "Elutasítás indoka",
        },
        MODIFY_APPLICATION_TYPE_MODAL_TITLE: "Kérelemtípus módosítása",
        MODIFY_APPLICATION_TYPE_MODAL_LABEL: "Kérelem típusa",
        MODIFY_APPLICATION_TYPE_MODAL_PLACEHOLDER: "Válasszon új típust",
        ASSIGN_MODAL_TITLE: "Kérelem kijelölése",
        ASSIGN_REVIEWER_MODAL_TITLE: "Véleményező kiválasztása",
        APPROVE_REJECT_MODAL_TITLE: "Véleményezési válasz",
        ASSIGN_SUCCESS: "A kérelmet sikeresen kijelöltük <strong>{name}</strong> részére!",
        ASSIGN_ERROR: "A kérelmet nem sikerült kijelölni <strong>{name}</strong> részére",
        ASSIGN_MULTIPLE_SUCCESS: "A kiválasztott {count} kérelmet sikeresen kijelöltük <strong>{name}</strong> részére!",
        ASSIGN_MULTIPLE_ERROR: "A kiválasztott {count} kérelmet nem sikerült kijelölni <strong>{name}</strong> részére",
        SIGN_CONFIRMATION: {
            INVALID_PIN: "A kód érvénytelen, kérjük, próbálja újra",
            PIN_EXPIRED: "A kód lejárt, kérjük, próbálja újra",
            SESSION_EXPIRED: "A munkamenet lejárt, kérjük, próbálja újra",
            ERROR: "Hiba történt, kérjük, próbálja újra",
            BULK_FAILED: "A következő kérelmek nem írhatók alá {0}",
        },
        SIGN_AND_APPLY_LOADER: {
            TITLE: "A benyújtás néhány pillanatot vesz igénybe",
            TEXT: "Kérjük, várjon, a kérelem benyújtása folyamatban van, és néhány percet is igénybe vehet, papír- és időpazarlás nélkül.",
        },
        UPLOAD_DOCUMENTS_MODAL: {
            TITLE: "Dokumentumok hozzáadása",
        },
        CREATE_PAYMENT_MODAL: {
            TITLE: "Fizetés létrehozása",
            BUTTON: "Küldés",
        },
        DELETE_CONFIRMATION: "Biztos törli ezt a dokumentumot?",
        INFO_TEXT: {
            FIRST_CITIZEN_REVIEW_DATE: "Első beérkezett tisztázás",
            LAST_CITIZEN_REVIEW_DATE: "Utolsó beérkezett tisztázás",
            FIRST_STAFF_REVIEW_DATE: "Első elküldött tisztázás",
            LAST_STAFF_REVIEW_DATE: "Utolsó elküldött tisztázás",
        },
        COPY_FILE_MODAL: {
            TITLE: "Fájlnév megadása",
        },
        BULK_COPY_FILE_MODAL: {
            TITLE: "Másolandó fájlok kiválasztása",
            CONFIRM_MSG: "Biztos átmásolja az összes fájlt?",
        },
        DYNAMIC_FORMS: {
            GENERATE_BUTTON: "Generálás",
            CONFIGURE_POSITIONS: "Aláírások beállítási területe",
            CONFIGURE_POSITIONS_DESCRIPTIONS: "A végleges dokumentumon megjelenő aláírások és az aláírási sorrend beállítására szolgáló terület. </br> Ez a digitalizált folyamat a papíralapú, hagyományos aláírómappát váltja ki.",
            NUMBER_OF_ROWS: "Sorok",
            NUMBER_OF_COLUMNS: "Oszlopok",
            SIGN_TEXT_PREFIX: "Aláírás",
            SIGN_TEXT_ASSIGNED_STAFF: "Kijelölt ügyintéző",
            ADD_SIGNATURE: "Aláíró kiválasztása",
            SELECT_SIGNATURE: "Aláírás keresése",
            SAVE_CHANGES: "Módosítások mentése",
            SAVE_AS_NEW_TEMPLATE: "Mentés új sablonként",
            TEMPLATE_NAME: "Sablon neve",
            TEMPLATE_INFO_TEXT: "Válasszon egy korábban létrehozott sablont, vagy adjon meg egy új nevet",
            TEMPLATE_PLACEHOLDER: "Válasszon sablont",
            OVERWRITE_WARNING: "A módosítások mentése felülírja a kiválasztott sablont. Folytatja?",
            SELECT_AT_LEAST_ONE_TEMPLATE: "Válassza ki azt a sablont, amelyhez menteni szeretné a módosításokat",
            CONFIGURE_AT_LEAST_ONE_SIGNATURE: "A módosítások mentéséhez állítson be legalább egy aláírást",
            NO_TEXT_IN_DOCUMENT: "Kérjük, a generálás előtt írjon szöveget a dokumentumba",
            SIGNATURES_LOST: "A sorok vagy oszlopok beállításának módosításával a már beállított aláírások elvesznek. Folytatja?",
            DOCUMENT_DETAILS_TITLE: "Dokumentum részletei",
            DOCUMENT_DETAILS_DESCRIPTION: "A dokumentum tartalmának szánt terület",
            SELECT_TEMPLATE_DESCRIPTION: "Válasszon egy előre definiált sablont a tartalom és az aláírók betöltéséhez",
            INFO_TITLE: "Útmutató az aláírások beállításához az elektronikus űrlapokon - Ghișeul Unic",
            INFO_DESCRIPTION: "<div style='text-align: left'>Az alkalmazás felületének jobb oldalán található a generált dokumentumra kerülő <b>aláírások beállítására</b> szolgáló szakasz. </br></br> <b>Aláírási sorrend (jóváhagyási folyamat)</b> </br> </br> <li>Az egyes személyekhez rendelt aláírási index határozza meg, hogy az aláírások milyen sorrendben kerülnek a dokumentumra.</li> <li>Példa: <ul style='margin-top: 8px'>Az <b>1</b>-es indexű személy ír alá először.</ul><ul>A <b>2</b>-es indexű személy ír alá másodikként, és így tovább.</ul></li><li>Ez az index az aláírások hozzáadása után kézzel módosítható a konfigurátorban.</li> </br> <b>Megjelenítési sorrend a dokumentumban (vizuális pozíció)</b> </br> </br> <li><b>Az aláírások oldalon belüli elhelyezését</b> az határozza meg, hogy <b>milyen sorrendben szerepelnek a konfigurátor listájában</b>, az indextől függetlenül.</li> <li>Ez a sorrend határozza meg az aláírások oszlopba vagy sorokba rendezését, a választott formátumtól függően.</li> </br> <b>Kötelező szabály: az elnök pozíciója</b> </br> </br> <li>Az elnöknek mindig elsőként kell szerepelnie a listában, vagyis az övé a dokumentumon vizuálisan elsőként megjelenő aláírás, felül vagy bal oldalon (az elrendezéstől függően).</li><li>Ezt a pozíciót NEM befolyásolja az aláírási index.</li><li>Még ha az elnök ír is alá utoljára, neki kell elsőként megjelennie a megjelenített aláírások listájában.</li></div>",
            GENERATE_SUCCESS: "A generálás sikeresen megtörtént",
            SAVE_DRAFT_SUCCESS: "A piszkozat mentve",
            TEMPLATE_SUCCESS: "A sablon mentve",
            SAVING_DOCUMENT: "A dokumentum generálása folyamatban, ne töltse újra az oldalt.",
            PRESIDENT_POSITION_WARNING: "Az elnök aláírásának az első sorban kell lennie",
            MAX_ROWS_COLS_MESSAGE: "Kérjük, legalább 1 és legfeljebb 7 sort állítson be",
            GENERIC_ERROR_MESSAGE: "Hiba történt. Kérjük, próbálja újra.",
            NO_SIGNATURES: "A dokumentumhoz nincs aláírás csatolva. Kérjük, adjon hozzá legalább egy aláírást.",
            PRESIDENT_SIGNATURE_WARNING: "Az elnök aláírását az első sorba (felülre) kell hozzáadni, és neki kell utoljára aláírnia, az aláírási sorrend legmagasabb indexével.",
        },
        CLARIFICATIONS: {
            NO_CLARIFICATIONS: "Ehhez a kérelemhez nincsenek tisztázások",
            NO_SCHEMA: "Az űrlap sémája nem érhető el",
            STAFF_REQUEST: "Tisztázási kérés",
            CITIZEN_RESPONSE: "Állampolgár válasza",
            NO_CITIZEN_RESPONSE: "Az állampolgár még nem válaszolt erre a tisztázási kérésre",
        },
        FILTERS: {
            PROJECT_ID_ADD: "Hozzáadás",
            PROJECT_ID_INVALID: "Érvénytelen karakterek a szűrőben: ",
            PROJECT_ID_DUPLICATE: "Ez a szűrő már létezik",
        },
    },
    ARCHIVE: {
        BUTTONS: {
            MANUAL_ARCHIVE: "Manuális archiválás",
            ADD_WORKSPACE: "Munkaterület hozzáadása",
            DOWNLOAD: "Letöltés",
        },
        MENU: {
            DASHBOARD: "Irányítópult",
            DOCUMENTS: "Dokumentumok",
            ADMINISTRATION: "Adminisztráció",
        },
        WORKSPACE: {
            LIST: {
                TITLE: "Munkaterületek",
            },
            FIELDS: {
                NAME: "Megnevezés",
                ENTITY_TYPE: "Típus",
                CREATED_DATE: "Archiválás",
                DIMENSION: "Méret",
                FOLDERS_NUMBER: "Mappák száma",
                DESCRIPTION: "Leírás",
            },
            PLACEHOLDERS: {
                NAME: "Megnevezés",
                ENTITY_TYPE: "Típus",
                CREATED_DATE: "Archiválás",
            },
            FORM: {
                EDIT_TITLE: "Munkaterület szerkesztése",
                ADD_TITLE: "Munkaterület hozzáadása",
            },
        },
        SUBFOLDER: {
            LIST: {
                TITLE: "Dokumentumok",
            },
            FIELDS: {
                NAME: "Megnevezés",
                TYPE: "Típus",
                CREATED_DATE: "Archiválás",
                DIMENSION: "Méret",
                DOCUMENT_NUMBER: "Dokumentumok száma",
                WORKSPACE: "Munkaterület",
                DESCRIPTION: "Leírás",
                DOCUMENT_TYPE_CODE: "Dokumentumtípus",
            },
            PLACEHOLDERS: {
                NAME: "Megnevezés",
                ACHIVE_DATE: "Archiválás",
            },
            ACTIONS: {
                EDIT: "Mappa szerkesztése",
                ADD: "Mappa hozzáadása",
            },
            FORM: {
                WORKSPACE: "Munkaterület",
                TYPE: "Kapcsolódó dokumentumtípus",
                NAME: "Mappa megnevezése",
            },
        },
        DOCUMENTS: {
            LIST: {
                TITLE: "Dokumentumok",
            },
            FIELDS: {
                DOCUMENT_NAME: "Megnevezés",
                DOCUMENT_TYPE_NAME: "Típus",
                DOCUMENT_SIZE: "Méret",
                CREATED_DATE: "Létrehozás dátuma",
                UPDATED_DATE: "Módosítás dátuma",
            },
            PLACEHOLDERS: {
                NAME: "Megnevezés",
                ACHIVE_DATE: "Archiválás",
            },
            ACTIONS: {
                EDIT: "Mappa szerkesztése",
                ADD: "Mappa hozzáadása",
            },
        },
        DOCUMENT: {
            TITLE_MANUAL_ARCHIVE: "Manuális archiválás",
            TITLE_VIEW_ARCHIVE: "Archívum megtekintése",
            HEADERS: {
                ATTACHMENTS: "Mellékletek",
                DETAILS: "Részletek",
                METADATA: "Metaadatok",
            },
            FIELDS: {
                WORKSPACE: "Munkaterület",
                DOCUMENT_NAME: "Dokumentum neve",
                DOCUMENT_FOLDER: "Mappa",
                DOCUMENT_TYPE: "Dokumentumtípus",
            },
        },
        CONFIRMATION_TEXT: "Az adatok következetessége érdekében kérjük, ellenőrizze, hogy azok érvényesek és megfelelnek az archivált dokumentumoknak. Bármilyen későbbi módosításhoz kérjük, forduljon a rendszergazdához. Biztos menteni szeretné a dokumentumot?",
        MESSAGES: {
            SUCCESS: "A manuális archiválás sikeresen megtörtént!",
            ERRORS: "Hiba történt a manuális archiválás során!",
        },
        ATTACHMENTS: {
            PLACEHOLDER: "fájl kiválasztva",
            EMPTY: "Nincsenek csatolt dokumentumok.",
            EMPTY_WARNING: "A mentéshez az archívumnak csatolt fájlokat kell tartalmaznia.",
            LABEL: "Fájl",
            ADD_BUTTON: "Melléklet hozzáadása",
        },
        REPORTS: {
            WORKSPACE_LABEL: "Munkaterület",
            WORKSPACE_DIMENSION: {
                TITLE: "Archivált tárhely összesen",
                DESCRIPTION: "Munkaterület-jelentés",
            },
            EXPIRATION: {
                TITLE: "Lejárati határidő",
                DESCRIPTION: "Hamarosan lejáró dokumentumok",
                MONTHLY: "Ebben a hónapban",
                WEEKLY: "Ezen a héten",
            },
            WORKSPACE_DOCUMENTS: {
                TITLE: "Archivált dokumentumok száma összesen",
                DESCRIPTION: "Munkaterület-jelentés",
            },
            WORKSPACE_FOLDERS_DIMENSION: {
                TITLE: "Archivált dokumentumok teljes mérete munkaterületenként",
                CHART_LABELS_TITLE: "Mappák listája",
                DESCRIPTION: "Jelentés a munkaterület mappáiról",
            },
            WORKSPACE_FOLDERS_DOCUMENTS: {
                TITLE: "Archivált dokumentumok teljes száma munkaterületenként",
                CHART_LABELS_TITLE: "Mappák listája",
                DESCRIPTION: "Jelentés a munkaterület mappáiról",
            },
            WORKSPACE_PROGRESS_ANNUAL: {
                TITLE_DOC: "Archiválási előrehaladás ({period}) - dokumentumok",
                TITLE_DIMENSION: "Archiválási előrehaladás ({period}) - méret",
                TITLE_DESCRIPTION_DOC: "Archivált fájlok",
                TITLE_DESCRIPTION_DIMENSION: "Archivált fájlok mérete",
                TOTAL_DESCRIPTION_DOC: "Dokumentumok a kiválasztott időszakban",
                TOTAL_DESCRIPTION_DIMENSION: "Méret a kiválasztott időszakban",
                CHART_TITLE: "Elemzés",
                Y_AXIS_DOC: "Dokumentumok",
                Y_AXIS_DIMENSION: "Méret",
            },
        },
        PERIOD: {
            ANNUALY: "éves",
            MONTHLY: "havi",
            WEEKLY: "heti",
        },
    },
    FORMS: {
        LIST: {
            TITLE: "Űrlapfelületek",
            ADD_BUTTON: "Űrlap hozzáadása",
            TABLE_HEADER: "Űrlapfelület-modellek",
        },
        FIELDS: {
            NAME: "Megnevezés",
            STATUS: "Állapot",
            DESCRIPTION: "Leírás",
            TRANSLATABLE: "Automatikus fordítás (HU, EN)",
        },
        BUTTONS: {
            ADD: "Hozzáadás",
            DELETE: "Törlés",
        },
        PLACEHOLDERS: {
            NAME: "Név",
            STATUS: "Állapot",
        },
        ENUMS: {
            STATUS: {
                DRAFT: "Piszkozat",
                PUBLISHED: "Közzétéve",
            },
        },
        CREATE_MODAL: {
            TITLE: "Űrlapfelület mentése",
        },
        COMPONENTS: {
            FIELDS: {
                input: "Szövegmező",
                textarea: "Szövegterület",
                number: "Szám",
                radio: "Választógomb",
                checkbox: "Jelölőnégyzet",
                time: "Időpont",
                date: "Dátum",
                rate: "Értékelés",
                color: "Szín",
                select: "Legördülő lista",
                switch: "Kapcsoló",
                slider: "Csúszka",
                text: "Szöveg",
                blank: "Egyéni",
                fileupload: "Fájl",
                imgupload: "Kép",
                editor: "Szerkesztő",
                cascader: "Többszintű lista",
                table: "Altáblázat",
                grid: "Rács",
                section: "Szakasz",
                inline: "Soron belüli",
                tabs: "Tabok",
                divider: "Elválasztó",
                file: "Fájl",
                html: "HTML",
                "beneficiary-list": "Kedvezményezett",
                "applicant-form": "Kérelmező",
                "application-detail-form": "Kérelem részletei",
                "real-estate-list": "Ingatlan",
                "decision-list": "Határozatok",
                attachments: "Mellékletek",
                "urbanism-regulation-picker": "Szabályozások",
                "related-application": "Kapcsolódó dokumentumok",
                "offender-list": "Szabálysértő",
                "witness-list": "Tanú",
                "realty-list": "Építmény részletei",
                "staff-form": "Ügyintéző részletei",
                "gis-attachments": "GIS-mellékletek",
                "ac-tax-validator": "Minimális beruházási érték",
                richtexteditor: "HTML-szerkesztő",
                "locality-list": "Helyszínek részletei",
                "buildings-list": "Épülettestek",
                "urbanism-regulations-list": "RLU részletei",
                "gis-intersections": "GIS-metszetek",
                "document-expiry": "Dokumentum érvényessége",
                "document-extension": "Dokumentum meghosszabbítása",
                "repeatable-grid": "Ismételhető táblázat",
            },
            BASIC: {
                TITLE: "Alapkomponensek",
            },
            ADVANCE: {
                TITLE: "Speciális komponensek",
            },
            LAYOUT: {
                TITLE: "Elrendezés (Layout)",
            },
            CUSTOM: {
                TITLE: "Egyéni komponensek",
            },
        },
        DESCRIPTION: {
            CONTAINER_EMPTY: "Húzza át a bal oldali elemet a komponensek hozzáadásához",
            CONFIG_EMPTY: "Kérjük, adjon hozzá egy komponenst",
            TABLE_EMPTY: "Húzza át a bal oldali elemet a komponensek hozzáadásához",
            UPLOAD_JSON_INFO: "Alább látható a JSON-formátum, ezt felülírhatja saját JSON-kódjával",
        },
        MESSAGE: {
            COPY_SUCCESS: "Sikeres másolás",
            COPY_FAILED: "A másolás sikertelen",
            VALID_JSON: "Érvényes JSON",
            INVALID_JSON: "Érvénytelen JSON",
            VALID_ERROR: "Kérjük, töltse ki az összes kötelező mezőt.",
            UPLOAD_MAX_FILES: "Legfeljebb {max} fájl tölthető fel",
        },
        PLACEHOLDER: {
            PASTE_JSON: "Illessze be a JSON-t...",
        },
        ACTIONS: {
            IMPORT: "JSON importálása",
            CLEAR: "Törlés",
            PREVIEW: "Előnézet",
            JSON: "JSON generálása",
            CODE: "Kód generálása",
            GET_DATA: "Adatok lekérése",
            RESET: "Visszaállítás",
            COPY_DATA: "Adatok másolása",
            CANCEL: "Mégse",
            CONFIRM: "Megerősítés",
            ADD_OPTION: "Opció hozzáadása",
            ADD_COLUMN: "Oszlop hozzáadása",
            ADD_TAB: "Tab hozzáadása",
            UPLOAD: "Feltöltés",
            ADD: "Hozzáadás",
        },
        CONFIG: {
            FORM: {
                TITLE: "Űrlap attribútumai",
            },
            WIDGET: {
                TITLE: "Komponens attribútumai",
                MODEL: "ID",
                NAME: "Név",
                ALIAS: "Alias",
                META: "Meta",
                WIDTH: "Szélesség",
                HEIGHT: "Magasság",
                SIZE: "Méret",
                LABEL_WIDTH: "Címke szélessége",
                CUSTOM: "Egyéni",
                PLACEHOLDER: "Helyőrző",
                LAYOUT: "Elrendezés (Layout)",
                BLOCK: "Blokk",
                INLINE: "Soron belüli",
                CONTENT_POSITION: "Tartalom pozíciója",
                LEFT: "Balra",
                RIGHT: "Jobbra",
                CENTER: "Középre",
                SHOW_INPUT: "Beviteli mező megjelenítése",
                MIN: "Minimum",
                MAX: "Maximum",
                STEP: "Lépésköz",
                MULTIPLE: "Többszörös kiválasztás",
                FILTERABLE: "Kereshető",
                ALLOW_HALF: "Fél érték engedélyezése",
                SHOW_ALPHA: "Átlátszósági beállítások támogatása",
                SHOW_LABEL: "Címke megjelenítése",
                OPTION: "Opció",
                STATIC_DATA: "Statikus adatok",
                REMOTE_DATA: "Távoli adatok",
                REMOTE_FUNC: "Távoli függvény",
                VALUE: "Érték",
                LABEL: "Címke",
                OPTION_LABEL_HELP: "Az érték a kérelemben tárolódik, és a feltételekben ezt használjuk. A címke az a szöveg, amelyet az állampolgár lát, és ez kerül fordításra.",
                CHILDREN_OPTION: "Alopció",
                DEFAULT_VALUE: "Alapértelmezett érték",
                LIMIT: "Feltöltések maximális száma",
                IMAGE_ACTION: "Képfeltöltési cím",
                TIP: "Tájékoztató szöveg",
                ACTION: "Feltöltési cím",
                DEFAULT_TYPE: "Adattípus",
                STRING: "Szöveg",
                OBJECT: "Objektum",
                ARRAY: "Tömb",
                NUMBER: "Szám",
                BOOLEAN: "Logikai",
                INTEGER: "Egész szám",
                FLOAT: "Tizedes szám",
                URL: "URL",
                EMAIL: "E-mail",
                HEX: "Hexadecimális",
                GUTTER: "Rácsköz",
                COLUMN_OPTION: "Oszlopok beállítása",
                SPAN: "Rácskiterjedés",
                JUSTIFY: "Vízszintes igazítás",
                JUSTIFY_START: "Elejére",
                JUSTIFY_END: "Végére",
                JUSTIFY_CENTER: "Középre",
                JUSTIFY_SPACE_AROUND: "Térköz körül",
                JUSTIFY_SPACE_BETWEEN: "Térköz között",
                ALIGN: "Függőleges igazítás",
                ALIGN_TOP: "Fent",
                ALIGN_MIDDLE: "Középen",
                ALIGN_BOTTOM: "Lent",
                TYPE: "Típus",
                DEFAULT: "Alapértelmezett",
                CARD: "Tabok",
                BORDER_CARD: "Keretes kártya",
                TAB_POSITION: "Tab pozíciója",
                TOP: "Fent",
                BOTTOM: "Lent",
                TAB_OPTION: "Címke beállítása",
                TAB_NAME: "Tab neve",
                CUSTOM_CLASS: "Egyéni osztály",
                ATTRIBUTE: "Attribútumművelet",
                DATA_BIND: "Adatkötés",
                HIDDEN: "Rejtett",
                READONLY: "Csak olvasható",
                DISABLE: "Letiltva",
                CALCULATOR: "Kalkulátor",
                PRESELECTION: "Előzetes kiválasztás",
                CONVERT_NUMBER_TO_TEXT: "Szám átalakítása szöveggé",
                CONVERT_NUMBER_TO_TEXT_FROM_FIELD: "Szám átalakítása szöveggé a következő mezőből:",
                SUM_NUMBERS: "Számok összege",
                SUM_NUMBERS_FROM_FIELDS: "Számok összege a következő mezőkből:",
                MULTIPLY_NUMBERS: "Számok szorzása",
                MULTIPLY_NUMBERS_FROM_FIELDS: "Számok szorzása a következő mezőkből:",
                SUM_MONTHS: "Hónapok összege",
                SUM_MONTHS_FROM_FIELDS: "Hónapok összege a következő mezőkből:",
                DIFF_MONTHS: "Hónapok különbsége",
                DIFF_MONTHS_FROM_FIELDS: "Hónapok különbsége a következő mezőkből:",
                DIFF_DAYS: "Napok különbsége",
                DIFF_DAYS_FROM_FIELDS: "Napok különbsége a következő mezőkből:",
                PERCENTAGE_VALUE: "Százalékos érték",
                PERCENTAGE_VALUE_FROM_FIELDS: "Százalékos érték a következő mezőkből:",
                EDITABLE: "A szövegmező szerkeszthető",
                CLEARABLE: "Törlőgomb megjelenítése",
                ALLOW_CONTROL: "Nyilak használata az időpont kiválasztásához",
                IS_DELETE: "Törölhető",
                IS_EDIT: "Szerkeszthető",
                SHOW_PASSWORD: "Jelszó megjelenítése",
                VALIDATE: "Érvényesítés",
                REQUIRED: "Kötelező",
                CITIZEN_ID_CARD_VALIDATION: "Személyi igazolvány kötelező (természetes személy)",
                LEGAL_ENTITY_ID_CARD_VALIDATION: "Személyi igazolvány kötelező (jogi személy)",
                LEGAL_ENTITY_BANK_DETAILS_VALIDATION: "Banki adatok kötelezők (jogi személy)",
                PATTERN_PLACEHOLDER: "Adja meg a reguláris kifejezést",
                PATTERN_MESSAGE_PLACEHOLDER: "A reguláris kifejezés érvényesítési üzenete",
                NEW_OPTION: "Új opció",
                TAB: "Tab",
                VALIDATOR_REQUIRED: "Kötelező",
                VALIDATOR_TYPE: "Érvénytelen formátum",
                VALIDATOR_PATTERN: "Nem felel meg a mintának",
                COLLAPSIBLE: "Összecsukható",
                COLLAPSED: "Összecsukva (alapértelmezett)",
                SECTION_TITLE: "Cím",
                IS_CONDITIONED: "Feltételhez kötött",
                CONDITION: "Feltétel",
                FONT_SIZE: "Betűméret",
                IS_BOLD: "Félkövér",
                HIDE_LABEL: "Címke elrejtése",
                IS_SHARED: "Megosztott",
                SHOW_TOOLTIP: "Eszköztipp megjelenítése",
                TOOLTIP_TEXT: "Eszköztipp szövege",
                ROWS: "Sorok",
                MAX_ROWS: "Sorok maximális száma",
                PLAINTEXT: "Csak olvasható",
                ACCEPTED_FILE_TYPES: "Elfogadott fájltípusok",
                MAX_FILE_SIZE: "Maximális fájlméret: {0} MB",
                FILE_SIZE: "Fájlméret",
                FILE_TYPE: "Fájltípus",
                MAX_FILES: "Fájlok maximális száma",
                ADVANCED_CONDITIONS: "Speciális feltételek",
                CONDITION_EXPRESSION: "Feltételkifejezés",
                CONDITION_FIELD: "Mező",
                CONDITION_OPERATION: "Művelet",
                CONDITION_VALUE: "Érték",
                AUTOCOMPLETE_FORM: "Űrlap automatikus kitöltése",
                LOAD_ALL_GUEST_APPLICATIONS: "Minden kiállított irat, benyújtótól függetlenül",
                LOAD_ALL_ORG_APPLICATIONS: "Minden kiállított irat, szervezettől függetlenül",
                LOAD_EXTERNAL_DOCUMENTS: "Sorozatszám-foglalások betöltése",
                FORCE_SHOW_DOCUMENT_UPLOAD_BTN: "A feltöltőgomb mindig látható",
                DOCUMENT_KEY: "Dokumentumkulcs",
                CUSTOM_NOTFOUND_MESSAGE: "Egyéni hibaüzenet",
                COEFFICIENTS: "Együtthatók",
                UAT: "UAT",
                VILLAGE: "Település",
                COEFF_VALUE: "Együttható értéke",
                AC_TAX_CATEGORIES: "Díj szerkezeti rendszerenként",
                AC_TAX_A: "Szerkezeti rendszer A (beton)",
                AC_TAX_B: "Szerkezeti rendszer B (fa, kő)",
                AC_TAX_C: "Szerkezeti rendszer C (melléképületek)",
                AC_TAX_OTHER: "Egyéb",
                RU_SCOPE: "RU-cél",
                UTR_PDF_DOCUMENT_TEMPLATE: "Az UTR-ből generált PDF-hez használt dokumentumsablon",
                MIN_INSTANCES: "Példányok minimális száma",
                MAX_INSTANCES: "Példányok maximális száma",
                OPERATION_EQUAL: "Egyenlő",
                OPERATION_NOT_EQUAL: "Nem egyenlő",
                OPERATION_INCLUDES: "Tartalmazza",
                OPERATION_NOT_INCLUDES: "Nem tartalmazza",
                OPERATION_GREATER_THAN: "Nagyobb, mint",
                OPERATION_LESS_THAN: "Kisebb, mint",
                OPERATION_GREATER_THAN_OR_EQUAL: "Nagyobb vagy egyenlő",
                OPERATION_LESS_THAN_OR_EQUAL: "Kisebb vagy egyenlő",
                DEFAULT_OPTION: "{0}. opció",
                DEFAULT_TEXT: "Ez egy szöveg",
                RU_SCOPE_OTHER: "Egyéb",
            },
        },
        UPLOAD: {
            PREVIEW: "előnézet",
            EDIT: "csere",
            DELETE: "törlés",
        },
    },
    APPLICATION_TYPE: {
        LIST: {
            TITLE: "Kérelemtípusok",
        },
        ADD_BUTTON: "Új típus",
        FIELDS: {
            NAME: "Megnevezés",
            STATUS: "Állapot",
            DESCRIPTION: "Leírás",
            FORM_CITIZEN: "Állampolgári űrlapfelület",
            FORM_STAFF: "Ügyintézői űrlapfelület",
            REJECT_FORM_STAFF: "Ügyintézői elutasítási űrlapfelület",
            CLARIFICATION_FORM_CITIZEN: "Állampolgári tisztázási űrlapfelület",
            CLARIFICATION_FORM_STAFF: "Ügyintézői tisztázási űrlapfelület",
            DOCUMENT_TEMPLATE: "Ügyintézői dokumentumsablon",
            REJECT_DOCUMENT_TEMPLATE: "Ügyintézői elutasítási dokumentumsablon",
            CLARIFICATION_DOCUMENT_TEMPLATE: "Ügyintézői tisztázási dokumentumsablon",
            CLARIFICATION_DOCUMENT_TEMPLATE_CITIZEN: "Állampolgári tisztázási sablon",
            REVIEW_DOCUMENT_TEMPLATE: "Állampolgári tisztázási dokumentumsablon",
            PUBLIC_DOCUMENT_TEMPLATE: "Nyilvános dokumentum sablonja",
            APPLICATION_DOCUMENT_TEMPLATE: "Állampolgári dokumentumsablon",
            DOCUMENT_SERIES_TYPE: "Kimenő dokumentum sorozattípusa",
            APPLICATION_DOCUMENT_SERIES_TYPE: "Bejövő dokumentum sorozattípusa",
            FIRST_VIZA_SERIES_TYPE: "CFP-ellenjegyzés sorozattípusa",
            SECOND_VIZA_SERIES_TYPE: "Törvényességi ellenjegyzés sorozattípusa",
            REJECTION_VIZA_SERIES_TYPE: "Ellenjegyzés-elutasítás sorozattípusa",
            TAX_CATEGORY: "Díjkategória",
            CONSTRUCTION_TAX_CATEGORY: "Díjkategória 1 (construction_value metaadat)",
            LAND_TAX_CATEGORY: "Díjkategória 2 (land_value metaadat)",
            EXTRA_TAX_CATEGORY: "Díjkategória 3 (értékre alkalmazott egyéb díj)",
            APPLICATION_TYPE_REF: "Referenciadokumentumok",
            ARCHIVE_DOCUMENT_TYPE_CODE: "Archívumi dokumentumtípus",
            WORKFLOW: "Folyamat",
            SUB_WORKFLOW: "Alfolyamat",
            TENANT_ID: "Szervezet",
            IS_AUTO: "Automatikus típus",
            REMAINING_PERIOD: "Hátralévő idő",
            ORDER: "Prioritás a listában (sorrend)",
            DISCOUNTS: "Elérhető kedvezmények",
            UATS: "Elérhető UAT-ok",
            IS_INTERNAL: "Dokumentumtípus",
            IS_INBOUND_CATEGORY: "Bejövő",
            IS_INTERNAL_CATEGORY: "Belső",
            IS_OUTBOUND_CATEGORY: "Kimenő",
            IS_DYNAMIC_FORM: "Dinamikus űrlaptípus",
            HAS_DIGITAL_SEAL: "CertSign elektronikus bélyegző alkalmazása a kiállított iraton",
            HAS_STS_DIGITAL_SEAL: "STS elektronikus bélyegző alkalmazása a kiállított iraton",
            IS_GENERATING_PROJECT_ID: "Project ID generálása",
            DIGITAL_SEAL_CUSTOM_IMAGE_ID: "További kép hozzáadása a bélyegzőhöz",
            REVIEW_APPLICATION_TYPE_ID: "Kapcsolódó tisztázási feljegyzés",
            INTERNAL_APPLICATION_TYPE_ID: "Kapcsolódó belső dokumentum",
            DEPARTMENTS: "Osztályok",
            FUNCTIONS: "Beosztások",
            OPTION_APPLICATION: "Kérelem",
            OPTION_DOCUMENT: "Dokumentum",
            USAGE_CATEGORIES: "Használati kategóriák",
            VISIBLE_FOR: "Látható a következőknek",
            DOMAIN: "Szakterületek",
            ENTIRE_ORGANIZATION: "Teljes szervezet",
            EXPIRY_NOTIFICATION_ENABLED: "Értesítés a dokumentum lejáratáról",
            DAYS_BEFORE_EXPIRY: "Értesítési időszak (nap)",
            IS_EXPIRY_EXTENSION_TYPE: "Lejárat-meghosszabbítási kérelemtípus",
            IS_PCUEL_SYNCED: "PCUEL-lel szinkronizálva",
            THIRD_PARTY_EMAILS: "Harmadik felek e-mail címei",
        },
        FORM: {
            EDIT_TITLE: "Kérelemtípus szerkesztése",
            ADD_TITLE: "Új kérelemtípus",
            USAGE_CATEGORY: "Használati kategória",
            MAX_FILE_SIZE: "Legfeljebb 10MB (png, jpg, jpeg)",
            FILE_UPLOAD_INFO_MESSAGE: "Töltse fel a képet húzással vagy kattintással",
            FILE_UPLOAD_ERROR_INVALID: "A fájl érvénytelen!",
            FILE_UPLOAD_ERROR_SIZE: "A fájl túl nagy!",
            DEPARTMENTS_TREE: "Látható a következőknek (osztályok, beosztások, szolgálatok, részlegek)",
            INVALID_EMAIL: "Érvénytelen e-mail cím",
            DUPLICATE_EMAIL: "Ez az e-mail cím már hozzá van adva",
            THIRD_PARTY_EMAILS_PLACEHOLDER: "Adja meg az e-mail címet",
            THIRD_PARTY_EMAILS_ADD_BUTTON: "Hozzáadás",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
            DOMAIN: {
                URBANISM: "Urbanisztika",
                ADMINISTRATION: "Közigazgatás",
                CITY_HALL: "Polgármesteri hivatalok",
                APPROVALS: "Láttamozó hatóságok",
                ROADS: "Közlekedés",
                ECONOMIC: "Gazdasági",
                SUBORDINATION: "Alárendelt intézmények",
                MAPS: "Térképek",
                INVESTMENTS: "Beruházások",
                TOURISM: "Turizmus",
                EVENTS: "Bérbeadások",
            },
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
            STATUS: "Állapot",
            NO_REF_DOC: "Nincs referenciadokumentum",
            NO_DISCOUNTS: "Nincs kedvezmény",
            APPLY_DISCOUNT: "Kedvezmény alkalmazása vidéki UAT esetén",
            IS_TAX_FIXED: "Díj kérelmenként (helyszínek nélkül)",
            IS_TAX_CATEGORY_CONDITIONAL: "Értéktől függő díj",
            NO_UATS: "Nincs UAT",
            DOMAIN: "Szakterület",
            VISIBLE_FOR_DEPARTMENT: "Osztály",
            VISIBLE_FOR_SERVICE: "Szolgálat",
            VISIBLE_FOR_COMPARTMENT: "Részleg",
        },
        MESSAGES: {
            IS_AUTO: "Az automatikus típusnak nincsenek referenciadokumentumai",
        },
    },
    DOCUMENT_TEMPLATE: {
        LIST: {
            TITLE: "Dokumentumsablonok",
            ADD_BUTTON: "Új sablon",
            TABLE_HEADER: "Sablonok",
        },
        FIELDS: {
            NAME: "Megnevezés",
            DESCRIPTION: "Leírás",
            STATUS: "Állapot",
            CREATED_DATE: "Létrehozás dátuma",
            TYPE: "Rendszerszintű dokumentumsablon",
        },
        PLACEHOLDERS: {
            STATUS: "Állapot",
            NAME: "Név",
            TYPE: "Rendszerszintű dokumentumsablon",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
        },
        CREATE_MODAL: {
            TITLE: "Dokumentumsablon mentése",
        },
        EDIT_MODAL: {
            TITLE: "Dokumentumsablon szerkesztése",
        },
        FORM: {
            TITLE: "Dokumentumsablon",
            DOWNLOAD_BUTTON: "Letöltés",
            FIELDS_LIST_TITLE: "Mezők beszúrása",
            FIELDS_PANE_COLLAPSE: "Mezők elrejtése",
            FIELDS_PANE_EXPAND: "Mezők megjelenítése",
            ORGANISATION_LABEL: "Válassza ki a szervezetet",
            APPLICATION_TYPES_LABEL: "Válassza ki a kérelemtípust",
            RELATED_APPLICATION_TYPES_LABEL: "Válassza ki a kapcsolódó kérelemtípust",
            FORM_TYPE_LABEL: "Válassza ki az űrlap típusát",
            CITIZEN_LABEL: "Állampolgár",
            STAFF_LABEL: "Ügyintéző",
            CITIZEN_CLARIFICATION_LABEL: "Állampolgári tisztázások",
            STAFF_CLARIFICATION_LABEL: "Ügyintézői tisztázások",
            SELECT_TYPE: "Válassza ki a típust",
            APPLICATION_TYPE: "Kérelem",
            CONTROL_TYPE: "Ellenőrzés",
            FIELD_SEARCH_PLACEHOLDER: "Mező keresése...",
            NO_FIELDS_FOUND: "Nem található mező",
            SELECT_TYPE_TO_SEE_FIELDS: "Válasszon ki egy típust a mezők megtekintéséhez",
        },
    },
    PROCESS_EDITOR: {
        HEADER: "Folyamatkezelés",
        NEW_PROCESS_BTN: "Új folyamat",
        GENERAL: {
            HEADER: "Folyamatszerkesztő",
            HEADER_LIST: "Folyamatok listája",
            TITLE: "Új folyamat",
            SAVE_BTN: "Mentés",
            EDIT_BTN: "Szerkesztés",
            FIELDS: {
                NAME: "Megnevezés",
                DESCRIPTION: "Leírás",
                STATUS: "Állapot",
                EXECUTION_SCOPE: "Hatókör",
            },
            PLACEHOLDERS: {
                NAME: "Keresés megnevezés szerint",
                DESCRIPTION: "Leírás",
                EXECUTION_SCOPE: "Hatókör",
                MAIN: "Folyamat",
                SUBPROCESS: "Alfolyamat",
            },
        },
        TABS: {
            GENERAL: "Általános",
            STEPS: "Lépések",
        },
        STEPS: {
            HEADER: "Folyamatszerkesztő",
            HEADER_LIST: "Létrehozott lépések",
            EDIT_MODAL_HEADER: "Lépés szerkesztése",
            ADD_MODAL_HEADER: "Lépés hozzáadása",
            ADD_BTN: "Lépés hozzáadása",
            SAVE_LIST_BTN: "Lépések mentése",
            PUBLISH_BTN: "Közzététel",
            PUBLISH_MSG: "A kezdő lépés nem az első a listában! A lista nem tehető közzé.",
            PUBLISH_CONFIRM_MSG: "Biztos közzéteszi ezt a folyamatot? Ezután elérhető lesz használatra.",
            SHOW_GIS_INTERSECTION_SETTINGS_MODAL: "GIS-metszetek beállításai",
            EDIT_GIS_INTERSECTION_SETTINGS_MODAL_HEADER: "GIS-metaadat-leképezések szerkesztése a(z) \"{0}\" lépéshez",
            ADD_GIS_INTERSECTION_SETTINGS_MODAL_HEADER: "GIS-metaadat-beállítások mentése a(z) \"{0}\" lépéshez",
            EDIT_GIS_INTERSECTION_SETTINGS_VIEW_MODAL_HEADER: "Beállítások megtekintése",
            VIZA_SERIES_TYPE_FIRST_OPTION: "CFP-ellenjegyzés",
            VIZA_SERIES_TYPE_SECOND_OPTION: "Jogi ellenjegyzés",
            FIELDS: {
                NAME: "Lépés neve",
                ACTION_NAME: "Művelet",
                ACTION_TYPE: "Művelettípus",
                NEXT_STEP: "Következő lépés",
                CONDITIONAL_ROUTING: "Feltételes útválasztás",
                FILE_STATUS: "Fájl állapota",
                FILE_TYPE: "Fájltípus",
                EXTRA_DOCUMENT_TEMPLATE_ID: "Dokumentumsablon",
                EXTRA_DOCUMENT_VISIBILITY: "Generált fájl láthatósága",
                FUNCTION_TYPE: "Beosztás",
                SIGN_BY_ASSIGNED_USER: "Aláírás a kijelölt felhasználó által",
                APPLICATION_STATUS: "Kérelem állapota",
                RETURN_ACTION: "Visszatérés ide",
                SIGN_WITH_VIZA: "Aláírás ellenjegyzéssel",
                VIZA_SERIES_TYPE: "Ellenjegyzés sorozattípusa",
                CLARIFICATION_STATUS: "Tisztázás állapota",
            },
            PLACEHOLDERS: {
                NAME: "Név",
                ACTION_NAME: "Művelet",
                ACTION_TYPE: "Művelettípus",
                NEXT_STEP: "Következő lépés",
                CONDITIONAL_ROUTING: "Feltételes útválasztás",
                FILE_STATUS: "Fájl állapota",
                FILE_TYPE: "Fájltípus",
                EXTRA_DOCUMENT_TEMPLATE_ID: "Dokumentumsablon",
                EXTRA_DOCUMENT_VISIBILITY: "Generált fájl láthatósága",
                FUNCTION_TYPE: "Beosztás",
                APPLICATION_STATUS: "Kérelem állapota",
                CLARIFICATION_STATUS: "Tisztázás állapota",
                VIZA_SERIES_TYPE: "Ellenjegyzés sorozattípusa",
            },
            ACTIONS: {
                START: "Kezdet",
                END: "Vég",
            },
            GIS_INTERSECTIONS: {
                ADD_MAPPINGS: "Metaadatok hozzáadása",
                SAVE_MAPPINGS: "Metaadatok mentése",
                MAPPINGS_LIST_DESC: "Meglévő leképezések",
                GIS_VALUE_LABEL: "GIS-érték",
                GIS_VALUE_LABEL_EXTENDED: "A GIS-attribútum értéke",
                FIELDS: {
                    TENANT_ID: "Szervezet",
                    TENANT_NAME: "Szervezet",
                    LAYER_ID: "GIS Feature Layer",
                    LAYER_NAME: "GIS Feature Layer",
                    SUBLAYER_ID: "GIS-alréteg",
                    SUBLAYER_NAME: "GIS-alréteg",
                    GIS_ATTRIBUTE_ID: "GIS-attribútum",
                    GIS_ATTRIBUTE_NAME: "GIS-attribútum neve",
                    METADATA_NAME: "Ghișeul Unic-metaadat neve",
                    INTERSECTION_TYPE: "Metszet típusa",
                    METADATA_COMPLETION_METHOD: "Metaadat kitöltési módja",
                    GIS_ATTRIBUTE_VALUE_OVERRIDE: "Kézi érték",
                },
                PLACEHOLDERS: {
                    TENANT_ID: "Szervezet",
                    TENANT_NAME: "Szervezet",
                    LAYER_ID: "GIS Feature Layer",
                    LAYER_NAME: "GIS Feature Layer",
                    SUBLAYER_ID: "GIS-alréteg",
                    SUBLAYER_NAME: "GIS-alréteg",
                    GIS_ATTRIBUTE_ID: "GIS-attribútum",
                    GIS_ATTRIBUTE_NAME: "Attribútum-metaadat neve",
                    METADATA_NAME: "Ghișeul Unic-metaadat neve",
                    INTERSECTION_TYPE: "Metszet típusa",
                    METADATA_COMPLETION_METHOD: "Metaadat kitöltési módja",
                    GIS_ATTRIBUTE_VALUE_OVERRIDE: "Kézi érték",
                },
                ENUMS: {
                    INTERSECTION_TYPE: {
                        TOTAL: "Teljes metszet",
                        PARTIAL: "Részleges metszet",
                        NONE: "Nincs metszet",
                    },
                    METADATA_COMPLETION_METHOD: {
                        USE_GIS_VALUE: "Aktuális GIS-érték",
                        MANUAL: "Kézi kitöltés",
                    },
                },
            },
            REAL_ESTATE_PLACEMENT: {
                SHOW_SETTINGS_MODAL: "Elhelyezkedési terv rétegbeállításai",
                EDIT_SETTINGS_MODAL_HEADER: "Az elhelyezkedési terv látható rétegeinek szerkesztése a(z) \"{0}\" lépéshez",
                ADD_SETTINGS_MODAL_HEADER: "Az elhelyezkedési terv látható rétegeinek hozzáadása a(z) \"{0}\" lépéshez",
                ADD_LAYER: "Réteg hozzáadása",
                CONFIGURED_LAYERS: "Beállított rétegek",
                FIELDS: {
                    TENANT_ID: "Szervezet",
                    LAYER_ID: "ID",
                    LAYER_NAME: "Név",
                    OPACITY: "Átlátszatlanság",
                    SHOW_LABELS: "Címkék megjelenítése",
                    SUBLAYERS: "Alrétegek",
                },
                PLACEHOLDERS: {
                    TENANT_ID: "Válasszon szervezetet",
                    LAYER_ID: "Réteg-ID",
                    LAYER_NAME: "Réteg neve",
                },
                LAYER_ALREADY_EXISTS: "Ezt a réteget már hozzáadták.",
            },
        },
        ENUMS: {
            STATUS: {
                YES: "IGEN",
                NO: "NEM",
                DRAFT: "Piszkozat",
                ERROR: "Nincs közzétéve",
                PUBLISHED: "Közzétéve",
                PENDING: "Feldolgozás alatt",
            },
            EXECUTION_SCOPE: {
                MAIN: "Főfolyamat",
                SUBPROCESS: "Alfolyamat",
            },
            EXTRA_DOCUMENT_VISIBILITY: {
                PRIVATE: "Privát",
                PUBLIC: "Nyilvános",
            },
        },
        TABLE_HEADER: {
            TRANSITION: "Átmenet",
            ACTIONS: "Műveletek",
        },
        MESSAGES: {
            ALREADY_EXISTS: "Ilyen megnevezésű folyamat már létezik",
        },
    },
    GIS_INTERSECTIONS: {
        LIST_HEADER: "Metszetek listája",
        SINGLE: "Összesen {total} metszett helyszín",
        MULTIPLE: "Összesen {total} metszett helyszín",
        INTERSECTION_GIS_VALUE: "Érték a GIS-ből",
        INTERSECTION_MANUAL_VALUE: "Kézi érték",
        INTERSECTION_VIEW_MODAL_TITLE: "Metszetek: {0} {1}",
        INTERSECTION_SECTION_TITLE: "{0}. metszet",
        CARD: {
            METADATA: "Metaadat",
            LAYER_NAME: "Réteg",
            SUBLAYER_NAME: "Alréteg",
            CADASTRAL_NUMBER: "Kataszteri szám",
            UAT: "Megyei jogú város / Város / Község",
            ATTRIBUTE_NAME: "GIS-attribútum",
            VALUE: "Érték",
        },
        INTERSECTION_TYPE_LABEL: "Metszet típusa",
        INTERSECTION_TYPE: {
            TOTAL: "Teljes metszet",
            PARTIAL: "Részleges metszet",
            NONE: "Nincs metszet",
        },
        COMPLETION_METHOD_LABEL: "Metaadat kitöltési módja",
        METADATA_COMPLETION_METHOD: {
            USE_GIS_VALUE: "Aktuális GIS-érték",
            MANUAL: "Kézi kitöltés",
        },
        INTERSECTION_VIEW_MODAL_COUNTER: "{0}. metszet {1} közül",
    },
    PERMISSIONS: {
        HEADER: "Jogosultságok",
        FILTER: {
            TITLE: "Jogosultságok listája",
        },
        BUTTONS: {
            SET_PERMISSIONS: "Jogosultságok beállítása",
        },
        FIELDS: {
            NAME: "Név",
            PERMISSION_NAME: "Megnevezés",
            DESCRIPTION: "Leírás",
            CATEGORY: "Kategória",
            SCOPE: "Hatókör",
            ORGANISATIONS: "Szervezet",
            SYSTEM_DEFAULT: "Alapértelmezett hozzárendelés",
            DEFAULT_ASSIGNED_TO: "Alapértelmezett felhasználó",
            APPLY_DEFAULT_TO_ORGANISATION: "Alapértelmezett szervezet",
        },
        PLACEHOLDERS: {
            NAME: "Név",
            PERMISSION_NAME: "Megnevezés",
            CATEGORY: "Kategória",
        },
        FORM: {
            TITLE: "Jogosultságok beállítása",
            PERMISSIONS: "Jogosultságok",
        },
    },
    REAL_ESTATE: {
        FORM: {
            HEADER: "Helyszín hozzáadása",
            ADD_BTN: "Új helyszín hozzáadása",
            ADD_FILE_LABEL: "Kataszteri terv hozzáadása (pdf/zip)",
            ADD_FILE_BTN: "Fájlok kiválasztása",
            DUPLICATE_CADASTRAL_NUMBER: "Ez a kataszteri szám már hozzá van adva",
            DUPLICATE_CADASTRAL_NUMBER_PLURAL: "Néhány kiválasztott kataszteri szám már hozzá van adva",
            DIFFERENT_AREA: "A megadott terület eltér az ANCPI által nyilvántartott területtől",
            WRONG_COUNTY: "Kérelmet csak {county} megye területére lehet benyújtani",
            CADASTRAL_NUMBER_UNAVAILABLE: "Nincs kataszteri nyilvántartásban szereplő helyszínem (telekkönyvezett/telekkönyvi kivonattal rendelkező)",
            DRAW_PARCEL: "Helyszín rajzolása",
            DRAW_SEARCH_INTERSECT: "Helyszínek rajzolása és keresése",
        },
        VIEW: {
            ADDRESS: "Cím",
            CONTACT: "Elérhetőség",
            CADASTRAL_PLAN: "Kataszteri terv",
            NO_FILES: "Nincsenek fájlok",
            FILES_LABEL: "Azonosító fájlok",
        },
        SKETCH: {
            MODAL_HEADER: "Helyszín rajzolása",
            MODAL_HEADER_INTERSECT: "Helyszín keresése rajzolással",
            MODAL_HEADER_MIXED: "Helyszín rajzolása vagy keresése",
            VIEW_MODAL_HEADER: "Helyszín megtekintése",
            TITLE_UNDER_EDIT: "Használja a poligon rajzoló eszközt a térkép jobb alsó sarkában található eszköztárból a helyszín körvonalazásához. Kattintson a térképre a parcella minden egyes sarkánál, majd az utolsó ponton dupla kattintással fejezze be az alakzatot. Rajzolás után a körvonal módosítható a csúmópontok mozgatásával, vagy törölheti és újra rajzolhatja az eszköztárból. Miután a körvonal helyesen tükrözi a helyszínt, nyomja meg a 'Hozzáadás' gombot.",
            TITLE_UNDER_INTERSECT: "Használja a poligon rajzoló eszközt a térkép jobb alsó sarkában található eszköztárból egy olyan terület körvonalazásához, amely egy vagy több parcellát lefed. A rajzolás befejezése után (dupla kattintás az utolsó ponton) az alkalmazás automatikusan megkeresi a berajzolt területen található parcellákat; ezután a találati listából kiválaszthatja, mely parcellákat szeretné hozzáadni.",
            TITLE_UNDER_MIXED: "Használja a poligon rajzoló eszközt a térkép jobb alsó sarkában található eszköztárból a helyszín körvonalazásához. Ha a berajzolt terület átfedésben van egy vagy több meglévő parcellával, a találati listából kiválaszthatja, melyeket szeretné hozzáadni; ellenkező esetben a rajz új helyszínként kerül hozzáadásra.",
            INTERSECT_CANDIDATES_HEADER: "Talált helyszínek",
            INTERSECT_NO_MATCHES: "Nem található helyszín a berajzolt területen",
            INTERSECT_CADASTRAL_NUMBERS_LABEL: "Talált kataszteri számok, ANCPI-ban validálva",
            INTERSECT_VALIDATION_SUMMARY: "{valid} validálva az ANCPI-ban, {invalid} nem validált",
            INTERSECT_STATUS_SKETCH: "Nincs validálva az ANCPI-ban, vázlatként lesz hozzáadva",
            INTERSECT_UAT_UNRESOLVED: "Az UAT nem határozható meg",
            INTERSECT_SELECT_ALL: "Összes kijelölése / Kijelölés törlése",
        },
        SINGLE: "Összesen {total} helyszín",
        MULTIPLE: "Összesen {total} helyszín",
        REAL_ESTATES: "Helyszínek",
        SKETCHES: "Rajzolt helyszínek",
        NO_REAL_ESTATES: "Nincs hozzáadott helyszín",
        DOCUMENTS: "Dokumentumok",
        LIST_HEADER: "Helyszínek listája",
        MODAL: {
            ADD_HEADER: "Helyszín hozzáadása",
            SUMMARY_HEADER: "Az ingatlanok teljes listája",
            VIEW_COUNTER: "{0}. ingatlan {1} közül",
        },
        DETAILS_MODAL: {
            HEADER: "Helyszín részletei (ANCPI-lekérdezés dátuma: {date})",
            SUBHEADER_DESCRIPTION: "A. I. rész. Az ingatlan leírása",
            SUBHEADER_REGISTRATIONS_FIRST: "B. II. rész. Tulajdonosok és iratok",
            SUBHEADER_REGISTRATIONS_SECOND: "C. III. rész. TERHEK",
            NO_DATA: "Nincs adat",
            GENERAL: {
                HEADER: "Általános adatok",
                UAT: "UAT",
                CADASTRAL_NUMBER: "Kataszteri szám",
                PREVIOUS_CAD_NO: "Régi kataszteri szám",
                PREVIOUS_LAND_BOOK_NO: "Régi CF-szám",
                MEASUREAD_AREA: "Mért terület",
                LEGAL_AREA: "Jogi terület",
            },
            ADDRESS: {
                HEADER: "Cím",
                COUNTY: "Megye",
                ADMIN_UNIT: "UAT",
                LOCALITY: "Település",
                STREET_TYPE: "Utca típusa",
                STREET_NAME: "Utca",
                POSTAL_NUMBER: "Házszám",
                BUILDING_NUMBER: "Épület száma",
                BUILDING_PART_NUMBER: "Épület száma (rész)",
                FLOOR_NUMBER: "Emelet",
                BUILDING_UNIT_NUMBER: "Egység száma",
                POSTAL_CODE: "Irányítószám",
            },
            PARCELS: {
                TITLE: "Parcellák",
                HEADER: "{number}. parcella",
                MEASUREAD_AREA: "Mért terület",
                LEGAL_AREA: "Jogi terület",
                PROPERTY_TITLE_NO: "Birtoklevél",
                USE_CATEGORY: "Rendeltetés",
                IS_AGRICULTURAL: "Mezőgazdasági",
                INTRAVILAN: "Belterület",
            },
            BUILDINGS: {
                TITLE: "Építmények",
                HEADER: "{number}. épület",
                MEASUREAD_AREA: "Mért terület",
                LEGAL_AREA: "Jogi terület",
                USE_CATEGORY: "Rendeltetés",
                LEGAL: "Jogszerű",
            },
            OWNERS: {
                HEADER: "Tulajdonosok",
                NAME: "Név",
                CNP: "CNP",
                OWNERSHIP_TYPE: "Tulajdon típusa",
                IS_PART_HOLDER: "Résztulajdonos",
                DESCRIPTION: "{registration_type}, jog: {right_type}, szerzés jogcíme: {property_transfer_type}, jelenlegi hányad: {actual_quota}.",
            },
            REGISTRATIONS: {
                HEADER_FIRST: "A tulajdonjogra és más dologi jogokra vonatkozó bejegyzések",
                HEADER_SECOND: "A tulajdonjog részjogosítványaira, a dologi biztosítéki jogokra és a terhekre vonatkozó bejegyzések",
                DEED_TEXT: "{type}, szám: {number}, kelt: {date}, kiállította: {issuer}",
                INTAB_DESCRIPTION: "Telekkönyvi bejegyzés, jog: {right_type} {right_comment}, szerzés jogcíme: {transfer_type}, jelenlegi hányad: {quota}",
            },
        },
        CARD: {
            CADASTRAL_NUMBER: "Kataszteri szám",
            UAT: "UAT",
            LAND_AREA: "Terület",
            ADDRESS_COUNTY: "{county} megye",
            CATEGORY: "Kategóriakód",
            MISSING_COORDINATES_MESSAGE: "Hiányzó ANCPI-koordináták",
        },
    },
    METADATA_MAPPING: {
        FIELDS: {
            METADATA: "GU-metaadat",
            ARCHIVE_METADATA_NAME: "Archívum-metaadat neve",
            ALIAS: "GU-metaadat címkéje",
            ARCHIVE_METADATA_LABEL: "Archívum-metaadat címkéje",
        },
        PAGE_TITLE: "Archívum-metaadatok megfeleltetése a GU-metaadatoknak",
        TABLE_TITLE: "Meglévő megfeleltetések listája",
        FORM: {
            ARCHIVE: {
                DOC_TYPE: "Válasszon dokumentumot",
                METADATA: "Válasszon metaadatot - Archívum",
            },
            GU: {
                APP_TYPE: "Válasszon kérelemtípust",
                METADATA: "Válasszon metaadatot - GU",
            },
        },
        MANDATORY_NOTE: "Az (M) előtaggal jelölt opciók kötelezőek.",
        CONFIRMATION_MESSAGE: "A(z) <strong>{label}</strong> archívum-metaadat már a(z) <strong>{metadata}</strong> GU-metaadathoz van rendelve. <hr> Felül szeretné írni ezzel: <strong>{text}</strong>?",
        TABLE_TITLE_FOR: "Meglévő megfeleltetések listája: {appType}",
    },
    ATLAS: {
        MENU: {
            LAYER_MANAGER: "Atlasz",
            MY_APPLICATIONS: "Kérelmeim",
            INTEREST_ZONES: "Érdeklődési területek",
            DISTANCE: "Távolság",
            ARIA: "Terület",
            SEARCH: "Keresés",
            HELP: "Súgó",
            VISIBILITY_MANAGER: "Láthatósági beállítások",
            PARCEL_SEARCH: "Ingatlan keresése",
            ARCGIS_APPS: "GIS-alkalmazások",
        },
        LAYER_MANAGER: {
            TITLE: "Térképkezelő",
            SEARCH_LAYER: "Rétegek keresése",
            MORE_ACTION: {
                SHARE: "Megosztás",
                EDIT: "Szerkesztés",
                EXPORT: "Exportálás",
                DELETE: "Törlés",
                PUBLISH: "Közzététel",
            },
            ATLAS_LABEL: "Atlasz-rétegek",
            APPS_LABEL: "GIS-alkalmazások",
            ORGANISATION_LABEL: "Szervezeti rétegek",
            PRIVATE_LABEL: "Rétegeim",
            IMPORT_LAYER_LINK: "importáljon egy réteget",
            EMPTY_LAYER_TEXT: "Nincsenek rétegek",
            EMPTY_ARCGIS_APPS_TEXT: "Nincsenek GIS-alkalmazások",
            UPLOADING: "Feltöltés...",
            UPLOAD_DONE: "A réteg feltöltése sikeres!",
            UPLOAD_ERROR: "Hiba a réteg feltöltésekor!",
            UPLOAD_MORE: "Szeretne másik réteget feltölteni?",
            UPLOAD_TRY: "Próbálja újra!",
            DELETE_MODAL_TITLE: "Biztos törli ezt a réteget?",
            DELETE_ARCGIS_APP_MODAL_TITLE: "Biztos törli ezt a GIS-alkalmazást?",
            DELETE_MODAL_SUBTITLE: "Az alrétegek összes adata elvész.",
            UPLOAD_LAYER: {
                TITLE: "Új réteg feltöltése (.ZIP)",
            },
            UPDATE_CONTAINER_TITLE: "Container szerkesztése",
            UPDATE_LAYER_TITLE: "Réteg szerkesztése",
            ADD_LAYER_TITLE: "Réteg hozzáadása",
            ADD_LAYER_BY_ID_BTN: "Réteg hozzáadása ID alapján",
            TOOLTIP_TEXT: "A réteg elérhető itt:",
            TOOLTIP_URL: "gis.cluj.archi",
            SYSTEM_LAYER: "Rendszerréteg",
            LAYER_SYNC_SUCCESS: "A réteg frissítése sikeres.",
            LAYER_SYNC_ERROR: "A réteget nem sikerült frissíteni.",
            SHOW_LEGEND: "Jelmagyarázat megjelenítése",
            HIDE_LEGEND: "Jelmagyarázat elrejtése",
            LAYER_TITLE: "Réteg címe",
        },
        LAYER_PRESETS: {
            TITLE: "Térképtémák",
            PREDEFINED_TITLE: "Előre definiált szűrők",
            PERSONAL_TITLE: "Saját szűrők",
            ADD_BTN: "Szűrő hozzáadása",
            PREDEFINED_ADD_BTN: "Előre definiált szűrő hozzáadása",
            SAVE_BTN: "Mentés",
            APPLY_BTN: "Alkalmazás",
            DELETE_BTN: "Törlés",
            NAME_PLACEHOLDER: "Szűrő neve...",
            EMPTY_TEXT: "Nincsenek mentett szűrők.",
            PREDEFINED_EMPTY_TEXT: "Nincsenek előre definiált szűrők.",
            PREDEFINED_SELECT_ORG_CTA: "Válassza ki az intézményt",
            SAVE_SUCCESS: "A szűrő mentve.",
            PREDEFINED_SAVE_SUCCESS: "Az előre definiált szűrő mentve.",
            HELP_TITLE: "Hogyan működik?",
            HELP_TEXT: "Mentse el az aktuális rétegláthatósági beállítást névvel ellátott szűrőként. Alkalmazzon egy mentett szűrőt, hogy gyorsan visszaállítsa ugyanazt a rétegláthatósági beállítást.",
            APPLY_SUCCESS: "A szűrő alkalmazva.",
            DELETE_SUCCESS: "A szűrő törölve.",
            PREDEFINED_DELETE_SUCCESS: "Az előre definiált szűrő törölve.",
            DELETE_CONFIRM_TITLE: "Törli a szűrőt?",
            DELETE_CONFIRM_TEXT: "Ez a művelet nem vonható vissza.",
            PREDEFINED_DELETE_CONFIRM_TITLE: "Törli az előre definiált szűrőt?",
            PREDEFINED_DELETE_CONFIRM_TEXT: "Ez a művelet nem vonható vissza.",
        },
        LAYER_SETTINGS: {
            TITLE: "Alréteg beállítások",
            SELECT_SUBLAYER: "Alréteg kiválasztása",
            SELECT_SUBLAYER_PLACEHOLDER: "-- Válasszon alréteget --",
            ALLOW_FEATURES_TABLE: "Attribútumtábla megjelenítésének engedélyezése",
            ALLOW_COMMENTS: "Megjegyzések engedélyezése",
            SHOW_ID_COLUMN: "ID-oszlop megjelenítése",
            SELECT_ID_COLUMN_FIRST: "Először válasszon egy ID-oszlopot a kiválasztott attribútumok közül",
            NAME_COLUMN_FORMAT: "Alrétegtábla fejlécoszlopának formátuma",
            NAME_COLUMN_FORMAT_PLACEHOLDER: "pl.: {field1} - {field2}",
            NAME_FORMAT_INVALID: "Érvénytelen formátum: a mezőknek a kiválasztott attribútumok közül kell származniuk",
            SELECT_ATTRIBUTES: "Válassza ki a látható attribútumokat",
            SELECTED_ATTRIBUTES: "Kiválasztott attribútumok",
            LOADING_ATTRIBUTES: "Attribútumok betöltése...",
            ATTRIBUTE_FETCH_ERROR: "Hiba az attribútumok ArcGIS-ből való betöltése során",
            ALIAS: "Alias",
            SEARCHABLE: "Kereshető",
            USE_AS_ID: "Használat ID-ként",
        },
        APPLICATIONS_MANAGER: {
            TITLE: "Kérelmeim",
        },
        INTEREST_AREAS_MANAGER: {
            TITLE: "Érdeklődési területeim",
            TITLE_TOOLTIP: "Új érdeklődési terület hozzáadásához használja a térkép menüjében található területmérési opciót. A terület kijelölésének befejezéséhez kattintson duplán.",
            AREA: "Terület",
            NOTIFICATIONS: "Értesítések",
            NOTES: "Jegyzetek",
            PERIMETER: "Kerület",
            ADD_NEW_ZONE_TITLE: "Új érdeklődési terület hozzáadása",
            EDIT_NEW_ZONE_TITLE: "Érdeklődési terület szerkesztése",
            NOTES_PLACEHOLDER: "Adjon meg kulcsfontosságú információkat",
            BUTTONS: {
                NEW_AREA: "Új terület",
            },
            DELETE_CONFIRMATION_TEXT: "Biztos törli az érdeklődési területet?",
        },
        INTERSECTION_MANAGER: {
            TITLE: "Megjelölt hely",
            INFO_LAYER_TEXT: "Információk",
            CU_INFO_LAYER_TEXT: "Urbanisztikai bizonyítvány",
            AUTHORIZATION_INFO_LAYER_TEXT: "Engedély",
            DETAILS_TEXT: "Részletek",
            SIRUTA_LABEL: "SIRUTA",
            COUNTY_NAME_LABEL: "Megye megnevezése",
            COUNTY_INDICATIV_LABEL: "Megye kódja",
            UAT_LABEL: "UAT megnevezése",
            APPROVAL_YEAR_LABEL: "PUG jóváhagyásának éve",
            YEAR_OF_EXTENSION_LABEL: "PUG meghosszabbításának éve",
            NO_YEAR_OF_EXTENSION: "Nem alkalmazható",
            URBANISM_REGULATION_LABEL: "Urbanisztikai szabályozások",
            APPLICATION_ISSUED_DATE: "Kiállítás dátuma",
            APPLICATION_TYPE: "Típus",
            APPLICATION_STATUS: "Állapot",
            HELP_TEXT: "Nincs találat, válasszon ki egy pontot a térképen!",
            TAB_LABEL: "Metszet",
            APPLICATION_STATUSES: {
                DRAFT: "Piszkozat",
                NEW: "Új",
                EMITTED: "Lezárva",
                REJECTED: "Elutasítva",
            },
        },
        INTERSECTION_DETAILS_MODAL: {
            HEADER: "Megjelölt hely adatai",
            RLU_RT: "Műszaki szabályozás",
            RLU_RJ: "Jogi szabályozás",
            RLU_RE: "Gazdasági szabályozás",
            RLU_POT: "POT",
            RLU_CUT: "CUT ",
            RLU_RDA: "Frissítési szabályozás",
        },
        SUBLAYER_MANAGER: {
            TAB_LABEL: "Réteg részletei",
            SUBLAYER_NAME: "Alréteg megnevezése",
            SUBLAYER_ACTIONS: "Műveletek",
            EMPTY_SUBLAYERS_TEXT: "Nincsenek alrétegek",
            SCALE_RANGE_SLIDER_TITLE: "Alréteg paraméterei",
            SUGGEST_SCALE_RANGE_TEXT: "Méretarány javaslása",
            SCALE_RANGE_SLIDER_TEXT: "Méretarány",
            OPACITY_SLIDER_TEXT: "Átlátszatlanság",
            CLUSTERING_CHK_LABEL: "Klaszterezés",
            HEATMAP_CHK_LABEL: "Hőtérkép",
            FEATURES: {
                FEATURES_TABLE: "Parcellák listája",
                FEATURE_ATTRIBUTES: "Attribútumok",
                NAME: "Megnevezés",
                ACTION: "Művelet",
                COMMENTS: "Megjegyzések",
                NO_COMMENTS: "Még nincsenek megjegyzések.",
                DELETE: "Törlés",
                DELETE_COMMENT_TITLE: "Megjegyzés törlése",
                DELETE_COMMENT_MESSAGE: "Biztos törli ezt a megjegyzést? A művelet nem vonható vissza.",
                ADD_PLACEHOLDER: "Írjon megjegyzést...",
                SUBMIT: "Küldés",
                NO_SELECTION: "Válasszon ki egy parcellát a részletek és a megjegyzések megtekintéséhez.",
                SEARCH_PLACEHOLDER: "Keresés...",
                CLEAR_FILTER: "Szűrő törlése",
                ID: "ID",
                COMMENTS_UNAVAILABLE_NO_ID: "Ennek az elemnek nincs felismerhető azonosító mezője, ezért nem lehet hozzászólni.",
                NO_FEATURES: "Nem található parcella",
                EDITED: "(Szerkesztve)",
                EDIT: "Szerkesztés",
                VIEW_DETAILS: "Részletek megtekintése",
                COPY_QR_LINK: "QR link másolása",
                QR_LINK_COPIED: "QR link kimásolva",
                QR_LINK_COPY_ERROR: "A QR linket nem sikerült kimásolni",
            },
        },
        SWIPE: {
            SET_LEADING: "Összehasonlító réteg (bal)",
            SET_TRAILING: "Összehasonlító réteg (jobb)",
            SWIPE_LEFT: "Összehasonlítás (bal)",
            SWIPE_RIGHT: "Összehasonlítás (jobb)",
            CLEAR: "Összehasonlítási rétegek törlése",
            TOGGLE_ON: "Kattintson a rétegek összehasonlításához",
            TOGGLE_OFF: "Kattintson az összehasonlítás leállításához",
        },
        COMMENTS_MANAGER: {
            COMMENTS: "Megjegyzések",
            ADD_COMMENT: "Megjegyzés hozzáadása",
            DELETE_COMMENT: "Megjegyzés törlése",
            DELETE_ALL_COMMENTS: "Beszélgetés törlése",
            REPLY_TO_COMMENT: "Válasz a megjegyzésre",
            EMPTY_COMMENTS_TEXT: "Nincsenek megjegyzések",
            INSTRUCTIONS: "Dupla kattintással válasszon ki egy pontot a térképen",
            CONFIRMATION_MESSAGE_DELETE: "Biztos törli az üzenetet?",
            CONFIRMATION_MESSAGE_DELETE_ALL: "Biztos törli a teljes beszélgetést?",
        },
        VISIBILITY_MANAGER: {
            TITLE: "Láthatósági beállítások",
            ORDER_COLUMN_HEADER: "Sorrend",
        },
        CREATE_LAYER_MODAL: {
            HEADER: "Új réteg hozzáadása",
            ERROR: "A kiválasztott RU-hatókörrel már létezik Container!",
        },
        HOME_BUTTON: {
            TITLE: "Kezdőnézet",
        },
        PARCEL_SEARCH: {
            SHOW_PARCEL_SEARCH: "Ingatlan keresése",
            HIDE_PARCEL_SEARCH: "Ingatlankeresés bezárása",
            COUNTY_PLACEHOLDER: "Válasszon megyét",
            UAT_PLACEHOLDER: "Válasszon UAT-ot",
            CADASTRAL_NUMBER_PLACEHOLDER: "Adja meg a telekkönyvi számot",
            MODAL: {
                HEADER: "Ingatlankeresés",
            },
            TITLE: "Ingatlankeresés",
            SEARCH_BTN: "Ingatlan keresése",
            SEARCH_HISTORY_LABEL: "Keresési előzmények",
        },
        LAYER_ATTRIBUTE_SEARCH: {
            TITLE: "Keresés a rétegekben",
            PLACEHOLDER: "UAT / kataszteri szám / kérelemszám",
            LOADING: "Keresés...",
            NO_RESULTS: "Nincs találat",
            SUMMARY: "{count} találat {groups} rétegben",
        },
        PUBLISH_LAYER_MODAL: {
            HEADER: "Réteg közzététele",
        },
        ARCGIS_APPS_MODAL: {
            ADD_NEW_APPLICATION: "Alkalmazás hozzáadása",
            HEADER_EDIT: "GIS-alkalmazás szerkesztése",
            HEADER_ADD: "GIS-alkalmazás hozzáadása",
        },
        COMPARE_LAYER_MODAL: {
            HEADER: "Rétegek összehasonlítása",
            TEMPLATE_LAYER: "Cél",
            TEMPLATE_LAYER_LABEL: "Sablonréteg szerkezete",
            SOURCE_LAYER: "Forrás: {layer}",
            SOURCE_LAYER_LABEL: "Forrásréteg szerkezete",
            FORCE_PUBLISH: "Közzététel kényszerítése",
            STATUS: {
                READY: "A réteg készen áll a közzétételre.",
                NOT_READY: "A réteg nem tehető közzé, mert a szerkezete nem felel meg a sablonréteg szerkezetének.",
            },
        },
        LAYER_DETAILS: {
            TITLE: "Réteg részletei: {name}",
            GENERAL_INFO: "Általános információk",
            GIS_DETAILS: "GIS-részletek",
            ID: "ID:",
            LAYER_TYPE: "Rétegtípus:",
            ACCESS_LEVEL: "Hozzáférési szint:",
            CONTAINER_ID: "Container ID:",
            CREATED_DATE: "Létrehozás dátuma:",
            RU_SCOPE: "RU-hatókör:",
            UAT_NAME: "UAT:",
            UAT_ID: "UAT ID:",
            OWNER_ORG_NAME: "Tulajdonos szervezet:",
            OWNERSHIP_TYPE: "Tulajdonlási modell:",
            FEATURE_SERVICE_URL: "Feature Service URL:",
            GIS_LAYER_ID: "GIS-réteg ID:",
        },
        FIELDS: {
            NAME: "Réteg megnevezése",
            CONTAINER_NAME: "Container megnevezése",
            ACCESS_LEVEL: "Hozzáférési szint",
            OWNERSHIP_TYPE: "Frissítés típusa",
            ORGANIZATION: "Szervezet",
            LAYER_TYPE: "Rétegtípus",
            CONTAINER_LAYER: "Válasszon Containert az Atlaszból",
            RU_SCOPE: "RU-hatókör",
            UAT: "UAT",
            USE_AS_TEMPLATE: "Szerkezet hozzáadása az összes UAT-hoz",
            DECISION: "HCL (amellyel elfogadták)",
            HAS_DECISION: "Nem alkalmazható",
            LAYER: "Válasszon réteget az Atlaszból",
            OWNER: "Tulajdonos",
            PUBLISH_NAME: "Név",
            TEMPLATE_NAME: "Név",
            GEOMETRY_TYPE: "Geometriatípus",
            STATUS: "Állapot",
            DECISION_ID: "Válasszon H.C.L.-t",
            TEMPLATE_LAYER_ID: "Sablonréteg",
            ARCGIS_IMPORTED_ITEM: "GIS-réteg azonosítója",
            ARCGIS_IMPORTED_ITEM_TYPE: "GIS-réteg típusa",
            TITLE: "Cím",
            NOTES: "Jegyzetek",
            NOTIFICATION_ENABLED: "Értesítések bekapcsolva",
            SURFACE: "Terület",
            PERIMETER: "Kerület",
            ARCGIS_IMPORTED_ITEM_IS_LINKED: "Hozzáadás duplikálás nélkül",
            PRIVATE_LAYER_OWNERSHIP_TYPE: "Privát réteg vagy szervezeti réteg",
            FEATURE_SERVICE_URL: "GIS feature URL",
            GIS_LAYER_ID: "GIS-réteg azonosítója",
            APP_ID: "Alkalmazás ID",
            APP_NAME: "Alkalmazás neve",
            APP_URL: "Alkalmazás URL-je",
            CAN_ACCESS_CITIZEN: "Az állampolgárok számára látható az \"Atlasz-előnézet\" nézetben",
            CAN_ACCESS_STAFF: "Az ügyintézők számára látható az \"Atlasz-előnézet\" nézetben",
            APPLICATION_TYPE: "Kapcsolódó kérelemtípus",
            APPLICATION_TYPE_HELP_TITLE: "Mire használjuk ezt?",
            APPLICATION_TYPE_HELP_TEXT: "Az ezekkel a kérelemtípusokkal rendelkező kérelmek pinpointjai szinkronizálva lesznek ezzel a réteggel.",
            INTEREST_AREA_NOTIFICATIONS: "Érdekzóna-értesítések engedélyezése",
            DELETE_PINPOINT_ON_REJECTION: "Pinpoint törlése elutasításkor",
        },
        ENUMS: {
            LAYER_TYPE: {
                CONTAINER: "Container",
                SIMPLE: "Egyszerű",
            },
            ACCESS_LEVEL: {
                PRIVATE: "Privát",
                PUBLIC: "Nyilvános",
                PROTECTED: "Védett",
            },
            OWNERSHIP_TYPE: {
                CENTRALIZED: "Központosított",
                DISTRIBUTED: "Elosztott",
            },
            RU_SCOPE: {
                PUG: "PUG",
                PUZ: "PUZ",
                PUD: "PUD",
                OTHER: "Egyéb",
            },
            STATUS: {
                OK: "OK",
                MISSING: "Hiányzik",
                NEW: "Új",
                COMPLETED: "Teljes",
                PENDING: "Feldolgozás alatt",
            },
            ARCGIS_IMPORTED_ITEM_TYPE: {
                FEATURE_SERVER: "Feature Server",
                SHAPEFILE: "Shapefile",
            },
            PRIVATE_LAYER_OWNERSHIP_TYPE: {
                PLOT_PRIVATE: "Privát réteg",
                PLOT_ORGANISATION: "Szervezeti réteg",
            },
            GEOMETRY_TYPE: {
                POLYGON: "Poligon",
            },
        },
        EDIT_MODAL: {
            LAYER_NAME: "Megnevezés",
            SUBLAYER_NAME: "Urbanisztikai övezetek",
            ACCESS_LEVEL: "Hozzáférési szint",
            OWNER: "Szervezet",
            RU_SCOPE: "RU hatóköre",
            UAT: "UAT",
            TYPE: "Típus",
            STATUS: "Állapot",
            TEMPLATE: "Sablon",
            UPLOAD_BROWSE_TXT: "Fájl kiválasztása",
            UPLOAD_BROWSE_PLACEHOLDER: "Válasszon egy fájlt, vagy húzza ide...",
            DUPLICATE_LAYER_NAME: "Ez a rétegnév már létezik!",
            SUBLAYERS_LIST: "Alrétegek listája",
        },
        BUTTONS: {
            ADD_SIMPLE_LAYER: "Egyszerű réteg hozzáadása",
            CLOSE_SIMPLE_LAYER: "Egyszerű réteg hozzáadásának bezárása",
            UPDATE_CONTAINER: "Container szerkesztése",
        },
        PUBLISH_STATUS: {
            PUBLISHED: "Közzétéve",
            NOT_PUBLISHED: "Nincs közzétéve",
            NEW: "Új",
            PENDING: "Feldolgozás alatt",
            ERROR: "Hiba",
            COMPLETED: "Közzétéve",
            MESSAGE_SUCCESS: "A réteg sikeresen közzétéve az Atlaszban",
            MESSAGE_FAILED: "A réteget nem sikerült közzétenni az Atlaszban. Kérjük, próbálja újra",
            MESSAGE_CONFIRMATION: "A közzététel néhány percet vesz igénybe. Ezalatt tovább használhatja az alkalmazást. A közzététel eredményét az oldal újratöltése után a rétegen követheti nyomon.",
        },
        POPUP_TEMPLATE_INFO_FIELDS: {
            APPLICATION_STATUS: "Kérelem állapota",
            APPLICATION_ID: "Kérelemazonosító",
            COLOR: "Szín",
            CADASTRAL_NUMBER: "Kataszteri szám",
            COMBINED_ID: "Kombinált azonosító",
            APPLICATION_TYPE: "Kérelem típusa",
            APPLICATION_TYPE_NAME: "Kérelemtípus neve",
            APPLICATION_REQUEST_NUMBER: "Kérelem száma",
            APPLICATION_NUMBER: "Engedély száma",
            APPLICATION_REQUEST_DATE: "Kérelem dátuma",
            APPLICATION_ISSUED_DATE: "Kiállítás dátuma",
            REAL_ESTATE_TYPE: "Helyszín típusa",
            UAT_ID: "UAT-azonosító",
            COUNTY: "Megye",
            PLACEHOLDER: "UAT/kataszteri szám/kérelem",
        },
        FEATURE_COMMENTS: {
            TITLE: "Megjegyzések",
            BULK_DELETE: "Kijelöltek törlése",
            CONFIRM_DELETE_TITLE: "Törlés megerősítése",
            CONFIRM_DELETE_TEXT: "Biztos törli ezt a megjegyzést? A művelet nem vonható vissza.",
            CONFIRM_BULK_DELETE_TITLE: "Csoportos törlés megerősítése",
            CONFIRM_BULK_DELETE_TEXT: "Biztos törli a kijelölt {count} megjegyzést? A művelet nem vonható vissza.",
            DELETE_SUCCESS: "A megjegyzés sikeresen törölve.",
            DELETE_ERROR: "Hiba történt a megjegyzés törlésekor.",
            BULK_DELETE_SUCCESS: "{count} megjegyzés sikeresen törölve.",
            BULK_DELETE_ERROR: "Hiba történt a megjegyzések törlésekor.",
            COLUMN_ID: "ID",
            COLUMN_DATE: "Létrehozás dátuma",
            COLUMN_UPDATED_DATE: "Frissítés dátuma",
            COLUMN_USER: "Felhasználó",
            COLUMN_OWNER_USER_ID: "Tulajdonos",
            COLUMN_COMMENT: "Megjegyzés",
            COLUMN_LAYER_ID: "Rétegazonosító",
            COLUMN_LAYER: "Réteg",
            COLUMN_SUBLAYER_ID: "Alréteg-azonosító",
            COLUMN_SUBLAYER: "Alréteg",
            COLUMN_FEATURE_ID: "Parcella-azonosító",
            COLUMN_COMMENTING_USER_NAME: "Felhasználó",
            ACTION_VIEW: "Megtekintés",
            ACTION_REPLY: "Válasz",
            ACTION_DELETE: "Törlés",
            REPLY_TO: "Válasz a felhasználó megjegyzésére",
            REPLY_PLACEHOLDER: "Írja meg válaszát...",
            REPLY_SUCCESS: "A válasz sikeresen hozzáadva.",
            REPLY_ERROR: "Hiba történt a válasz hozzáadásakor.",
            FILTER_LAYER: "Réteg",
            FILTER_SUBLAYER: "Alréteg",
            FILTER_FEATURE_ID: "Parcella-azonosító",
            FILTER_DATE: "Létrehozás dátuma",
            FILTER_USER: "Felhasználó",
            FILTER_COMMENT: "Megjegyzés",
            FILTER_LAYER_ID: "Réteg",
            COLUMN_APPLICATION_REQUEST_NUMBER: "Kérelem száma",
            FILTER_APPLICATION_REQUEST_NUMBER: "Kérelem száma",
            VIEW_ON_MAP: "Megtekintés a térképen",
            NO_COMMENTS: "Nincsenek megjegyzések.",
            ALL_LAYERS: "Összes réteg",
            ALL_SUBLAYERS: "Összes alréteg",
            VALIDATION_FIELD_REQUIRED: "A(z) {field} mező kötelező",
            VALIDATION_FAILED: "A megjegyzés érvényesítése sikertelen: {errors}",
        },
        CITIZEN_FEATURES: {
            SECTION_TITLE: "Rétegeim",
            COLLEAGUE_SECTION_TITLE: "Kollégák rétegei",
            COLLEAGUE_MEMBER_FILTER_LABEL: "Csapattag",
            COLLEAGUE_EMPTY_STATE: "Nincs kollégák által közzétett réteg",
            UPLOAD_BTN: "Réteg feltöltése",
            EMPTY_STATE: "Nincs feltöltött rétege",
            FORM: {
                CREATE_TITLE: "Új réteg feltöltése",
                EDIT_TITLE: "Réteg szerkesztése",
                UPLOAD_BTN: "Feltöltés",
                FILE_PLACEHOLDER: "Válasszon .zip fájlt",
                FILE_HINT: "A ZIP-fájlnak tartalmaznia kell a következő fájlokat: .shp, .dbf, .prj és a további szükséges fájlokat.",
                FILE_TYPE_ERROR: "Csak ZIP-fájlok fogadhatók el",
                REPLACE_HINT: "A shapefile cseréjéhez törölje a jelenlegi verziót, és töltsön fel egy újat.",
                PROCESSING: "A fájl feldolgozása folyamatban... Ez néhány percet is igénybe vehet.",
            },
            FIELDS: {
                NAME: "Megnevezés",
                DESCRIPTION: "Leírás",
                NOTIFICATIONS_ENABLED: "Értesítések bekapcsolása",
                IS_APP_PREVIEW_ENABLED: "Előnézet bekapcsolása az alkalmazásban",
                FILE: "Fájl",
            },
            STATUS: {
                NEW: "Új",
                PROCESSING: "Feldolgozás alatt",
                COMPLETED: "Lezárva",
                ERROR: "Hiba",
            },
            CONFIRM_DELETE_TITLE: "Törlés megerősítése",
            CONFIRM_DELETE: "Biztos törli ezt a shapefile-t? A művelet nem vonható vissza.",
            SIDEBAR: {
                TAB_LABEL: "Saját réteg",
                SUBLAYER_SECTION_TITLE: "Alrétegek",
                FEATURES_SECTION_TITLE: "Elemek",
                ZOOM_TO_SUBLAYER: "Nagyítás az alrétegre",
            },
        },
        SCALE_WIDGET: {
            LABEL: "Méretarány 1:",
        },
        COORDINATE_CONVERSION: {
            EASTING: "Kelet",
            NORTHING: "Észak",
        },
        MAP_EXPORT: {
            EXPORTED_AT: "Exportálva: {date}",
            SCALE: "Méretarány: {scale}",
        },
    },
    DECISION: {
        PAGE_HEADER: "Határozatok",
        LIST: {
            TITLE: "Határozatok listája",
            EDIT: "Szerkesztés",
            DELETE: "Törlés",
            ADD_EXTENSION: "Meghosszabbítás hozzáadása",
        },
        FIELDS: {
            NAME: "Megnevezés",
            DESCRIPTION: "Címke",
            NUMBER: "Szám",
            ENTRY_DATE: "Kiállítás dátuma",
            EXPIRATION_DATE: "Lejárati dátum",
            TARGET_ID: "Helyszín",
            PURPOSE_ID: "Cél",
            COUNTY: "Megye",
            DECISION_ID: "Határozat",
            KEY: "Kulcs",
        },
        PLACEHOLDERS: {
            NAME: "Megnevezés",
            TARGET_ID: "Keresés helyszín szerint",
            PURPOSE_ID: "Keresés cél szerint",
        },
        ADD_EDIT_FORM: {
            HEADER_ADD: "Határozat hozzáadása",
            HEADER_EDIT: "Határozat szerkesztése",
        },
        SUCCESS: {
            ADD: "A határozat sikeresen hozzáadva.",
            UPDATE: "A határozat sikeresen módosítva.",
        },
        BUTTON: {
            ADD_DECISION: "Határozat hozzáadása",
        },
        TOTAL_TEXT: "Összesen 0 határozat| Összesen 1 határozat | Összesen {total} határozat",
        CARD: {
            EXTENSION_LABEL: "Meghosszabbító határozat",
            DECISION_LABEL: "Jóváhagyó határozat",
            PURPOSE_LABEL: "Fázis",
        },
    },
    SYSTEM_SETTINGS: {
        LIST: {
            TITLE: "Rendszerbeállítások listája",
        },
        FIELDS: {
            KEY: "Funkció",
            DESCRIPTION: "Leírás",
            DEFAULT_VALUE: "Érték",
        },
        FORM: {
            EDIT_TITLE: "Beállítás szerkesztése",
        },
        PLACEHOLDERS: {
            KEY: "Keresés kulcs szerint",
        },
        KEYS: {
            MAINTENANCE: "Karbantartási banner",
            MAINTENANCE_TEXT: "Karbantartási banner szövege",
            SIGN_AND_SEAL_ERROR_TIMER_HOURS: "Aláírás és bélyegzés zárolási ideje (óra)",
            CITIZEN_MAINTENANCE: "Állampolgároknak szóló karbantartási oldal",
            CITIZEN_MAINTENANCE_TEXT: "Állampolgároknak szóló karbantartási oldal szövege",
        },
    },
    DECISION_TARGET: {
        LIST: {
            TITLE: "Helyszínek listája",
        },
        ADD_BUTTON: "Helyszín hozzáadása",
        FIELDS: {
            NAME: "Megnevezés",
        },
        FORM: {
            EDIT_TITLE: "Helyszín szerkesztése",
            ADD_TITLE: "Új helyszín",
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
        },
    },
    DECISION_PURPOSE: {
        LIST: {
            TITLE: "Célok listája",
        },
        ADD_BUTTON: "Cél hozzáadása",
        FIELDS: {
            NAME: "Megnevezés",
        },
        FORM: {
            EDIT_TITLE: "Cél szerkesztése",
            ADD_TITLE: "Új cél",
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
        },
    },
    DOCUMENT_SERIES_TYPE: {
        TITLE: "Sorozattípusok",
        LIST: {
            TITLE: "Sorozattípusok listája",
        },
        ADD_BUTTON: "Új típus",
        FIELDS: {
            NAME: "Megnevezés",
        },
        FORM: {
            EDIT_TITLE: "Sorozattípus szerkesztése",
            ADD_TITLE: "Új sorozattípus",
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
        },
    },
    REGISTERS_TYPE: {
        TITLE: "Nyilvántartások tipológiái",
        LIST: {
            TITLE: "Nyilvántartások tipológiáinak listája",
        },
        ADD_BUTTON: "Új tipológia",
        FIELDS: {
            NAME: "Megnevezés",
            DESCRIPTION: "Leírás",
        },
        FORM: {
            EDIT_TITLE: "Nyilvántartás tipológia szerkesztése",
            ADD_TITLE: "Új nyilvántartás tipológia",
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
            DESCRIPTION: "Írja be a leírást",
        },
        FIELDS_SOURCE: {
            CITIZEN: "Állampolgár",
            STAFF: "Hivatalnok",
            CLARIFICATION_CITIZEN: "Állampolgári pontosítások",
            CLARIFICATION_STAFF: "Hivatali pontosítások",
        }
    },
    REGISTERS: {
        TITLE: "Nyilvántartás",
        STATUS: {
            CLOSED: "Lezárt",
            REJECTED: "Elutasított",
        },
        ACTIONS: {
            EXPORT: "Exportálás CSV-be",
        },
    },
    PAYMENT_REGISTRY: {
        TITLE: "Fizetések",
        LIST: {
            TITLE: "Fizetési előzmények",
        },
        CALCULATE_TAX: "Díjszámítás",
        ADD_PAYMENT_ORDER: "Fizetési megbízás",
        FIELDS: {
            NAME: "Megnevezés",
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
        },
        GENERATE_REPORT: "Elszámolási jelentés",
    },
    REAL_ESTATE_REGISTER: {
        TITLE: "Telekkönyvi adatok",
        LIST_HEADER: "Helyszínek",
        SAVE_SEARCH: "Keresés mentése",
        TOTAL_REAL_ESTATES: "Helyszínek összesen",
        ADD_REAL_ESTATE: "Új helyszín hozzáadása",
        NO_REAL_ESTATES: "Nem található helyszín",
        NO_REAL_ESTATES_DESCRIPTION: "A jelenlegi nézetben nem található helyszín.",
        REAL_ESTATE_DETAILS: "Helyszín részletei",
        NO_REAL_ESTATE_SELECTED: "Nincs kiválasztott helyszín",
        ALL_REAL_ESTATES: "Összes helyszín",
        ADD_MORE_REAL_ESTATES: "További helyszínek hozzáadása",
        REMOVE_CONFIRMATION: "Biztos törli ezt a helyszínt?",
        SYNC_SUCCESS: "A helyszínek sikeresen mentve.",
        REMOVE_SUCCESS: "Sikeres törlés.",
        PLACEHOLDER: "Helyszín {0}",
    },
    TAX_CALCULATOR: {
        TITLE: "Díjkalkulátor",
        FORM_SECTION_TITLE: "Iratkiállítási díj",
        SUMMARY_SECTION_TITLE: "Rendelés összesítése",
        FIELDS: {
            APPLICATION_TYPE: "Irattípus",
            EXEMPTION: "Díjmentességek az Adótörvénykönyv szerint",
            LAND_AREA: "Telek területe",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
        },
        CALCULATE_BUTTON: "Számítás",
        SUMMARY: {
            OTHER_TAXES_LABEL: "Egyéb díjak",
            EXEMPTION_LABEL: "Mentességek",
            VAT_LABEL: "ÁFA",
        },
        TOTAL: "Fizetendő összesen",
        DEFAULT_TAX_NAME: "Irat",
    },
    ISSUED_DOCUMENT: {
        TITLE: "Kiállított iratok",
        LIST: {
            TITLE: "Kiállított irataim",
            TITLE_STAFF: "Kiállított iratok általános nyilvántartása",
        },
        FIELDS: {
            DOCUMENT_SERIES: "Kimenő iktatószám",
            DOCUMENT_NAME: "Irattípus",
            ISSUED_DATE: "Kiállítás dátuma",
            BENEFICIARY_USER: "Kedvezményezett",
            ISSUED_YEAR: "Év",
            ISSUER_USER_FULL_NAME: "Kiállította",
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
            DOCUMENT_NAME: "Irattípus",
            ISSUED_YEAR: "Év",
            BENEFICIARY_USER: "Keresés név szerint",
            DOCUMENT_SERIES: "Keresés szám szerint",
            ISSUER_USER_FULL_NAME: "Kiállította",
        },
    },
    CONTROL: {
        PAGE_HEADER: "Ellenőrzési nyilvántartás",
        CURRENT_LOCATION: "Jelenlegi helyszín",
        LIST: {
            TITLE: "Ellenőrzések",
            DOCUMENT_CREATED_HEADER: "Létrehozott dokumentumok",
            NO_ASSIGNEE: "Nincs kijelölve",
        },
        BUTTON: {
            ADD_CONTROL: "Új ellenőrzés",
            ADD_COMPLAIN: "Bejelentés hozzáadása",
            ADD_LOCATION: "Helyszín hozzáadása",
            NEXT_STEP: "Következő lépés",
            DELETE_LOCATION: "Helyszín törlése",
            CLOSE_CONTROL: "Irattárazás",
            GENERATE_PVCC: "PVCC generálása",
            ADD_DOCUMENT: "Dokumentum",
            SAVE: "Mentés",
            PREVIEW: "Előnézet",
        },
        FIELDS: {
            CREATED_DATE: "Létrehozás dátuma",
            CONTROL_ID: "Bejövő iktatószám",
            COMPLAIN_REF: "Bejelentés hivatkozása",
            CREATED_BY: "Létrehozta",
            STATUS: "Állapot",
            COMPLAIN_NUMBER: "Bejelentés száma",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            ADDRESS: "Cím",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "UAT típusa",
            LOCALITY: "Megyei jogú város / Város / Község",
            FIRST_NAME: "Keresztnév",
            LAST_NAME: "Vezetéknév",
            EMAIL: "E-mail",
            PHONE: "Telefon",
            IDENTIFICATION_NUMBER: "Bejövő iktatószám",
            CONTROL_DATE: "Beérkezés dátuma",
            CADASTRAL_NUMBER: "Kataszteri szám",
            USER_TYPE_NAME: "Személy típusa",
            PERSONAL_NUMERIC_CODE: "CNP",
            COUNTY: "Megye",
            VILLAGE: "Település",
            SECTOR: "Kerület",
            STREET: "Utca",
            STREET_NUMBER: "Házszám",
            POSTAL_CODE: "Irányítószám",
            STAIRCASE: "Lépcsőház",
            BLOCK: "Tömbház",
            FLOOR: "Emelet",
            APARTMENT: "Lakás",
            REAL_ESTATE_TYPE: "Helyszín típusa",
            AUTHORISATION_CODE: "TNA",
            SUBSIDIARY: "Fiókszervezet",
            LAND_AREA: "Telek területe",
            OTHER_IDENTIFICATION: "Egyéb azonosítás",
            FILE_TYPE: "Dokumentumtípus",
            RESOLVED_DATE: "Megoldás dátuma",
            PASSPORT_NUMBER: "Útlevélszám",
            CITY: "Város",
            LICENSE: "Licenc",
            COMPANY_NAME: "Cég",
            UNIQUE_REGISTRATION_CODE: "CUI",
            FILENAME: "Dokumentum neve",
            TITLE: "Cím",
            MESSAGE: "Üzenet",
            COMMENTS: "Megjegyzések",
            ALLOCATED_DOCUMENT_SERIES: "Kimenő iktatószám",
            EMPLACEMENT_LOCALITY: "Település",
            OBJECTIONS: "Szabálysértő kifogásai",
            ID_CARD_SERIAL: "Sz. ig. sorozat",
            ID_CARD_NUMBER: "Sz. ig. szám",
            ID_CARD_EXPIRATION_DATE: "Lejárati dátum",
            ID_CARD_ISSUER: "Kiállította",
            CONSTRUCTION_TYPE: "Ingatlan típusa",
            CONTROL_TYPE_NAME: "Ellenőrzés típusa",
            ID_CARD_RELEASE_DATE: "Kiállítás dátuma",
            REGISTRATION_NUMBER: "Iktatószám",
            PERSON_TYPE: "Milyen minőségben",
            CONTRAVENTION_NUMBER: "Bírságjegy száma",
            CONTRAVENTION_SERIES: "Bírságjegy sorozata",
            CONTROL_PERSON: "Válasszon előre megadott tanút",
        },
        PLACEHOLDERS: {
            CONTROL_ID: "Bejövő iktatószám",
            COMPLAIN_REF: "Bejelentés hivatkozása",
            CREATED_BY: "Létrehozta",
            STATUS: "Állapot",
            IDENTIFICATION_NUMBER: "Bejövő iktatószám",
            CADASTRAL_NUMBER: "CF-szám",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            COUNTY: "Megye",
            LOCALITY: "Település",
            VILLAGE: "Település",
            TERRITORIAL_ADMINISTRATIVE_UNIT_TYPE: "UAT típusa",
            EMPLACEMENT_LOCALITY: "Település",
            COMMENTS: "Megjegyzések",
            MESSAGE: "Üzenet",
            EMAIL: "E-mail",
        },
        ENUMS: {
            STATUS: {
                REGISTERED: "Iktatva",
                RESOLVED: "Megoldva",
                CLOSED: "Irattárazva",
                GENERATED: "Generálva",
                ERROR: "Hiba",
                DRAFT: "Piszkozat",
            },
            PERSON_TYPE: {
                INVESTITOR: "Beruházó",
                EXECUTANT: "Kivitelező",
                PROIECTANT: "Tervező",
            },
        },
        LABEL: {
            CONTROL_ID: "Nyilvántartási szám",
        },
        FORM: {
            ADD_TITLE: "Ellenőrzés hozzáadása",
            EDIT_TITLE: "{0}. sz. ellenőrzés",
            NEW_CONTROL: "Új ellenőrzés",
        },
        PREPARATION: {
            HEADER: "Bejelentés részletei",
            COMPLAIN_LIST_TAGS: "Bejelentések bejövő iktatószámainak listája",
            WARNING: "Ellenőrzés hozzáadásához adjon hozzá egy helyszínt, vagy válasszon a bejelentések listájából!",
            LIST: "Helyszínek listája",
            PREVIEW_MAP: "Előnézet a Területi Atlaszból",
            FORM: {
                LOCATION: "Helyszín",
                COMPLAIN_DESCRIPTION: "A bejelentés szerint",
                MODAL_HEADER: "Bejelentés helyszínének adatai",
            },
            SEARCH_FOR: "bejelentések",
        },
        MODALS: {
            ADD: "Hozzáadás",
            CANCEL: "Mégse",
            SAVE: "Mentés",
        },
        NOTIFIERS: {
            DUPLICATE_OFFENDER_PNC: "Az azonos személyi számú (CNP: {pnc}) szabálysértő már hozzá van adva.",
            DUPLICATE_WITNESS_PNC: "Az azonos személyi számú (CNP: {pnc}) tanú már hozzá van adva.",
            DUPLICATE_OFFENDER_PASSPORT: "Az azonos útlevélszámú ({passport}) szabálysértő már hozzá van adva.",
            DUPLICATE_WITNESS_PASSPORT: "Az azonos útlevélszámú ({passport}) tanú már hozzá van adva.",
            CADASTRAL_NUMBER_NOT_FOUND: "Sajnáljuk, a kataszteri szám nem található. Próbálja újra!",
            CADASTRAL_NUMBER_ERROR: "Sajnáljuk, a szinkronizálás nem sikerült. Próbálja újra!",
            DEFAULT_ERROR_MESSAGE: "Hiba történt, kérjük, próbálja újra",
            GENERATE_DOCUMENTS_WARN: "PVCC generálása",
            GENERATE_DOCUMENTS_WARN_TEXT: "Kérjük, mentse a módosításokat a dokumentum generálása előtt. A dokumentumok generálása után az ellenőrzés már nem módosítható. Biztos folytatni szeretné?",
            GENERATION_COMPLETED: "Sikeres generálás!",
            GENERATION_COMPLETED_TEXT: "A generált dokumentumok a 'Dokumentumok' szakaszban tekinthetők meg.",
            GENERATION_ERROR: "Hiba történt a generálás során!",
            GENERATION_ERROR_TEXT: "Kérjük, próbálja újra a dokumentumok generálását.",
            CLOSE_CONTROL_SUCCESS: "Az ellenőrzés sikeresen irattárazva!",
            CLOSE_CONTROL_SUCCESS_TEXT: "Az irattárazást követően már nem módosítható.",
            CLOSE_CONTROL_WARN: "Ellenőrzés irattárazása",
            CLOSE_CONTROL_WARN_TEXT: "Az irattárazott ellenőrzés a továbbiakban nem módosítható. Biztos folytatni szeretné?",
            PREVIEW_DOCUMENTS_WARN: "PVCC előnézete",
            PREVIEW_DOCUMENTS_WARN_TEXT: "Kérjük, mentse a módosításokat, mielőtt megtekinti a dokumentum előnézetét.",
        },
        UPLOAD_DOCUMENTS_MODAL: {
            TITLE: "Dokumentumok hozzáadása",
        },
        TABS: {
            CONTROL_PREPARATION: "Ellenőrzés előkészítése",
            DATA_COLLECTION: "Adatgyűjtés",
            DOCUMENTS: "Dokumentumok",
            ACTIVITIES: "Tevékenységek",
        },
    },
    DASHBOARD: {
        APPLICATIONS_STATUS: {
            HEADER: "Kérelmek állapota",
            PERIOD: "Az elmúlt 30 nap",
            REGISTERED: "Iktatva",
            PROCESSING: "Feldolgozás alatt",
            CLARIFICATIONS: "Tisztázások",
        },
        TOP_USERS: {
            HEADER: "Legaktívabb felhasználók",
        },
        REGISTRED_APPLICATIONS: {
            HEADER: "Iktatott kérelmek",
            DESCRIPTION: "Benyújtott és megoldott kérelmek",
            PERIOD: "Az elmúlt 12 hónap",
            SUBMITTED: "Benyújtott",
            APPLICATIONS_COUNT: "Kérelmek száma",
        },
        SOLVED_APPLICATIONS: {
            HEADER: "Megoldott kérelmek",
            DESCRIPTION: "A megoldott kérelmek aránya az összes benyújtásból",
            APPLICATIONS_TYPE_HEADER_LEGAL: "Leggyakoribb kérelemtípusok",
            APPLICATIONS_TYPE_HEADER_STAFF: "Kérelmek UAT szerint",
        },
        RECENT_APPLICATIONS: {
            HEADER: "Legutóbbi kérelmek",
            BUTTON: {
                VIEW_ALL_APPLICATIONS: "Összes kérelem megtekintése",
            },
            MISSING: "Jelenleg nincs benyújtott kérelem. Nyújtson be most egy kérelmet online.",
        },
        RECENT_ISSUED_DOC: {
            HEADER: "Nemrég kiállított iratok",
            BUTTON: {
                VIEW_ALL_ISSUED_DOC: "Összes kiállított irat megtekintése",
            },
        },
        PERFORMANCE: {
            HEADER: "Teljesítmény",
            ABOVE_AVG: "Átlag feletti",
            NORMAL: "Normál",
            BELLOW_AVG: "Átlag alatti",
            RESOLUTION_AVG: "Átlag",
            OBJECTIVE_HEADER: "Ügyintézési határidő célértéke",
        },
        TOTALS: {
            NEW: "Összes új",
            SOLVED: "Összes megoldott",
            IN_OPERATION: "Összes folyamatban lévő",
            PERCENT: "Összesített százalék",
            TOP_USERS: "Legtöbb kijelölést kapott ügyintézők",
        },
        TYPES: {
            STATS: "Statisztika",
            NEW: "Új",
            SOLVED: "Megoldott",
            IN_OPERATION: "Folyamatban",
            TOTAL_LABEL: "Összesen",
            DAYS: "Nap",
            SOLUTION_TERM: "Ügyintézési határidő",
            APPLICATIONS_PER_UATS: "Kérelmek területi-közigazgatási egység (UAT) szerint",
        },
        RECENT_NOTIFICATIONS: {
            MISSING: "Nincs értesítése.",
        },
        FIELDS: {
            START_DATE: "Kezdő dátum",
            END_DATE: "Záró dátum",
        },
        REGISTERED_APPLICATIONS: {
            HEADER: "Iktatott kérelmek",
            DESCRIPTION: "Új és megoldott kérelmek",
        },
        DOMAIN_TITLE: "Miben segíthetünk ma?",
        DOMAIN_SUBTITLE: "Megkíméljük Önt az ügyfélszolgálati sorban állástól.",
        DOMAIN_SUBTITLE_SECOND: "Kérelmeit 100%-ban digitálisan, egyszerűen és biztonságosan nyújthatja be és követheti nyomon. Papírmentesen!",
        DOMAIN_SEARCH_APPLICATION_TYPE_PLACEHOLDER: "Kérelem keresése",
        DOMAIN_NO_SEARCH_RESULTS: "Nem található kérelem.",
        DOMAIN_ACCESS_BUTTON: "Megnyitás",
        DOMAINS: [
            {
                key: "urbanism",
                title: "Urbanisztika",
                description: "Urbanisztikai bizonyítványok, építési engedélyek, főépítészi láttamozások, építést igazoló bizonyítványok, műszaki átvételek stb.",
            },
            {
                key: "administration",
                title: "Közigazgatás",
                description: "Jogi ügyek, a döntéshozó hatóság iratai stb.",
            },
            {
                key: "city_hall",
                title: "Polgármesteri hivatalok",
                description: "Intézményközi levelezés a polgármesteri hivatalok és a megyei tanács között",
            },
            {
                key: "approvals",
                title: "Láttamozó hatóságok",
                description: "Kérelmek a láttamozásokat és hozzájárulásokat kiállító különböző intézményekhez és szervezetekhez (ISU, földgáz, víz stb.)",
            },
            {
                key: "roads",
                title: "Közlekedés",
                description: "Megyei utakra vonatkozó láttamozások, megyei útberuházások, megyei tömegközlekedés, útjelzések",
            },
            {
                key: "economic",
                title: "Gazdasági",
                description: "A Kolozs Megyei Tanács által nyújtott finanszírozások, kifizetések, humánerőforrás, vállalatirányítás stb.",
            },
            {
                key: "subordination",
                title: "Alárendelt intézmények",
                description: "A Kolozs Megyei Tanácshoz tartozó könyvtárak, kulturális intézmények, kórházak és társaságok",
            },
            {
                key: "maps",
                title: "Térképek",
                description: "GIS-alkalmazások, különféle térképek, a Területi Atlasz stb.",
            },
            {
                key: "investments",
                title: "Beruházások",
                description: "Folyamatban lévő szerződések, közbeszerzések, európai alapok, projektek stb.",
            },
            {
                key: "tourism",
                title: "Turizmus",
                description: "A Bánffy-kastély látogatása, turistaútvonalak, Nemzeti Turisztikai Információs Központ, Salvamont",
            },
            {
                key: "events",
                title: "Bérbeadás",
                description: "Helyiségbérlési kérelmek, rendezvényszervezés (Cluj Arena, Agro Transilvania stb.)",
            },
            {
                key: "sesizari",
                title: "Bejelentések",
                description: "Megyei utak, közérdekű információk, kóbor kutyák, szabálytalanságok",
            },
        ],
        DOMAIN_APPLICATION_TYPES_COUNT: "kérelem | kérelem | kérelem",
    },
    URBANISM_REGULATION_ZONES: {
        LIST: {
            TITLE: "Urbanisztikai szabályozások",
        },
        ADD_BUTTON: "Új szabályozás",
        FIELDS: {
            NAME: "Megnevezés",
            KEY: "Kulcs",
            TYPE: "Szabályozás célja",
            TENANT: "UAT",
            DISPLAY_NAME: "Megnevezés az atlaszban",
        },
        FORM: {
            EDIT_TITLE: "Szabályozás szerkesztése",
            ADD_TITLE: "Új szabályozás",
        },
        ENUMS: {
            TYPE: {
                PUG: "PUG",
                PUZ: "PUZ",
                PUD: "PUD",
            },
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
            KEY: "Keresés kulcs szerint",
            TENANT: "UAT",
            TYPE: "Szabályozás célja",
        },
    },
    URBANISM_REGULATIONS: {
        TITLE: "{0} RLU-kategóriáinak szerkesztése",
        FIELDS: {
            CONTENT: "Tartalom",
            CONTENT_HTML: "Nyilvános tartalom - Ez a tartalom érhető el az állampolgárok számára az Atlaszban",
        },
        ITEM_DETAILS: "Részletek",
        EMPTY_ITEMS_LABEL: "Nincsenek csatolt kategóriák",
        EDIT_ITEM_FORM: "{0} {1} szerkesztése",
    },
    URBANISM_REGULATIONS_PICKER: {
        SECTION_TITLE: "Urbanisztikai szabályozások kézi előkitöltése",
        TITLE: "Kézi előkitöltés",
        COMPLETE_BUTTON: "Szabályozások kiválasztása",
        NO_DATA_FOUND: "Nincs megjeleníthető urbanisztikai szabályozás",
        PREVIEW_HEADER: "Előnézet",
        SELECT_HEADER: "Övezet kiválasztása",
        SELECT_PLACEHOLDER: "Keresés megnevezés szerint",
        ENTRY_NOT_DEFINED: "Nincs meghatározva",
        PREVIEW_HELP_TEXT: "Válasszon ki egy övezetet az oldalsó listából a tartalom előnézetéhez",
        COULD_NOT_SUBMIT_MESSAGE: "Hiba történt, ellenőrizze, hogy az urbanisztikai szabályozások megfelelően vannak-e beállítva.",
        FORCE_UPDATE_LABEL: "Adatok felülírása",
        HELP_TEXT_COMPLETED: "A dokumentum a Területi Atlasz beállításai alapján előre ki lett töltve ",
        HELP_TEXT_NOT_COMPLETED: "A dokumentumot nem sikerült automatikusan előkitölteni, mert nem található információ a Területi Atlaszban",
        HELP_TEXT_FORCE_UPDATE: "Minden mező felülíródik az új értékekkel",
        HELP_TEXT_NOT_FORCE_UPDATE: "Csak az üres mezők töltődnek ki új értékekkel",
    },
    INTERNAL_DOCUMENTS: {
        LIST: {
            TITLE: "Dokumentumok nyilvántartása",
            SUB_TITLE: "Dokumentumok listája",
            NO_ASSIGNEE: "Nincs kijelölve",
            DOCUMENTS_HEADER: "Dokumentumok",
            SIGN_TITLE: "Aláírandó dokumentumok nyilvántartása",
            SIGN_DOCUMENT_BULK: "Dokumentumok aláírása",
            SIGN_DOCUMENT_BULK_PERSONALIZED: "Dokumentumok személyre szabott aláírása",
            SIGN_DOCUMENT_BULK_STS: "Dokumentumok aláírása STS-sel",
        },
        ADD_BUTTON: "Dokumentum létrehozása",
        VIEW_APPLICATION_BUTTON: "{number} számú kérelem megtekintése",
        INTERNAL_DOCUMENTS_REVIEW_WARNING: "Ez a dokumentum belső, nem jut el az állampolgárhoz!",
        FIELDS: {
            APPLICATION_TYPE_NAME_COLUMN: "Dokumentumtípus",
            IDENTIFICATION_NUMBER: "Bejövő iktatószám",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Kérelem száma",
            CREATED_DATE: "Létrehozás dátuma",
            APPLICATION_DATE: "Lezárás dátuma",
            RESPONSE_DUE_IN: "Hátralévő idő",
            FILE_TYPE: "Dokumentumtípus",
            ASSIGNED_TO: "Felelős",
            ALLOCATED_DOCUMENT_SERIES: "Kimenő iktatószám",
            STATUS: "Állapot",
            CADASTRAL_NUMBER: "CF-szám",
            APPLICATION_TYPE_NAME: "Belső dokumentum típusa",
            REVIEW_COMMENT: "Megjegyzések",
            APPLICATION_NUMBER: "Kérelem száma",
            PIN: "Megerősítő kód",
            CREATED_BY: "Létrehozta",
            FILENAME: "Dokumentum neve",
        },
        PLACEHOLDERS: {
            BENEFICIARY: "Kedvezményezett",
            IDENTIFICATION_NUMBER: "Bejövő iktatószám",
            PARENT_APPLICATION_IDENTIFICATION_NUMBER: "Kérelem száma",
            APPLICATION_TYPE_NAME: "Kérelem típusa",
            CREATED_BY: "Létrehozta",
            ASSIGNED_TO: "Felelős",
            STATUS: "Állapot",
            CADASTRAL_NUMBER: "Kataszteri szám",
            ALLOCATED_DOCUMENT_SERIES: "Kimenő iktatószám",
        },
        FORM: {
            NEW_DOCUMENT: "Új belső dokumentum",
            EDIT_TITLE: "Dokumentum {0}",
            DOCUMENT_TYPE_HEADER: "",
            CONTINUE_BTN: "Folytatás",
            SAVE_BTN: "Mentés",
            SAVE_AS_DRAFT_BUTTON: "Mentés piszkozatként",
            PREVIEW_DOC: "Előnézet",
            FIND_APPLICATION_TITLE: "Kérelem keresése",
            SEARCH_FOR: "kérelmek",
            ADD_DOCUMENT: "Dokumentum hozzáadása",
            UPLOAD_DOCUMENT_TITLE: "Dokumentum hozzáadása",
            SIGN_DOCUMENT_TITLE: "Dokumentum aláírása",
            REFRESH_DOCUMENT: "Újratöltés",
            SIGNATURES_PANE_EXPAND: "Aláírási panel megjelenítése",
            SIGNATURES_PANE_COLLAPSE: "Aláírási panel elrejtése",
        },
        TABS: {
            APPLICATION_DETAILS: "Kérelem részletei",
            DOCUMENT_DETAILS: "Dokumentum részletei",
            DOCUMENTS: "Dokumentumok",
            ACTIVITIES: "Tevékenységek",
        },
        VIEW: {
            SAVE_AS_DRAFT_BUTTON: "Mentés piszkozatként",
            REASSIGN_STAFF: "Felelős újbóli kijelölése",
            ASSIGN_STAFF: "Felelős kijelölése",
            SEND_RESPONSE: "Válasz küldése",
            NEXT_STEP: "Következő lépés",
            SIGN_DOCUMENT: "Dokumentum aláírása",
            SIGN_DOCUMENT_PERSONALIZED: "Dokumentum személyre szabott aláírása",
            SIGN_DOCUMENT_STS: "Dokumentum aláírása STS-sel",
            ASSIGN_STAFF_MESSAGE: "Biztos átveszi ezt a dokumentumot?",
            APPROVE_DOCUMENT: "Jóváhagyás",
            REJECT_DOCUMENT: "Elutasítás",
            APPROVE_DOCUMENT_MESSAGE: "Biztos jóváhagyja ezt a dokumentumot?",
            REJECT_DOCUMENT_MESSAGE: "Biztos elutasítja ezt a dokumentumot?",
            GENERATE_DOCUMENT_MESSAGE: "A dokumentum generálása megtörtént",
            GENERATE_DOCUMENT_ERROR: "A dokumentum nem generálható",
            SIGN_DOCUMENT_ERROR: "A dokumentum nem írható alá",
            SIGN_SUCCESS: "A dokumentum aláírása megtörtént",
            SEND_REVIEW: "Tisztázás szükséges",
            RETURN_DOCUMENT: "Dokumentum újragenerálása",
            RETURN_DOCUMENT_MESSAGE: "Biztos visszaküldi ezt a dokumentumot? Ez a művelet visszafordíthatatlan, és az irat újragenerálásával jár.",
            SAVE_FAILED: "A mentés nem sikerült",
            GENERATE_DOCUMENT_BTN: "Dokumentum véglegesítése",
            SEND_TO_REVIEW: "Véleményezésre küldés",
            ASSIGN_REVIEWER: "Véleményező kiválasztása",
            REASSIGN_REVIEWER: "Véleményező újbóli kiválasztása",
            SEND_TO_REVIEW_DOCUMENT_MESSAGE: "Biztos véleményezésre küldi ezt a dokumentumot?",
        },
        ENUMS: {
            STATUS: {
                NEW: "Új",
                PENDING: "Ellenőrzés alatt",
                RESOLVED: "Megoldva",
                REJECTED: "Elutasítva",
                REJECTED_IN_PROGRESS: "Elutasítás alatt",
                APPROVED: "Folyamatban",
                DRAFT: "Piszkozat",
                GENERATED: "Generálva",
                SIGNED: "Aláírva",
                SEALED: "Lebélyegezve",
                SIGN_PENDING: "Aláírás alatt",
                CLOSED: "Lezárva",
                REVIEW: "Tisztázás alatt",
                ERROR: "Hiba",
                REGISTERED: "Iktatva",
            },
        },
        SIGN_CONFIRMATION: {
            INVALID_PIN: "A kód érvénytelen, kérjük, próbálja újra",
            PIN_EXPIRED: "A kód lejárt, kérjük, próbálja újra",
            SESSION_EXPIRED: "A munkamenet lejárt, kérjük, próbálja újra",
            ERROR: "Hiba történt, kérjük, próbálja újra",
            BULK_FAILED: "A következő kérelmek nem írhatók alá: {0}",
        },
        SIGN_STATUS: {
            TITLE: "Aláírási állapot",
            IDENTIFICATION_NUMBER: "Bejövő iktatószám",
            PARENT_IDENTIFICATION_NUMBER: "Kérelem száma",
            SIGNING_BY: "Jelenlegi aláíró",
            LAST_SIGNING_DATE: "Utolsó aláírás dátuma",
        },
        NOTIFIERS: {
            ASSIGN_SUCCESS: "A dokumentum felelőse sikeresen <strong>{name}</strong> lett!",
            INVALID_PROFILE_FOR_SIGNING_TITLE: "A profiladatok érvénytelenek",
            INVALID_PROFILE_FOR_SIGNING_TEXT: "Kérjük, ellenőrizze a <b>Profilom</b> szakaszban a személyi számot (CNP) és a személyi igazolvány adatait, amelyek az online aláíráshoz szükségesek!",
            INVALID_PROFILE_FOR_SIGNING_BUTTON_TEXT: "Ugrás: Profilom",
            INVALID_STAFF_ENROLLMENT_TITLE: "Hiba történt az aláírási folyamat során",
            INVALID_STAFF_ENROLLMENT_TEXT: "Kérjük, végezze el az aláírói regisztrációt, hogy aláírhasson",
            INVALID_STAFF_ENROLLMENT_BUTTON_TEXT: "Ugrás: Profilom",
            REVIEW_RESPONSE_SUCCESS: "A véleményezési válasz sikeresen elküldve!",
            REJECT_VIZA_RESPONSE_SUCCESS: "Az elutasítás sikeresen elküldve!",
        },
        RESPONSE_MODAL: {
            REJECT_APPLICATION_TITLE: "Elutasítás indoka",
        },
    },
    DOCUMENT_SERIES_ALLOCATION: {
        LIST: {
            TITLE: "Foglalások nyilvántartása",
        },
        ADD_BUTTON: "Sorozatszám foglalása",
        DETAILS_BUTTON: "Iratsorozatok részletei",
        EXPORT_ALLOCATIONS_BUTTON: "Exportálás",
        FIELDS: {
            CREATED_BY: "Foglalta",
            CREATED_DATE: "Foglalás dátuma",
            ALLOCATED_SERIES: "Sorozat",
            TYPE_NAME: "Sorozattípus",
            FILE: "Dokumentum (PDF)",
            ISSUED_DATE: "Kiállítás dátuma",
            LOCATION: "Hely",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            IDENTIFICATION_NUMBER: "Azonosítószám",
            TAX_VALUE: "Díj (RON)",
            AVAILABILITY_PERIOD_MONTHS: "Érvényesség (hónap)",
            EXECUTION_DURATION: "⁠Kivitelezés időtartama",
            EXECUTION_START_DATE: "⁠Munkakezdés dátuma",
            EXTENSION_DATE: "Meghosszabbítás dátuma",
            INVESTITION_VALUE: "Beruházás értéke",
            USE_REAL_ESTATE: "Helyszín vs. helymegjelölés",
        },
        FORM: {
            ADD_TITLE: "Sorozatszám foglalása",
            EDIT_TITLE: "Sorozat szerkesztése",
            VIEW_TITLE: "Foglalt sorozat megtekintése",
            ADD_LOCATION: "Hely hozzáadása",
            TITLE_TOOLTIP: "Kontúr rajzolásához használja a térkép menüjének területmérés opcióját. Egy hely kiválasztásához kattintson duplán a térképre.",
            LOCATION_TYPES: {
                LABEL: "Helyszín típusa",
                PINPOINT: "Hely",
                REAL_ESTATE_LIST: "Telekkönyv",
            },
            DEFAULT_FILE_NAME: "Dokumentum",
        },
        PLACEHOLDERS: {
            CREATED_BY: "Foglalta",
            CREATED_DATE: "Foglalás dátuma",
            ALLOCATED_SERIES: "Keresés sorozat szerint",
            TYPE_NAME: "Sorozattípus",
        },
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "Sikeres foglalás",
            CREATED_SUCCESS_TEXT: "A(z) <strong>{number}</strong> számú sorozat sikeresen lefoglalva.",
        },
    },
    APPLICATION_ATTACHMENTS: {
        TITLE: "MELLÉKLETEK",
    },
    RELATED_APPLICATION: {
        TITLE: "Kapcsolódó dokumentumok",
        NOT_FOUND: "A dokumentum nem található a rendszerben.",
        NOT_FOUND_AND_UPLOAD: "A dokumentum nem található a rendszerben. Kérjük, töltse fel a dokumentumot.",
        SEARCH_DESCRIPTION: "Válassza ki a Ghișeul Unic platformon kiállított dokumentumot, vagy adja meg a számát",
        ISSUED_BY_SYSTEM_DESCRIPTION: "{tenant} állította ki a Ghișeul Unic platformon keresztül",
        ISSUED_BY_DESCRIPTION: "Más hatóság/rendszer állította ki",
        FIELDS: {
            ALLOCATED_DOCUMENT_SERIES: "Dokumentumszám",
            ISSUED_DATE: "Kiállítás éve",
            ISSUED_BY: "Kiállította",
            RELATED_DOCUMENT: "Urbanisztikai bizonyítvány",
        },
    },
    DOCUMENT_EXPIRY: {
        INLINE: {
            PREFIX: "A jelen irat érvényességi ideje",
            SUFFIX: "a kiállítás dátumától számítva.",
        },
        FIELDS: {
            PERIOD_VALUE: "Érvényesség",
            PERIOD_UNIT: "Mértékegység",
        },
        ENUMS: {
            PERIOD_UNIT: {
                ZILE: "Nap",
                LUNI: "Hónap",
                ANI: "Év",
            },
        },
    },
    DOCUMENT_EXTENSION: {
        FIELDS: {
            ISSUE_DATE: "Érvényes ettől",
            EXTENSION_MONTHS: "Meghosszabbítás időtartama (hónap)",
            EXTENDED_UNTIL: "Érvényes eddig",
        },
    },
    OFFENDER: {
        DETAILS: {
            HEADER: "Szabálysértő részletei",
            ADD_BTN: "Szabálysértő hozzáadása",
            REMOVE_BTN: "Szabálysértő törlése",
            PERSON: {
                HEADER: "Személy típusa",
                INDIVIDUAL: "Természetes személy",
                LEGAL: "Jogi személy",
            },
            CITIZENSHIP: {
                HEADER: "Állampolgárság",
                ROMANIAN: "Román állampolgár",
                FOREIGNER: "Külföldi állampolgár",
            },
            FORM: {
                AUTHORIZATION_CODE: "TNA",
                SUBSIDIARY: "Leányvállalat",
            },
            ADDRESS: "Cím",
            CONTACT: "Elérhetőség",
        },
        SINGLE: "Összesen {total} szabálysértő",
        MULTIPLE: "Összesen {total} szabálysértő",
        LIST_HEADER: "Szabálysértők listája",
        MODAL: {
            ADD_HEADER: "Szabálysértő hozzáadása",
            EDIT_HEADER: "Szabálysértő szerkesztése",
        },
        CARD: {
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Lakcím",
            CONTACT: "Elérhetőség",
            CITIZENSHIP: "Állampolgárság",
            ADDRESS_COUNTY: "Megye",
            ADDRESS_STREET: "utca",
            ADDRESS_NUMBER: "szám",
            ADDRESS_STAIRCASE: "lépcsőház",
            ADDRESS_APARTMENT: "lakás",
            PASSPORT_NUMBER: "Útlevél",
        },
    },
    WITNESS: {
        DETAILS: {
            HEADER: "Tanú részletei",
            ADD_BTN: "Tanú hozzáadása",
            REMOVE_BTN: "Tanú törlése",
            CITIZENSHIP: {
                HEADER: "Állampolgárság",
                ROMANIAN: "Román állampolgár",
                FOREIGNER: "Külföldi állampolgár",
            },
            PERSON: {
                HEADER: "Személy típusa",
                INDIVIDUAL: "Természetes személy",
                LEGAL: "Jogi személy",
            },
            FORM: {
                AUTHORIZATION_CODE: "TNA",
                SUBSIDIARY: "Leányvállalat",
            },
            ADDRESS: "Cím",
            CONTACT: "Elérhetőség",
            SAVE_AS_PREDEFINED: "Mentés előre megadott tanúként",
        },
        SINGLE: "Összesen {total} tanú",
        MULTIPLE: "Összesen {total} tanú",
        LIST_HEADER: "Tanúk listája",
        MODAL: {
            ADD_HEADER: "Tanú hozzáadása",
            EDIT_HEADER: "Tanú szerkesztése",
        },
        CARD: {
            PERSONAL_NUMERIC_CODE: "CNP",
            ADDRESS: "Lakcím",
            CONTACT: "Elérhetőség",
            CITIZENSHIP: "Állampolgárság",
            ADDRESS_COUNTY: "Megye",
            ADDRESS_STREET: "utca",
            ADDRESS_NUMBER: "szám",
            ADDRESS_STAIRCASE: "lépcsőház",
            ADDRESS_APARTMENT: "lakás",
            PASSPORT_NUMBER: "Útlevél",
        },
    },
    REALTY: {
        FORM: {
            HEADER: "Építmény hozzáadása",
            ADD_BTN: "Új építmény hozzáadása",
            DUPLICATE_CADASTRAL_NUMBER: "Ez a kataszteri szám már hozzá van adva",
            DUPLICATE_CADASTRAL_NUMBER_PLURAL: "Néhány kiválasztott kataszteri szám már hozzá van adva",
            DIFFERENT_AREA: "A megadott terület eltér az ANCPI által nyilvántartott területtől",
            WRONG_COUNTY: "Kérelmet csak {county} megyére lehet benyújtani",
        },
        VIEW: {
            ADDRESS: "Cím",
            CONTACT: "Elérhetőség",
            CADASTRAL_PLAN: "Kataszteri terv",
            NO_FILES: "Nincsenek fájlok",
            FILES_LABEL: "Azonosító fájlok",
        },
        SINGLE: "Összesen {total} építmény",
        MULTIPLE: "Összesen {total} építmény",
        LIST_HEADER: "Építmények listája",
        MODAL: {
            ADD_HEADER: "Építmény hozzáadása",
            SUMMARY_HEADER: "Építmények teljes listája",
        },
        CARD: {
            CADASTRAL_NUMBER: "Kataszteri szám",
            UAT: "UAT",
            LAND_AREA: "Terület",
            COUNTY: "{county} megye",
            CATEGORY: "Kategóriakód",
            MISSING_COORDINATES_MESSAGE: "Hiányzó ANCPI-koordináták",
            ADDRESS: "{street} utca, {no}. szám",
        },
    },
    STAFF: {
        SECTION_TITLE: "Ügyintéző részletei",
        FIELDS: {
            FUNCTION: "Beosztás",
            ORGANISATION: "Ellenőrző szerv",
            FIRST_NAME: "Keresztnév",
            LAST_NAME: "Vezetéknév",
            IDENTIFICATION_NUMBER: "Ellenőri igazolvány száma",
            ID_EXPIRATION_DATE: "Lejárati dátum",
            ID_RELEASED_BY: "Kiállította",
            ADDRESS: "Székhely / ellenőrzött építési terület címe",
        },
    },
    CONTROL_TYPE: {
        HEADER: "Válassza ki az ellenőrzés típusát",
        LIST: {
            TITLE: "Ellenőrzéstípusok",
        },
        ADD_BUTTON: "Új ellenőrzés",
        FIELDS: {
            NAME: "Megnevezés",
            STATUS: "Állapot",
            DESCRIPTION: "Leírás",
            FORM: "Űrlapfelület",
            DOCUMENT_TEMPLATE: "Dokumentumsablon",
            DOCUMENT_SERIES_TYPE: "Iratsorozat típusa",
            OUTPUT_DOCUMENT_SERIES_TYPE: "PVCC-iratsorozat típusa",
            TENANT_ID: "Szervezet",
        },
        FORM: {
            EDIT_TITLE: "Ellenőrzéstípus szerkesztése",
            ADD_TITLE: "Új ellenőrzéstípus",
        },
        ENUMS: {
            STATUS: {
                ACTIVE: "Aktív",
                INACTIVE: "Inaktív",
            },
        },
        PLACEHOLDERS: {
            NAME: "Keresés megnevezés szerint",
            STATUS: "Állapot",
        },
    },
    AC_TAX_VALIDATOR: {
        FORM: {
            HEADER: "Építmény hozzáadása",
            MIN_VALUE: "(legalább {value})",
        },
        FIELDS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            VILLAGE: "Település",
            STREET: "Utca",
            STREET_NUMBER_SHORT: "Sz.",
            CONSTRUCTION_SCOPE: "A következő munkálatok elvégzésére",
            CONSTRUCTION_TYPE: "Szerkezeti rendszer",
            SURFACE: "Az építmények teljes bruttó szintterülete",
            CONSTRUCTION_VALUE: "Lakóépületek értéke (RON)",
            CONSTRUCTION_PURPOSE: "Cél (létesítmény)",
            COUNTY: "Megye",
        },
        PLACEHOLDERS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            VILLAGE: "Település",
            STREET: "Utca",
            STREET_NUMBER_SHORT: "Sz.",
            CONSTRUCTION_SCOPE: "Építmény típusa",
            CONSTRUCTION_TYPE: "Szerkezeti rendszer",
            SURFACE: "Terület",
            CONSTRUCTION_VALUE: "Érték",
            CONSTRUCTION_PURPOSE: "",
            COUNTY: "",
        },
        ENUMS: {
            CONSTRUCTION_SCOPE: {
                LOCUINTE: "Lakóépületek és melléképületeik (0.5%)",
                OTHER: "Egyéb típusú munkálatok (1%)",
            },
            CONSTRUCTION_TYPE: {
                BETON: "Vasbeton vázas épület vagy olyan épület, amelynek külső falai égetett téglából vagy bármely más, hő- és/vagy vegyi kezeléssel előállított anyagból készültek",
                LEMN: "Olyan épület, amelynek külső falai fából, terméskőből, égetetlen téglából, vályogból vagy bármely más, hő- és/vagy vegyi kezelésnek nem alávetett anyagból készültek",
                ANEXE: "Melléképület, a szerkezeti rendszertől függetlenül",
            },
        },
        ERRORS: {
            CONSTRUCTION_VALUE_TOO_SMALL: "A megadott érték kisebb a minimális értéknél!",
            SURFACE_WRONG_FORMAT: "A megadott érték érvénytelen",
        },
    },
    LOCALITIES: {
        LIST_HEADER: "Helyszínek részletei",
        FORM: {
            HEADER: "Új helyszín hozzáadása",
            ADD_BTN: "Új helyszín hozzáadása",
            WRONG_COUNTY: "Kérelmet csak {county} megye területére lehet benyújtani",
        },
        VIEW: {
            ADDRESS: "Cím",
            CONTACT: "Elérhetőség",
        },
        SINGLE: "Összesen {total} helyszín",
        MULTIPLE: "Összesen {total} helyszín",
        MODAL: {
            ADD_HEADER: "Helyszín hozzáadása",
            SUMMARY_HEADER: "Helyszínek teljes listája",
        },
        CARD: {
            UAT: "Megyei jogú város / Város / Község",
            COUNTY: "{county} megye",
            VILLAGE: "Település",
            ADDRESS: "Lakcím",
            ADDRESS_COUNTY: "Megye",
            ADDRESS_STREET: "u.",
            ADDRESS_NUMBER: "sz.",
            ADDRESS_STAIRCASE: "lépcsőház",
            ADDRESS_APARTMENT: "lakás",
        },
        FIELDS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "Megyei jogú város / Város / Község",
            VILLAGE: "Település",
            STREET: "Utca",
            STREET_NUMBER_SHORT: "Sz.",
            COUNTY: "Megye",
            STAIRCASE: "Lépcsőház",
            BLOCK: "Tömbház",
            FLOOR: "Emelet",
            APARTMENT: "Lakás",
        },
        PLACEHOLDERS: {
            TERRITORIAL_ADMINISTRATIVE_UNIT: "Megyei jogú város / Város / Község",
            VILLAGE: "Település",
            STREET: "Utca",
            STREET_NUMBER_SHORT: "Sz.",
            COUNTY: "",
        },
    },
    BUILDINGS: {
        LIST_HEADER: "Épülettestek",
        FORM: {
            HEADER: "Épülettestek hozzáadása",
            ADD_BTN: "Új épülettest hozzáadása",
            WRONG_COUNTY: "Kérelmet csak {county} megye területére lehet benyújtani",
        },
        VIEW: {
            ADDRESS: "Cím",
            CONTACT: "Elérhetőség",
        },
        SINGLE: "Összesen {total} épülettest",
        MULTIPLE: "Összesen {total} épülettest",
        MODAL: {
            ADD_HEADER: "Új épülettest hozzáadása",
            SUMMARY_HEADER: "Épülettestek teljes listája",
        },
        CARD: {
            NAME: "Épülettest neve",
            HEIGHT: "A tervezett építmények magassága",
            HEIGHT_SHORT: "Magasság",
            NR_LEVELS: "Szintek száma",
            CHARACTERISTICS: "Szerkezeti jellemzők és külső megjelenés",
            CHARACTERISTICS_SHORT: "Jellemzők",
            CAPACITY: "A tervezett építmények funkcionális kapacitása",
            CAPACITY_SHORT: "Kapacitások",
        },
        FIELDS: {
            NAME: "Épülettest megnevezése (pl. C1 – lakóház)",
            HEIGHT: "Párkány-/ereszmagasság (m)",
            MAX_HEIGHT: "Gerinc-/attikamagasság (m)",
            EXISTING_LEVELS: "Meglévő szintek száma",
            PROPOSED_LEVELS: "Tervezett szintek száma",
            CONSTRUCTION_TYPE: "Szerkezeti rendszer (leírás)",
            FOUNDATIONS: "Alapozás (típus + leírás)",
            ROOF_TYPE: "Tető (típus + leírás)",
            HEATING_TYPE: "Fűtési rendszer",
            ISOLATION: "Tetőfedés",
            EXTERIOR_FINISH: "Külső felületképzés",
            EXTERIOR_WOODWORK: "Külső nyílászárók",
            FUNCTION: "Rendeltetés",
            CATEGORY_OF_IMPORTANCE: "Fontossági kategória",
            BUILDING_FUNCTION: "Épülettest típusa",
            BUILDING_FUNC_EXISTING: "Meglévő",
            BUILT_AREA: "Beépített terület (m²)",
            DEVELOPED_AREA: "Bruttó szintterület (m²)",
            USEFUL_AREA: "Hasznos alapterület (m²)",
            LIVING_AREA: "Lakóterület (m²)",
            PROPOSED_APARTMENTS_NO: "Tervezett lakóegységek száma",
            ONE_ROOM_APARTMENT_NO: "1 szobás",
            TWO_ROOMS_APARTMENT_NO: "2 szobás",
            THREE_ROOMS_APARTMENT_NO: "3 szobás",
            FOUR_ROOMS_APARTMENT_NO: "4 szobás",
            FIVE_ROOMS_APARTMENT_NO: "5 szobás",
            OTHER_ROOMS_APARTMENT_NO: "Egyéb",
            OTHER_CHARACTERISTICS: "A tervezett építmények funkcionális kapacitásának egyéb, a fenti kategóriákba nem tartozó jellemzői",
            CL_HOUSING_TYPES: "Típusok",
        },
        PLACEHOLDERS: {
            EXTERIOR_FINISH: "típus: díszvakolat \nszín: RAL ... \nanyag:",
            EXTERIOR_WOODWORK: "típus: \nszín: RAL ... \nanyag: Fa/PVC",
            ISOLATION: "típus: kerámiacserép \nszín: RAL ... \nanyag:",
            PROPOSED_APARTMENTS_NO: "Összeg = A+B+C+D+E+F",
            ONE_ROOM_APARTMENT_NO: "A",
            TWO_ROOMS_APARTMENT_NO: "B",
            THREE_ROOMS_APARTMENT_NO: "C",
            FOUR_ROOMS_APARTMENT_NO: "D",
            FIVE_ROOMS_APARTMENT_NO: "E",
            OTHER_ROOMS_APARTMENT_NO: "F",
        },
        ENUMS: {
            BUILDING_FUNCTION: {
                EXISTING: "Meglévő",
                PROPOSED: "Tervezett",
            },
            BUILDING_FUNC_EXISTING: {
                DISSOLVED: "Elbontott",
                MAINTAINED: "Megtartott",
            },
            FUNCTION: {
                CL: "Lakóépületek CL",
                CAS: "Közigazgatási és szociális-kulturális építmények CAS",
                CIE: "Ipari és közműépítmények CIE",
                CA: "Melléképítmények CA",
            },
            CATEGORY_OF_IMPORTANCE: {
                A: "Kivételes fontosságú építmények (A)",
                B: "Kiemelt fontosságú építmények (B)",
                C: "Normál fontosságú építmények (C)",
                D: "Csekély fontosságú építmények (D)",
            },
            CL_HOUSING_TYPES: {
                PERMANENT: "Állandó",
                SEASONAL: "Idényjellegű",
                SOCIABLE: "Szociális",
                FOR_RENT: "bérbeadásra szánt",
                OF_DUTY: "szolgálati ",
                OF_NECESSITY: "szükséglakás ",
                OF_INTERVENTION: "beavatkozási ",
                OF_PROTOCOL: "protokoll",
            },
        },
        NO_BUILDINGS: "Nincs hozzáadott épület",
    },
    URBANISM_REGULATIONS_EDIT: {
        SYNC_UTR: "UTR mentése",
        SYNC_UTR_DESC: "Az UTR mentése a kérelemhez tartozó szervezet szabályozásai közé",
        CHECK_EXISTING_UTR: "UTR-jel ellenőrzése",
        CHECK_EXISTING_UTR_DESC: "Annak ellenőrzése, hogy az UTR-jel szerepel-e már a kiválasztott UAT jelenlegi szabályozásai között",
        UTR_ALREADY_EXISTS: "A(z) '{0}' UTR-jel már létezik a rendszerben.",
        UTR_KEY_IS_AVAILABLE: "A(z) '{0}' UTR-jel szabad.",
        OVERWRITE_EXISTING_UTR_WARN: "A(z) '{0}' kulcshoz már létezik szabályzat a rendszerben, a jelenlegi szabályzat a(z) '{1}' kulccsal kerül mentésre. Folytatja?",
        LIST_HEADER: "Szabályozások",
        FORM: {
            HEADER: "UTR hozzáadása",
            ADD_BTN: "Új UTR hozzáadása",
            ADD_BTN_LABEL: "Vagy",
        },
        SINGLE: "Összesen {total} UTR",
        MULTIPLE: "Összesen {total} UTR",
        MODAL: {
            ADD_HEADER: "Szabályzat hozzáadása",
            EDIT_HEADER: "Szabályzat szerkesztése",
            VIEW_HEADER: "Szabályzat megtekintése",
            SUMMARY_HEADER: "Helyi urbanisztikai szabályzatok listája",
            OPTIONS: {
                LABEL: "Válasszon egy meglévő szabályzatot, vagy adjon hozzá egy újat",
                LOAD_EXISTING_UTR: "Választás a meglévő szabályzatok közül",
                ADD_NEW_UTR: "Új UTR hozzáadása",
            },
        },
        CARD: {
            UAT: "Megyei jogú város / Város / Község",
            NAME: "Név",
            SYMBOL: "Jel",
        },
        SECTION_LABEL: "{0}. SZAKASZ",
        ARTICLE_LABEL: "{0}. cikk",
        SECTION_1: "AZ ÖVEZET JELLEGE",
        SECTION_2: "FUNKCIONÁLIS HASZNÁLAT",
        SECTION_3: "AZ ÉPÍTMÉNYEK ELHELYEZÉSÉNEK, KÖZMŰVESÍTÉSÉNEK ÉS KIALAKÍTÁSÁNAK FELTÉTELEI",
        SECTION_4: "A TELEKHASZNOSÍTÁS MAXIMÁLIS LEHETŐSÉGEI",
        SECTION_EXISTING_UTR: "UTR részletei",
        FIELDS: {
            COUNTY: "Megye",
            RU_SCOPE: "RU-cél",
            RU_SCOPES: "RU-célok",
            TERRITORIAL_ADMINISTRATIVE_UNIT: "UAT",
            TERRITORIAL_ADMINISTRATIVE_UNIT_ID: "UAT",
            UTR_ID: "Szabályozások",
            UTR: "Szabályozás",
            NAME: "UTR megnevezése",
            SYMBOL: "UTR-jel (pl. Lv)",
            IS_EXISTING_UTR: "Meglévő UTR",
            ARTICLE_1: "Általános feltételek",
            ARTICLE_2: "Szolgalmi jogok",
            ARTICLE_3: "Megengedett használatok",
            ARTICLE_4: "Feltételekkel megengedett használatok",
            ARTICLE_5: "Tiltott használatok",
            ARTICLE_6: "A parcellák jellemzői",
            ARTICLE_7: "Az épületek elhelyezése a szabályozási vonalhoz képest",
            ARTICLE_8: "Az épületek elhelyezése a parcellák oldalsó és hátsó határaihoz képest",
            ARTICLE_9: "Az épületek egymáshoz viszonyított elhelyezése ugyanazon a parcellán",
            ARTICLE_10: "Megközelítési és közlekedési feltételek",
            ARTICLE_11: "Gépjárművek parkolása",
            ARTICLE_12: "Az épületek legnagyobb magassága",
            ARTICLE_13: "Az épületek külső megjelenése",
            ARTICLE_14: "Közművesítési feltételek",
            ARTICLE_15: "Zöldterületek",
            ARTICLE_16: "Kerítések",
            ARTICLE_17: "Legnagyobb megengedett beépítettség (POT)",
            ARTICLE_18: "Legnagyobb telekhasznosítási együttható (CUT)",
            RLU_RT: "Műszaki szabályozás",
            RLU_RJ: "Jogi szabályozás",
            RLU_RE: "Gazdasági szabályozás",
            RLU_POT: "POT",
            RLU_CUT: "CUT ",
            RLU_RDA: "Frissítési rend",
        },
        PLACEHOLDERS: {},
        ENUMS: {},
    },
    APPLICATION_REGISTER: {
        TITLE: "Dokumentum iktatása",
        EMAIL: "E-mail",
        PHONE: "Telefon",
        EXTERNAL_DOCUMENT_NUMBER: "Külső dokumentum száma",
        EXTERNAL_DOCUMENT_DATE: "Külső dokumentum dátuma",
        CONNECTED_APPLICATIONS: "Kapcsolódó dokumentumok",
        DETAILS: "Részletek",
        DOCUMENTS: "Dokumentumok",
        FILE_UPLOAD_INFO_MESSAGE: "Húzza ide a fájlt, vagy kattintson a feltöltéshez",
        MAX_FILE_SIZE: "Legfeljebb 50MB",
        FILE_SIZE_ERROR: "Az egyik fájl meghaladja az 50 MB-os korlátot",
        FILE_EXTENSION_ERROR: "Ez a fájltípus nem támogatott.",
        FILE_MISSING_ERROR: "A fájl kötelező",
        REGISTER_DOCUMENT: "Dokumentum iktatása",
        REGISTER_APPLICATION: "Kérelem iktatása",
        GENERATE_DOCUMENT: "Dokumentum generálása",
        REGISTER_DOCUMENT_INFO_OF: "Új dokumentum iktatása a következő típussal:",
        REGISTER_DOCUMENT_INFO_AS: "(a *-gal jelölt mezők kötelezőek)",
        NOTIFIERS: {
            CREATED_SUCCESS_TITLE: "A dokumentum sikeresen iktatva!",
            CREATED_SUCCESS_TEXT: "A kiosztott szám: <strong>{number}</strong>",
            CONFIRM_BUTTON: "Iktatószám nyomtatása",
            CANCEL_BUTTON: "Másik dokumentum iktatása",
            CREATE_ERROR_TITLE: "Hiba történt a dokumentum iktatása során!",
            CREATE_ERROR_TEXT: "Kérjük, ellenőrizze a megadott adatokat, és próbálja újra.",
            UNFINISHED_CONNECTED_DOCUMENTS_TEXT: "Vannak folyamatban lévő kapcsolódó dokumentumok. Biztos véglegesíti ezt a dokumentumot?",
        },
        BENEFICIARY_REGISTER_TEXT: "Regisztrálás e-mail-cím vagy telefonszám alapján",
        BENEFICIARY_INVITE_TEXT: "Kedvezményezett meghívása a Ghișeul Unic platformra",
        BENEFICIARY_INVITED_SUCCESS: "A meghívó sikeresen elküldve",
        BENEFICIARY_INVITED_ERROR: "A meghívót nem sikerült elküldeni",
        BENEFICIARY_INVITE_EMAIL_ERROR: "A meghívót nem sikerült elküldeni. Ellenőrizze, hogy az e-mail-cím érvényes-e",
        PRINT_RECEIPT: {
            REGISTERED_TEXT: "Dokumentumát sikeresen iktattuk a Ghișeul Unic platformon!",
            DOCUMENT_NUMBER: "Dokumentum száma",
            REGISTRATION_DATE: "Iktatás dátuma",
            SCAN_FOR_STATUS: "Olvassa be a dokumentum állapotának megtekintéséhez",
        },
    },
    APPLICATION_CIRCULAR_MAIL: {
        TITLE: "Körlevél küldése",
        SEARCH_FOR_DEPARTMENTS: "Osztály",
        SEARCH_FOR_USERS: "Ügyintéző",
        RECIPIENT: "Címzett",
        ADDITIONAL_RECIPIENT: "További címzett",
        SUBJECT: "Tárgy",
        MESSAGE: "Üzenet",
        SEND: "Küldés",
        CANCEL: "Mégse",
        DEPARTMENT: "Osztályok",
        USERS: "Ügyintézők",
        ORGANIZATION: "Szervezet",
        SEARCH_PLACEHOLDER_DEPARTMENTS: "Keresés az osztály neve alapján",
        SEARCH_PLACEHOLDER_USERS: "Keresés az ügyintéző neve alapján",
        SEARCH_PLACEHOLDER_ORGANIZATIONS: "Keresés a szervezet neve alapján",
        ATTACHMENTS: "Mellékletek",
        MAX_FILE_SIZE: "Legfeljebb 50MB",
        FILE_UPLOAD_INFO_MESSAGE: "Húzza ide a fájlt, vagy kattintson a feltöltéshez (pdf, png, jpg, jpeg)",
        FILE_UPLOAD_ERROR: "Az egyik fájl meghaladja az 50 MB-os korlátot",
        FILE_MISSING_ERROR: "A fájl kötelező",
        SEND_TO_ALL_ORGANIZATIONS: "Küldés a teljes szervezetnek",
        ADDITIONAL_RECIPIENT_PLACEHOLDER: "Adja meg az e-mail-címeket vesszővel elválasztva",
        SUCCESS_TITLE: "Sikeres küldés",
        SUCCESS_TEXT: "A körlevél sikeresen elküldve!",
        ERROR_TITLE: "Kérjük, ellenőrizze a megadott adatokat, és próbálja újra.",
        ERROR_TEXT: "Legalább egy címzett megadása kötelező.",
    },
    PUBLIC_APPLICATION: {
        STATUS: "Dokumentum állapota",
        APPLICATION_NAME: "Iktatott dokumentum típusa",
        IDENTIFICATION_NUMBER: "Iktatószám",
        DATE: "Iktatás dátuma",
        FUNCTION: "Beosztás",
        DEPARTMENT: "Osztály",
        ALLOCATED_DOCUMENT_SERIES: "Lezárási szám",
        ISSUED_DATE: "Lezárás dátuma",
        NOT_FOUND: "A kérelem nem található",
        TECHNICAL_ERROR: "Technikai hiba",
        INFO: "A kérelem lezárása után megtekintheti és letöltheti a kérelemhez tartozó dokumentumokat.",
        PHONE_LABEL: "Kedvezményezett/kérelmező telefonszáma",
        PHONE_PLACEHOLDER: "Adja meg a telefonszámot",
        SEND_SMS: "SMS küldése",
        PHONE_ERROR_MANDATORY: "A telefonszám megadása kötelező",
        PHONE_ERROR: "Kérjük, adjon meg egy érvényes telefonszámot",
        PHONE_ERROR_PHONE_BLOCKED: "Mivel 5 alkalommal hibás kódot adott meg, a telefonszáma 5 percre zárolásra került",
        PHONE_ERROR_PHONE_NUMBER_NOT_ALLOCATED: "A megadott telefonszámnak a kérelmezőhöz vagy valamelyik kedvezményezetthez kell tartoznia",
        SMS_LABEL: "SMS-kód ellenőrzése",
        SMS_PLACEHOLDER: "Adja meg az SMS-ben kapott kódot",
        VALIDATE_CODE: "Kód ellenőrzése",
        CODE_ERROR_MANDATORY: "Az SMS-ben kapott kód megadása kötelező",
        CODE_ERROR: "Érvénytelen kód",
        CODE_ERROR_PHONE_BLOCKED: "Mivel 5 alkalommal hibás kódot adott meg, a telefonszáma 5 percre zárolásra került",
        CODE_ERROR_INVALID_CODE: "A megadott kód hibás",
        CODE_ERROR_CODE_EXPIRED: "A kód lejárt. Kérjük, kezdje újra a folyamatot",
        CODE_ERROR_PHONE_NUMBER_NOT_ALLOCATED: "A megadott telefonszámnak a kérelmezőhöz vagy valamelyik kedvezményezetthez kell tartoznia",
        CODE_SENT_TO: "A kódot elküldtük a következő telefonszámra: ",
        IF_NUMBER_WRONG: ". Ha a szám hibás vagy a kód lejárt.",
        RETRY: "Újrapróbálás",
        APPLICATIONS_DOCUMENTS: "A kérelemhez tartozó dokumentumok",
        PUBLIC_DOCUMENTS: "Nyilvános iratok",
        DOWNLOAD_ALL: "Összes dokumentum letöltése",
        TIME_REMAINING: "Még {time} áll rendelkezésére a dokumentumok megtekintésére vagy letöltésére",
    },
    EFACTURA: {
        AUTHORIZE: "Engedélyezés",
        SYNC_NOW: "Szinkronizálás most",
        PROCESS_AGAIN: "Újrafeldolgozás",
        AUTH_SUCCESS: "Sikeres ANAF-engedélyezés",
        AUTH_FAILED: "Sikertelen engedélyezés",
        AUTH_NO_CIF: "A szervezethez nincs CIF beállítva. Adjon meg egy CIF-et, és próbálja újra.",
        TOKEN_ACTIVE_EXPIRES: "Aktív token, lejárat: {expires}",
        SYNC_STATUS: {
            NOT_SYNCED: "Az adatok nincsenek szinkronizálva",
            LAST_SYNC: "Utolsó szinkronizálás: {date}",
        },
        EXPIRES: {
            UNKNOWN: "ismeretlen",
            EXPIRED: "lejárt",
            IN: "{duration} múlva",
            AND: "és",
            SECONDS: "{n} másodperc | {n} másodperc | {n} másodperc",
            MINUTES: "{n} perc | {n} perc | {n} perc",
            HOURS: "{n} óra | {n} óra | {n} óra",
            DAYS: "{n} nap | {n} nap | {n} nap",
            MONTHS: "{n} hónap | {n} hónap | {n} hónap",
        },
    },
    INVOICES: {
        FIELDS: {
            DETAILS: "Számla részletei",
            CREATIONDATE: "Kiállítás dátuma",
            INVOICE_ID: "Számla kódja",
            REQUEST_ID: "Kérés kódja",
            STATUS: "Állapot",
            NUMAR_FACTURA: "Számlaszám",
            FURNIZOR: "Szállító",
            VALOARE: "Érték",
            IDENTIFICATION_NUMBER: "Iktatószám",
            APPLICATION_DATE: "Iktatás dátuma",
            REFERINTA_CONTRACT: "Szerződésszám",
            CIF_EMITENT: "Kibocsátó CIF-je",
            ID_INCARCARE: "Feltöltési ID",
        },
        PLACEHOLDERS: {
            NUMAR_FACTURA: "Számlaszám",
            STATUS: "Állapot",
            FURNIZOR: "Szállító",
            IDENTIFICATION_NUMBER: "Iktatószám",
            APPLICATION_DATE: "Iktatás dátuma",
            REFERINTA_CONTRACT: "Szerződésszám",
            CIF_EMITENT: "Kibocsátó CIF-je",
            ID_INCARCARE: "Feltöltési ID",
        },
        ENUMS: {
            STATUS: {
                NEW: "Új",
                PROCESSED: "Feldolgozva",
                REPROCESSING: "Újrafeldolgozásra vár",
                PROCESSING: "Feldolgozás alatt",
                FAILED: "Hibás",
            },
        },
    },
    PCUEL: {
        INFO_MODAL_TEXT: "Fiókja szinkronizálásra kerül a PCUEL platformmal. Így a Ghișeul Unic felületén kiállított iratokat automatikusan megtalálja a PCUEL platformon.",
        ALREADY_SYNCED_TEXT: "Fiókja már szinkronizálva van a PCUEL platformmal.",
        DIFFERENT_ACCOUNT_TEXT: "Profilja már egy másik PCUEL-fiókkal van szinkronizálva. A társított fiók módosításához kérjük, forduljon a technikai támogatáshoz.",
        CONFLICT_TEXT: "A megadott PCUEL-fiók már egy másik profilhoz van társítva. Kérjük, forduljon a technikai támogatáshoz.",
        UNLINK_ERROR: "Hiba történt a fiók PCUEL-szinkronizálásának megszüntetésekor",
        UNLINK_SUCCESS: "A szinkronizálás sikeresen megszüntetve",
        UNLINK_CONFIRMATION_MESSAGE: "Biztos deaktiválni szeretné a PCUEL-szinkronizálást?",
    },
};

module.exports = { locale };
